/* DO NOT EDIT!
   This file is generated from: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abreact/client/localeProperties/abreact_en.properties
   To regenerate after edits to the above file, invoke the module's package.json task: locale:regen:maven
   Also helpful: https://confluence.abinitio.com/display/FED/Localization+for+Developers
*/// eslint-disable
import{AbWebServices}from"abweb/service/AbWebServices";/**
 * <pre>
 * AB_DIAGRAM_HIDE_OVERVIEW=Hide overview
 * </pre>
 */export function ab_diagram_hide_overview(){return AbWebServices.i18n.getMessage("abreact","AB_DIAGRAM_HIDE_OVERVIEW");}/**
 * <pre>
 * AB_DIAGRAM_SHOW_OVERVIEW=Show overview
 * </pre>
 */export function ab_diagram_show_overview(){return AbWebServices.i18n.getMessage("abreact","AB_DIAGRAM_SHOW_OVERVIEW");}/**
 * <pre>
 * AB_DIAGRAM_ZOOM_FIT_GRAPH=Fit graph
 * </pre>
 */export function ab_diagram_zoom_fit_graph(){return AbWebServices.i18n.getMessage("abreact","AB_DIAGRAM_ZOOM_FIT_GRAPH");}/**
 * <pre>
 * AB_DIAGRAM_ZOOM_FIT_SELECTION=Fit selection
 * </pre>
 */export function ab_diagram_zoom_fit_selection(){return AbWebServices.i18n.getMessage("abreact","AB_DIAGRAM_ZOOM_FIT_SELECTION");}/**
 * <pre>
 * AB_DIAGRAM_ZOOM_IN=Zoom in
 * </pre>
 */export function ab_diagram_zoom_in(){return AbWebServices.i18n.getMessage("abreact","AB_DIAGRAM_ZOOM_IN");}/**
 * <pre>
 * AB_DIAGRAM_ZOOM_OUT=Zoom out
 * </pre>
 */export function ab_diagram_zoom_out(){return AbWebServices.i18n.getMessage("abreact","AB_DIAGRAM_ZOOM_OUT");}/**
 * <pre>
 * AbAutoComplete.searchNotAvailable=Search not available
 * </pre>
 */export function abAutoComplete_searchNotAvailable(){return AbWebServices.i18n.getMessage("abreact","AbAutoComplete.searchNotAvailable");}/**
 * <pre>
 * AbBanner.buttons.abInitioLogoAltText=Ab Initio
 * </pre>
 */export function abBanner_buttons_abInitioLogoAltText(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.abInitioLogoAltText");}/**
 * <pre>
 * AbBanner.buttons.actionsMenuButtonLabel=Actions
 * </pre>
 */export function abBanner_buttons_actionsMenuButtonLabel(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.actionsMenuButtonLabel");}/**
 * <pre>
 * AbBanner.buttons.helpLibrary=Ab Initio Help Library
 * </pre>
 */export function abBanner_buttons_helpLibrary(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.helpLibrary");}/**
 * <pre>
 * AbBanner.buttons.myIssues=My Issues
 * </pre>
 */export function abBanner_buttons_myIssues(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.myIssues");}/**
 * <pre>
 * AbBanner.buttons.navigationMenu=Navigation Menu
 * </pre>
 */export function abBanner_buttons_navigationMenu(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.navigationMenu");}/**
 * <pre>
 * AbBanner.buttons.otherDebuggingTools=Other Debugging Tools
 * </pre>
 */export function abBanner_buttons_otherDebuggingTools(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.otherDebuggingTools");}/**
 * <pre>
 * # {0} is the name of the product whose help we are linking to. "Agentic Data Service" as an example
 * AbBanner.buttons.productHelp={0} Help
 * </pre>
 */export function abBanner_buttons_productHelp(arg0){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.productHelp",arg0);}/**
 * <pre>
 * AbBanner.buttons.productMenu=Product Menu
 * </pre>
 */export function abBanner_buttons_productMenu(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.productMenu");}/**
 * <pre>
 * AbBanner.buttons.recentlyViewed=Recently Viewed
 * </pre>
 */export function abBanner_buttons_recentlyViewed(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.recentlyViewed");}/**
 * <pre>
 * AbBanner.buttons.whatsNew=What's New
 * </pre>
 */export function abBanner_buttons_whatsNew(){return AbWebServices.i18n.getMessage("abreact","AbBanner.buttons.whatsNew");}/**
 * <pre>
 * AbBooleanLogicTree.NA=n/a
 * </pre>
 */export function abBooleanLogicTree_na(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.NA");}/**
 * <pre>
 * AbBooleanLogicTree.accessibility.conditionGroupLabel=Group {0}
 * </pre>
 */export function abBooleanLogicTree_accessibility_conditionGroupLabel(arg0){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.accessibility.conditionGroupLabel",arg0);}/**
 * <pre>
 * AbBooleanLogicTree.accessibility.formLabel=Conditional Logic Tree
 * </pre>
 */export function abBooleanLogicTree_accessibility_formLabel(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.accessibility.formLabel");}/**
 * <pre>
 * AbBooleanLogicTree.accessibility.singleConditionLabel=Condition {0}
 * </pre>
 */export function abBooleanLogicTree_accessibility_singleConditionLabel(arg0){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.accessibility.singleConditionLabel",arg0);}/**
 * <pre>
 * AbBooleanLogicTree.addAction=+ Action
 * </pre>
 */export function abBooleanLogicTree_addAction(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.addAction");}/**
 * <pre>
 * # Add a group of conditions that will be evaluated using the AND operator (all conditions are expected to be true)
 * AbBooleanLogicTree.addAndGroup=+ AND Group
 * </pre>
 */export function abBooleanLogicTree_addAndGroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.addAndGroup");}/**
 * <pre>
 * AbBooleanLogicTree.addCondition=+ Condition
 * </pre>
 */export function abBooleanLogicTree_addCondition(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.addCondition");}/**
 * <pre>
 * # Add a group of conditions that will be evaluated using the OR operator (any condition is expected to be true)
 * AbBooleanLogicTree.addOrGroup=+ OR Group
 * </pre>
 */export function abBooleanLogicTree_addOrGroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.addOrGroup");}/**
 * <pre>
 * # Add a group of conditions within another group
 * AbBooleanLogicTree.addSubgroup=+ Subgroup
 * </pre>
 */export function abBooleanLogicTree_addSubgroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.addSubgroup");}/**
 * <pre>
 * ## Used to say that every one of a set of conditions must be true
 * AbBooleanLogicTree.allOf=All of
 * </pre>
 */export function abBooleanLogicTree_allOf(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.allOf");}/**
 * <pre>
 * ## Used to say that any one of a set of conditions must be true
 * AbBooleanLogicTree.anyOf=Any of
 * </pre>
 */export function abBooleanLogicTree_anyOf(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.anyOf");}/**
 * <pre>
 * ## Used to change a set of conditions being joined together with ORs (any must be true) to AND (all must be true)
 * AbBooleanLogicTree.columnMenu.changeToAnd=Change to AND
 * </pre>
 */export function abBooleanLogicTree_columnMenu_changeToAnd(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.columnMenu.changeToAnd");}/**
 * <pre>
 * ## Used to change a set of conditions being joined together with ANDs (all must be true) to OR (any must be true)
 * AbBooleanLogicTree.columnMenu.changeToOr=Change to OR
 * </pre>
 */export function abBooleanLogicTree_columnMenu_changeToOr(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.columnMenu.changeToOr");}/**
 * <pre>
 * AbBooleanLogicTree.false=false
 * </pre>
 */export function abBooleanLogicTree_false(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.false");}/**
 * <pre>
 * AbBooleanLogicTree.groupMenu.and=AND
 * </pre>
 */export function abBooleanLogicTree_groupMenu_and(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.groupMenu.and");}/**
 * <pre>
 * AbBooleanLogicTree.groupMenu.or=OR
 * </pre>
 */export function abBooleanLogicTree_groupMenu_or(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.groupMenu.or");}/**
 * <pre>
 * AbBooleanLogicTree.menu.convertToSubgroup=Convert to Subgroup
 * </pre>
 */export function abBooleanLogicTree_menu_convertToSubgroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.convertToSubgroup");}/**
 * <pre>
 * AbBooleanLogicTree.menu.deleteAction=Delete Action
 * </pre>
 */export function abBooleanLogicTree_menu_deleteAction(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.deleteAction");}/**
 * <pre>
 * AbBooleanLogicTree.menu.deleteAll=Delete All
 * </pre>
 */export function abBooleanLogicTree_menu_deleteAll(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.deleteAll");}/**
 * <pre>
 * AbBooleanLogicTree.menu.deleteCondition=Delete Condition
 * </pre>
 */export function abBooleanLogicTree_menu_deleteCondition(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.deleteCondition");}/**
 * <pre>
 * AbBooleanLogicTree.menu.deleteSubgroup=Delete Subgroup
 * </pre>
 */export function abBooleanLogicTree_menu_deleteSubgroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.deleteSubgroup");}/**
 * <pre>
 * AbBooleanLogicTree.menu.disableAllConditions=Disable All Conditions
 * </pre>
 */export function abBooleanLogicTree_menu_disableAllConditions(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.disableAllConditions");}/**
 * <pre>
 * AbBooleanLogicTree.menu.disableCondition=Disable Condition
 * </pre>
 */export function abBooleanLogicTree_menu_disableCondition(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.disableCondition");}/**
 * <pre>
 * AbBooleanLogicTree.menu.duplicate=Duplicate
 * </pre>
 */export function abBooleanLogicTree_menu_duplicate(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.duplicate");}/**
 * <pre>
 * AbBooleanLogicTree.menu.enableAllConditions=Enable All Conditions
 * </pre>
 */export function abBooleanLogicTree_menu_enableAllConditions(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.enableAllConditions");}/**
 * <pre>
 * AbBooleanLogicTree.menu.enableCondition=Enable Condition
 * </pre>
 */export function abBooleanLogicTree_menu_enableCondition(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.enableCondition");}/**
 * <pre>
 * AbBooleanLogicTree.menu.groupWithNextAction=Make group with next action
 * </pre>
 */export function abBooleanLogicTree_menu_groupWithNextAction(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.groupWithNextAction");}/**
 * <pre>
 * AbBooleanLogicTree.menu.groupWithNextCondition=Make group with next condition
 * </pre>
 */export function abBooleanLogicTree_menu_groupWithNextCondition(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.groupWithNextCondition");}/**
 * <pre>
 * AbBooleanLogicTree.menu.insertAbove=Insert Above
 * </pre>
 */export function abBooleanLogicTree_menu_insertAbove(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.insertAbove");}/**
 * <pre>
 * AbBooleanLogicTree.menu.insertBelow=Insert Below
 * </pre>
 */export function abBooleanLogicTree_menu_insertBelow(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.insertBelow");}/**
 * <pre>
 * AbBooleanLogicTree.menu.makeIntoGroup=Make into group
 * </pre>
 */export function abBooleanLogicTree_menu_makeIntoGroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.makeIntoGroup");}/**
 * <pre>
 * AbBooleanLogicTree.menu.moveDown=Move Down
 * </pre>
 */export function abBooleanLogicTree_menu_moveDown(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.moveDown");}/**
 * <pre>
 * AbBooleanLogicTree.menu.moveUp=Move Up
 * </pre>
 */export function abBooleanLogicTree_menu_moveUp(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.moveUp");}/**
 * <pre>
 * AbBooleanLogicTree.menu.outdentSubgroup=Outdent Subgroup
 * </pre>
 */export function abBooleanLogicTree_menu_outdentSubgroup(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.menu.outdentSubgroup");}/**
 * <pre>
 * AbBooleanLogicTree.runtimeErr.tooltip=The condition contains a runtime error
 * </pre>
 */export function abBooleanLogicTree_runtimeErr_tooltip(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.runtimeErr.tooltip");}/**
 * <pre>
 * AbBooleanLogicTree.runtimeErr.tooltipMessage=The condition contains the following runtime error '{0}'
 * </pre>
 */export function abBooleanLogicTree_runtimeErr_tooltipMessage(arg0){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.runtimeErr.tooltipMessage",arg0);}/**
 * <pre>
 * AbBooleanLogicTree.true=true
 * </pre>
 */export function abBooleanLogicTree_true(){return AbWebServices.i18n.getMessage("abreact","AbBooleanLogicTree.true");}/**
 * <pre>
 * # For AbCancelButton, a simple encapsulation that can be used in various layouts, dialogs, cell editors
 * AbCancelButton.label=Cancel
 * </pre>
 */export function abCancelButton_label(){return AbWebServices.i18n.getMessage("abreact","AbCancelButton.label");}/**
 * <pre>
 * AbExpandableList.buttons.nMore=Show {0} More…
 * </pre>
 */export function abExpandableList_buttons_nMore(arg0){return AbWebServices.i18n.getMessage("abreact","AbExpandableList.buttons.nMore",arg0);}/**
 * <pre>
 * AbExpandableList.buttons.showLess=Show Fewer
 * </pre>
 */export function abExpandableList_buttons_showLess(){return AbWebServices.i18n.getMessage("abreact","AbExpandableList.buttons.showLess");}/**
 * <pre>
 * AbGraphStatusDisplay.statusLabel=Server Status:
 * </pre>
 */export function abGraphStatusDisplay_statusLabel(){return AbWebServices.i18n.getMessage("abreact","AbGraphStatusDisplay.statusLabel");}/**
 * <pre>
 * # For AbOkButton, a simple encapsulation that can be used in various layouts, dialogs, cell editors
 * AbOkButton.label=OK
 * </pre>
 */export function abOkButton_label(){return AbWebServices.i18n.getMessage("abreact","AbOkButton.label");}/**
 * <pre>
 * # Other navigation links inside side navigation menu
 * abApplicationSideNav.otherMenuButton.label=More
 * </pre>
 */export function abApplicationSideNav_otherMenuButton_label(){return AbWebServices.i18n.getMessage("abreact","abApplicationSideNav.otherMenuButton.label");}/**
 * <pre>
 * abButtonBarWithMoreDropdownWhenOverflow.more=More…
 * </pre>
 */export function abButtonBarWithMoreDropdownWhenOverflow_more(){return AbWebServices.i18n.getMessage("abreact","abButtonBarWithMoreDropdownWhenOverflow.more");}/**
 * <pre>
 * # {0} is the text displayed on the chiclet. It is the thing that will be removed. This is the aria-label for screen
 * # readers, so it should be short.
 * abChiclet.remove.button.ariaLabel=Remove {0}
 * </pre>
 */export function abChiclet_remove_button_ariaLabel(arg0){return AbWebServices.i18n.getMessage("abreact","abChiclet.remove.button.ariaLabel",arg0);}/**
 * <pre>
 * abComment.cancel=Cancel
 * </pre>
 */export function abComment_cancel(){return AbWebServices.i18n.getMessage("abreact","abComment.cancel");}/**
 * <pre>
 * abComment.comment=Comment
 * </pre>
 */export function abComment_comment(){return AbWebServices.i18n.getMessage("abreact","abComment.comment");}/**
 * <pre>
 * abComment.delete=Delete
 * </pre>
 */export function abComment_delete(){return AbWebServices.i18n.getMessage("abreact","abComment.delete");}/**
 * <pre>
 * abComment.deletedText=Comment deleted by User
 * </pre>
 */export function abComment_deletedText(){return AbWebServices.i18n.getMessage("abreact","abComment.deletedText");}/**
 * <pre>
 * abComment.edit=Edit
 * </pre>
 */export function abComment_edit(){return AbWebServices.i18n.getMessage("abreact","abComment.edit");}/**
 * <pre>
 * abComment.edited=(Edited)
 * </pre>
 */export function abComment_edited(){return AbWebServices.i18n.getMessage("abreact","abComment.edited");}/**
 * <pre>
 * abComment.like=Like
 * </pre>
 */export function abComment_like(){return AbWebServices.i18n.getMessage("abreact","abComment.like");}/**
 * <pre>
 * abComment.pluralLike={0} Likes
 * </pre>
 */export function abComment_pluralLike(arg0){return AbWebServices.i18n.getMessage("abreact","abComment.pluralLike",arg0);}/**
 * <pre>
 * abComment.renderNoCommentMessage=No comments
 * </pre>
 */export function abComment_renderNoCommentMessage(){return AbWebServices.i18n.getMessage("abreact","abComment.renderNoCommentMessage");}/**
 * <pre>
 * abComment.reopen=Reopen
 * </pre>
 */export function abComment_reopen(){return AbWebServices.i18n.getMessage("abreact","abComment.reopen");}/**
 * <pre>
 * abComment.reply=Reply
 * </pre>
 */export function abComment_reply(){return AbWebServices.i18n.getMessage("abreact","abComment.reply");}/**
 * <pre>
 * abComment.resolve=Resolve
 * </pre>
 */export function abComment_resolve(){return AbWebServices.i18n.getMessage("abreact","abComment.resolve");}/**
 * <pre>
 * abComment.resolved=Resolved
 * </pre>
 */export function abComment_resolved(){return AbWebServices.i18n.getMessage("abreact","abComment.resolved");}/**
 * <pre>
 * abComment.save=Save
 * </pre>
 */export function abComment_save(){return AbWebServices.i18n.getMessage("abreact","abComment.save");}/**
 * <pre>
 * abComment.showResolvedComments=Show resolved comments
 * </pre>
 */export function abComment_showResolvedComments(){return AbWebServices.i18n.getMessage("abreact","abComment.showResolvedComments");}/**
 * <pre>
 * abComment.showWorkflowActivity=Show actions
 * </pre>
 */export function abComment_showWorkflowActivity(){return AbWebServices.i18n.getMessage("abreact","abComment.showWorkflowActivity");}/**
 * <pre>
 * abComment.singularLike={0} Like
 * </pre>
 */export function abComment_singularLike(arg0){return AbWebServices.i18n.getMessage("abreact","abComment.singularLike",arg0);}/**
 * <pre>
 * abComment.sortPreferencePopularity=Most Popular
 * </pre>
 */export function abComment_sortPreferencePopularity(){return AbWebServices.i18n.getMessage("abreact","abComment.sortPreferencePopularity");}/**
 * <pre>
 * abComment.sortPreferenceRecent=Newest
 * </pre>
 */export function abComment_sortPreferenceRecent(){return AbWebServices.i18n.getMessage("abreact","abComment.sortPreferenceRecent");}/**
 * <pre>
 * abComment.submit=Submit
 * </pre>
 */export function abComment_submit(){return AbWebServices.i18n.getMessage("abreact","abComment.submit");}/**
 * <pre>
 * abComment.unlike=Unlike
 * </pre>
 */export function abComment_unlike(){return AbWebServices.i18n.getMessage("abreact","abComment.unlike");}/**
 * <pre>
 * abComment.writeAComment=Write a comment
 * </pre>
 */export function abComment_writeAComment(){return AbWebServices.i18n.getMessage("abreact","abComment.writeAComment");}/**
 * <pre>
 * abCopyButton.copied=Copied!
 * </pre>
 */export function abCopyButton_copied(){return AbWebServices.i18n.getMessage("abreact","abCopyButton.copied");}/**
 * <pre>
 * abCopyButton.label=Copy to clipboard
 * </pre>
 */export function abCopyButton_label(){return AbWebServices.i18n.getMessage("abreact","abCopyButton.label");}/**
 * <pre>
 * abCopyInfoButton.tooltip=Copy the contents of this dialog to the clipboard
 * </pre>
 */export function abCopyInfoButton_tooltip(){return AbWebServices.i18n.getMessage("abreact","abCopyInfoButton.tooltip");}/**
 * <pre>
 * abFileInput.browseFolderLinkLabel=browse for folder
 * </pre>
 */export function abFileInput_browseFolderLinkLabel(){return AbWebServices.i18n.getMessage("abreact","abFileInput.browseFolderLinkLabel");}/**
 * <pre>
 * abFileInput.browseLinkLabel=browse
 * </pre>
 */export function abFileInput_browseLinkLabel(){return AbWebServices.i18n.getMessage("abreact","abFileInput.browseLinkLabel");}/**
 * <pre>
 * abFileInput.dropZonePrompt=To attach files, drag and drop them here, or
 * </pre>
 */export function abFileInput_dropZonePrompt(){return AbWebServices.i18n.getMessage("abreact","abFileInput.dropZonePrompt");}/**
 * <pre>
 * abFileInput.dropZonePromptSingular=To attach a file, drag and drop it here, or
 * </pre>
 */export function abFileInput_dropZonePromptSingular(){return AbWebServices.i18n.getMessage("abreact","abFileInput.dropZonePromptSingular");}/**
 * <pre>
 * abFileInput.readingAndCompressingFiles=Reading and compressing files
 * </pre>
 */export function abFileInput_readingAndCompressingFiles(){return AbWebServices.i18n.getMessage("abreact","abFileInput.readingAndCompressingFiles");}/**
 * <pre>
 * abFilterGroup.or=or
 * </pre>
 */export function abFilterGroup_or(){return AbWebServices.i18n.getMessage("abreact","abFilterGroup.or");}/**
 * <pre>
 * abFilterListBox.no.matches.text=Nothing matches the filter text
 * </pre>
 */export function abFilterListBox_no_matches_text(){return AbWebServices.i18n.getMessage("abreact","abFilterListBox.no.matches.text");}/**
 * <pre>
 * abForumAccountNotice.paragraphOne=To access the test drives and documentation, you need an Ab&nbsp;Initio Forum account.
 * </pre>
 */export function abForumAccountNotice_paragraphOne(){return AbWebServices.i18n.getMessage("abreact","abForumAccountNotice.paragraphOne");}/**
 * <pre>
 * abForumAccountNotice.paragraphTwo=Click "OK" to log in or register for a new account.
 * </pre>
 */export function abForumAccountNotice_paragraphTwo(){return AbWebServices.i18n.getMessage("abreact","abForumAccountNotice.paragraphTwo");}/**
 * <pre>
 * abForumAccountNotice.title=Ab&nbsp;Initio Test&nbsp;Drives and Documentation
 * </pre>
 */export function abForumAccountNotice_title(){return AbWebServices.i18n.getMessage("abreact","abForumAccountNotice.title");}/**
 * <pre>
 * abGraphRenderer.fit=Fit
 * </pre>
 */export function abGraphRenderer_fit(){return AbWebServices.i18n.getMessage("abreact","abGraphRenderer.fit");}/**
 * <pre>
 * abGraphRenderer.toggleThumbnail=Toggle canvas overview
 * </pre>
 */export function abGraphRenderer_toggleThumbnail(){return AbWebServices.i18n.getMessage("abreact","abGraphRenderer.toggleThumbnail");}/**
 * <pre>
 * abGraphRenderer.zoomIn=Zoom in
 * </pre>
 */export function abGraphRenderer_zoomIn(){return AbWebServices.i18n.getMessage("abreact","abGraphRenderer.zoomIn");}/**
 * <pre>
 * abGraphRenderer.zoomOut=Zoom out
 * </pre>
 */export function abGraphRenderer_zoomOut(){return AbWebServices.i18n.getMessage("abreact","abGraphRenderer.zoomOut");}/**
 * <pre>
 * abGraphRenderer.zoomToFit=Zoom to fit
 * </pre>
 */export function abGraphRenderer_zoomToFit(){return AbWebServices.i18n.getMessage("abreact","abGraphRenderer.zoomToFit");}/**
 * <pre>
 * abHttpErrorPage.accessDenied.message=You do not have permission to access this page. Please contact your administrator.
 * </pre>
 */export function abHttpErrorPage_accessDenied_message(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.accessDenied.message");}/**
 * <pre>
 * abHttpErrorPage.accessDenied.title=Access Denied
 * </pre>
 */export function abHttpErrorPage_accessDenied_title(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.accessDenied.title");}/**
 * <pre>
 * abHttpErrorPage.pageNotFound.bodyLabel=Go to Home
 * </pre>
 */export function abHttpErrorPage_pageNotFound_bodyLabel(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.pageNotFound.bodyLabel");}/**
 * <pre>
 * abHttpErrorPage.pageNotFound.message=The requested page cannot be found.
Please check the URL or go to another page.
 * </pre>
 */export function abHttpErrorPage_pageNotFound_message(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.pageNotFound.message");}/**
 * <pre>
 * abHttpErrorPage.pageNotFound.title=Page Not Found
 * </pre>
 */export function abHttpErrorPage_pageNotFound_title(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.pageNotFound.title");}/**
 * <pre>
 * abHttpErrorPage.serviceUnavailable.message=The server is temporarily unable to handle your request. Try refreshing the browser or contacting your administrator.
 * </pre>
 */export function abHttpErrorPage_serviceUnavailable_message(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.serviceUnavailable.message");}/**
 * <pre>
 * abHttpErrorPage.serviceUnavailable.title=Service Unavailable
 * </pre>
 */export function abHttpErrorPage_serviceUnavailable_title(){return AbWebServices.i18n.getMessage("abreact","abHttpErrorPage.serviceUnavailable.title");}/**
 * <pre>
 * abInputArgs.addFilter=Add Filter...
 * </pre>
 */export function abInputArgs_addFilter(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.addFilter");}/**
 * <pre>
 * abInputArgs.applyFilters=Apply
 * </pre>
 */export function abInputArgs_applyFilters(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.applyFilters");}/**
 * <pre>
 * abInputArgs.applyGroupFiltersTooltip=Apply filters in this group
 * </pre>
 */export function abInputArgs_applyGroupFiltersTooltip(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.applyGroupFiltersTooltip");}/**
 * <pre>
 * abInputArgs.argIsRequired=This argument is required
 * </pre>
 */export function abInputArgs_argIsRequired(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.argIsRequired");}/**
 * <pre>
 * abInputArgs.arguments=Arguments
 * </pre>
 */export function abInputArgs_arguments(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.arguments");}/**
 * <pre>
 * abInputArgs.bool.false=False
 * </pre>
 */export function abInputArgs_bool_false(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.bool.false");}/**
 * <pre>
 * abInputArgs.bool.true=True
 * </pre>
 */export function abInputArgs_bool_true(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.bool.true");}/**
 * <pre>
 * abInputArgs.bool.undefined=Undefined
 * </pre>
 */export function abInputArgs_bool_undefined(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.bool.undefined");}/**
 * <pre>
 * abInputArgs.cancelFilters=Cancel
 * </pre>
 */export function abInputArgs_cancelFilters(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.cancelFilters");}/**
 * <pre>
 * abInputArgs.cancelFiltersTooltip=Cancel all changes that have not been applied yet.
 * </pre>
 */export function abInputArgs_cancelFiltersTooltip(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.cancelFiltersTooltip");}/**
 * <pre>
 * abInputArgs.cancelGroupFiltersTooltip=Cancel all changes in this group that have not been applied yet.
 * </pre>
 */export function abInputArgs_cancelGroupFiltersTooltip(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.cancelGroupFiltersTooltip");}/**
 * <pre>
 * abInputArgs.clearFilters=Clear
 * </pre>
 */export function abInputArgs_clearFilters(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.clearFilters");}/**
 * <pre>
 * abInputArgs.clearFiltersTooltip=Remove all filters
 * </pre>
 */export function abInputArgs_clearFiltersTooltip(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.clearFiltersTooltip");}/**
 * <pre>
 * abInputArgs.columnFiltersSectionName=Column Filters
 * </pre>
 */export function abInputArgs_columnFiltersSectionName(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.columnFiltersSectionName");}/**
 * <pre>
 * abInputArgs.dateMustBeLater=This date must be later than the first date
 * </pre>
 */export function abInputArgs_dateMustBeLater(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateMustBeLater");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.days=days
 * </pre>
 */export function abInputArgs_dateTimeUnit_days(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.days");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.hours=hours
 * </pre>
 */export function abInputArgs_dateTimeUnit_hours(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.hours");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.milliseconds=milliseconds
 * </pre>
 */export function abInputArgs_dateTimeUnit_milliseconds(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.milliseconds");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.minutes=minutes
 * </pre>
 */export function abInputArgs_dateTimeUnit_minutes(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.minutes");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.months=months
 * </pre>
 */export function abInputArgs_dateTimeUnit_months(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.months");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.seconds=seconds
 * </pre>
 */export function abInputArgs_dateTimeUnit_seconds(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.seconds");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.days={0} days
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_days(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.days",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.hours={0} hours
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_hours(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.hours",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.milliseconds={0} milliseconds
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_milliseconds(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.milliseconds",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.minutes={0} minutes
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_minutes(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.minutes",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.months={0} months
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_months(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.months",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.seconds={0} seconds
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_seconds(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.seconds",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.weeks={0} weeks
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_weeks(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.weeks",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.value.in.years={0} years
 * </pre>
 */export function abInputArgs_dateTimeUnit_value_in_years(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.value.in.years",arg0);}/**
 * <pre>
 * abInputArgs.dateTimeUnit.weeks=weeks
 * </pre>
 */export function abInputArgs_dateTimeUnit_weeks(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.weeks");}/**
 * <pre>
 * abInputArgs.dateTimeUnit.years=years
 * </pre>
 */export function abInputArgs_dateTimeUnit_years(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.dateTimeUnit.years");}/**
 * <pre>
 * abInputArgs.hideAllOptionalArgs=Hide all
 * </pre>
 */export function abInputArgs_hideAllOptionalArgs(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.hideAllOptionalArgs");}/**
 * <pre>
 * abInputArgs.invalidArgs=Input arguments are invalid
 * </pre>
 */export function abInputArgs_invalidArgs(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.invalidArgs");}/**
 * <pre>
 * #{0} - value
 * abInputArgs.numberMustBeGreaterOrEqualTo=This number must be greater or equal to {0}
 * </pre>
 */export function abInputArgs_numberMustBeGreaterOrEqualTo(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.numberMustBeGreaterOrEqualTo",arg0);}/**
 * <pre>
 * abInputArgs.numberMustBeGreaterThanFirst=This number must be greater than the first number
 * </pre>
 */export function abInputArgs_numberMustBeGreaterThanFirst(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.numberMustBeGreaterThanFirst");}/**
 * <pre>
 * #{0} - value
 * abInputArgs.numberMustBeLessOrEqualTo=This number must be less or equal to  {0}
 * </pre>
 */export function abInputArgs_numberMustBeLessOrEqualTo(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.numberMustBeLessOrEqualTo",arg0);}/**
 * <pre>
 * abInputArgs.op.caseSensitive=case-sensitive
 * </pre>
 */export function abInputArgs_op_caseSensitive(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.caseSensitive");}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.contains=contains {0}
 * </pre>
 */export function abInputArgs_op_contains(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.contains",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.doesNotMatch=does not match {0}
 * </pre>
 */export function abInputArgs_op_doesNotMatch(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.doesNotMatch",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.endsWith=ends with {0}
 * </pre>
 */export function abInputArgs_op_endsWith(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.endsWith",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.is=is {0}
 * </pre>
 */export function abInputArgs_op_is(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.is",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isAfter=is after {0}
 * </pre>
 */export function abInputArgs_op_isAfter(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isAfter",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isBefore=is before {0}
 * </pre>
 */export function abInputArgs_op_isBefore(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isBefore",arg0);}/**
 * <pre>
 * #{0} - first value
 * #{1} - second value
 * abInputArgs.op.isBetween=is between {0} and {1}
 * </pre>
 */export function abInputArgs_op_isBetween(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isBetween",arg0,arg1);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isEqualTo=equals {0}
 * </pre>
 */export function abInputArgs_op_isEqualTo(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isEqualTo",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isGreaterThan=is greater than {0}
 * </pre>
 */export function abInputArgs_op_isGreaterThan(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isGreaterThan",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isGreaterThanOrEqualTo=is greater than or equal to {0}
 * </pre>
 */export function abInputArgs_op_isGreaterThanOrEqualTo(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isGreaterThanOrEqualTo",arg0);}/**
 * <pre>
 * #{0} - time value (i.e is in latest 3 weeks)
 * abInputArgs.op.isInLatest=is in latest {0}
 * </pre>
 */export function abInputArgs_op_isInLatest(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isInLatest",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isLessThan=is less than {0}
 * </pre>
 */export function abInputArgs_op_isLessThan(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isLessThan",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isLessThanOrEqualTo=is less than or equal to {0}
 * </pre>
 */export function abInputArgs_op_isLessThanOrEqualTo(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isLessThanOrEqualTo",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isNot=is not {0}
 * </pre>
 */export function abInputArgs_op_isNot(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isNot",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isNotEqualTo=is not equal to {0}
 * </pre>
 */export function abInputArgs_op_isNotEqualTo(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isNotEqualTo",arg0);}/**
 * <pre>
 * abInputArgs.op.isNotSpecified=is not specified
 * </pre>
 */export function abInputArgs_op_isNotSpecified(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isNotSpecified");}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isObject=is object {0}
 * </pre>
 */export function abInputArgs_op_isObject(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isObject",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isOrAfter=is or after {0}
 * </pre>
 */export function abInputArgs_op_isOrAfter(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isOrAfter",arg0);}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.isOrBefore=is or before {0}
 * </pre>
 */export function abInputArgs_op_isOrBefore(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isOrBefore",arg0);}/**
 * <pre>
 * abInputArgs.op.isSpecified=is specified
 * </pre>
 */export function abInputArgs_op_isSpecified(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.isSpecified");}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.matches=matches {0}
 * </pre>
 */export function abInputArgs_op_matches(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.matches",arg0);}/**
 * <pre>
 * abInputArgs.op.name.contains=contains
 * </pre>
 */export function abInputArgs_op_name_contains(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.contains");}/**
 * <pre>
 * abInputArgs.op.name.doesNotMatch=does not match
 * </pre>
 */export function abInputArgs_op_name_doesNotMatch(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.doesNotMatch");}/**
 * <pre>
 * abInputArgs.op.name.endsWith=ends with
 * </pre>
 */export function abInputArgs_op_name_endsWith(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.endsWith");}/**
 * <pre>
 * abInputArgs.op.name.is=is
 * </pre>
 */export function abInputArgs_op_name_is(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.is");}/**
 * <pre>
 * abInputArgs.op.name.isAfter=is after
 * </pre>
 */export function abInputArgs_op_name_isAfter(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isAfter");}/**
 * <pre>
 * abInputArgs.op.name.isBefore=is before
 * </pre>
 */export function abInputArgs_op_name_isBefore(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isBefore");}/**
 * <pre>
 * abInputArgs.op.name.isBetween=is between
 * </pre>
 */export function abInputArgs_op_name_isBetween(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isBetween");}/**
 * <pre>
 * abInputArgs.op.name.isEqualTo=equals
 * </pre>
 */export function abInputArgs_op_name_isEqualTo(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isEqualTo");}/**
 * <pre>
 * abInputArgs.op.name.isGreaterThan=is greater than
 * </pre>
 */export function abInputArgs_op_name_isGreaterThan(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isGreaterThan");}/**
 * <pre>
 * abInputArgs.op.name.isGreaterThanOrEqualTo=is greater than or equal to
 * </pre>
 */export function abInputArgs_op_name_isGreaterThanOrEqualTo(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isGreaterThanOrEqualTo");}/**
 * <pre>
 * abInputArgs.op.name.isInLatest=is in latest
 * </pre>
 */export function abInputArgs_op_name_isInLatest(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isInLatest");}/**
 * <pre>
 * abInputArgs.op.name.isLessThan=is less than
 * </pre>
 */export function abInputArgs_op_name_isLessThan(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isLessThan");}/**
 * <pre>
 * abInputArgs.op.name.isLessThanOrEqualTo=is less than or equal to
 * </pre>
 */export function abInputArgs_op_name_isLessThanOrEqualTo(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isLessThanOrEqualTo");}/**
 * <pre>
 * abInputArgs.op.name.isNot=is not
 * </pre>
 */export function abInputArgs_op_name_isNot(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isNot");}/**
 * <pre>
 * abInputArgs.op.name.isNotEqualTo=is not equal to
 * </pre>
 */export function abInputArgs_op_name_isNotEqualTo(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isNotEqualTo");}/**
 * <pre>
 * abInputArgs.op.name.isObject=is object
 * </pre>
 */export function abInputArgs_op_name_isObject(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isObject");}/**
 * <pre>
 * abInputArgs.op.name.isOrAfter=is or after
 * </pre>
 */export function abInputArgs_op_name_isOrAfter(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isOrAfter");}/**
 * <pre>
 * abInputArgs.op.name.isOrBefore=is or before
 * </pre>
 */export function abInputArgs_op_name_isOrBefore(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.isOrBefore");}/**
 * <pre>
 * abInputArgs.op.name.matches=matches
 * </pre>
 */export function abInputArgs_op_name_matches(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.matches");}/**
 * <pre>
 * abInputArgs.op.name.startsWith=begins with
 * </pre>
 */export function abInputArgs_op_name_startsWith(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.name.startsWith");}/**
 * <pre>
 * #{0} - value
 * abInputArgs.op.startsWith=begins with {0}
 * </pre>
 */export function abInputArgs_op_startsWith(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.op.startsWith",arg0);}/**
 * <pre>
 * abInputArgs.optionalArg=Optional arguments...
 * </pre>
 */export function abInputArgs_optionalArg(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.optionalArg");}/**
 * <pre>
 * abInputArgs.removeFilter=Remove this filter
 * </pre>
 */export function abInputArgs_removeFilter(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.removeFilter");}/**
 * <pre>
 * abInputArgs.reportArgumentsSectionName=Report Arguments
 * </pre>
 */export function abInputArgs_reportArgumentsSectionName(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.reportArgumentsSectionName");}/**
 * <pre>
 * abInputArgs.revertInputArgTooltip=This argument was changed, but the data hasn't been updated yet.
Click {0} to refresh the view.
 * </pre>
 */export function abInputArgs_revertInputArgTooltip(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.revertInputArgTooltip",arg0);}/**
 * <pre>
 * # The following abInputArgs.xxx constants are used by a report player. To see an example, navigate to
 * # Other | Metadata Reports through the nav-bar menu and click on a report name.
 * abInputArgs.run=Run
 * </pre>
 */export function abInputArgs_run(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.run");}/**
 * <pre>
 * abInputArgs.showAllOptionalArgs=Show all
 * </pre>
 */export function abInputArgs_showAllOptionalArgs(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.showAllOptionalArgs");}/**
 * <pre>
 * abInputArgs.showPublishedChangesOnlyLabel=Show published changes only
 * </pre>
 */export function abInputArgs_showPublishedChangesOnlyLabel(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.showPublishedChangesOnlyLabel");}/**
 * <pre>
 * abInputArgs.showPublishedChangesOnlyTooltip=Select this box to include <i>only</i> published objects in the report.<br/>Deselect this box to include <i>both</i> published and non-published objects in the report.
 * </pre>
 */export function abInputArgs_showPublishedChangesOnlyTooltip(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.showPublishedChangesOnlyTooltip");}/**
 * <pre>
 * #{0} - number of characters
 * abInputArgs.stringCannotBeLongerThan.n.characters=This argument cannot be longer than {0} characters
 * </pre>
 */export function abInputArgs_stringCannotBeLongerThan_n_characters(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.stringCannotBeLongerThan.n.characters",arg0);}/**
 * <pre>
 * #{0} - number of characters
 * abInputArgs.stringCannotBeShorterThan.n.characters=This argument cannot be shorter than {0} characters
 * </pre>
 */export function abInputArgs_stringCannotBeShorterThan_n_characters(arg0){return AbWebServices.i18n.getMessage("abreact","abInputArgs.stringCannotBeShorterThan.n.characters",arg0);}/**
 * <pre>
 * abInputArgs.thisIsOptionalArg=This is an optional argument. Click to reset this argument to its default value and remove from view
 * </pre>
 */export function abInputArgs_thisIsOptionalArg(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.thisIsOptionalArg");}/**
 * <pre>
 * abInputArgs.unspecified=unspecified
 * </pre>
 */export function abInputArgs_unspecified(){return AbWebServices.i18n.getMessage("abreact","abInputArgs.unspecified");}/**
 * <pre>
 * # Alt text for icon indicating that a link opens in a new window or tab
 * abLink.opensInANewWindowIcon.altText=Opens in a new window
 * </pre>
 */export function abLink_opensInANewWindowIcon_altText(){return AbWebServices.i18n.getMessage("abreact","abLink.opensInANewWindowIcon.altText");}/**
 * <pre>
 * abLlmPromptDlg.editor.placeholder=Enter prompt for LLM
 * </pre>
 */export function abLlmPromptDlg_editor_placeholder(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.editor.placeholder");}/**
 * <pre>
 * abLlmPromptDlg.inputsTitle=Input Fields
 * </pre>
 */export function abLlmPromptDlg_inputsTitle(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.inputsTitle");}/**
 * <pre>
 * abLlmPromptDlg.paramsTitle=Graph Parameters
 * </pre>
 */export function abLlmPromptDlg_paramsTitle(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.paramsTitle");}/**
 * <pre>
 * abLlmPromptDlg.preview.placeholder=Content will appear here
 * </pre>
 */export function abLlmPromptDlg_preview_placeholder(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.placeholder");}/**
 * <pre>
 * abLlmPromptDlg.preview.prompt.label=Prompt
 * </pre>
 */export function abLlmPromptDlg_preview_prompt_label(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.prompt.label");}/**
 * <pre>
 * abLlmPromptDlg.preview.response.button.label.generate=Generate LLM response
 * </pre>
 */export function abLlmPromptDlg_preview_response_button_label_generate(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.response.button.label.generate");}/**
 * <pre>
 * abLlmPromptDlg.preview.response.button.label.regenerate=Regenerate LLM response
 * </pre>
 */export function abLlmPromptDlg_preview_response_button_label_regenerate(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.response.button.label.regenerate");}/**
 * <pre>
 * abLlmPromptDlg.preview.response.error=Could not create prompt
 * </pre>
 */export function abLlmPromptDlg_preview_response_error(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.response.error");}/**
 * <pre>
 * abLlmPromptDlg.preview.response.label=LLM Response
 * </pre>
 */export function abLlmPromptDlg_preview_response_label(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.response.label");}/**
 * <pre>
 * abLlmPromptDlg.preview.response.stale=Prompt updated. This response is now stale.
 * </pre>
 */export function abLlmPromptDlg_preview_response_stale(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.response.stale");}/**
 * <pre>
 * abLlmPromptDlg.preview.title=Preview
 * </pre>
 */export function abLlmPromptDlg_preview_title(){return AbWebServices.i18n.getMessage("abreact","abLlmPromptDlg.preview.title");}/**
 * <pre>
 * #{0} is the number of new notifications
 * abNotification.newNotifications={0} new
 * </pre>
 */export function abNotification_newNotifications(arg0){return AbWebServices.i18n.getMessage("abreact","abNotification.newNotifications",arg0);}/**
 * <pre>
 * abNotification.showComment=Show comment
 * </pre>
 */export function abNotification_showComment(){return AbWebServices.i18n.getMessage("abreact","abNotification.showComment");}/**
 * <pre>
 * abNotification.showRating=Show rating
 * </pre>
 */export function abNotification_showRating(){return AbWebServices.i18n.getMessage("abreact","abNotification.showRating");}/**
 * <pre>
 * # This is a tooltip shown on the percent bar. It will look something like "Valids: 50" in English
 * abPercentBar.labelAndValue={0}: {1}
 * </pre>
 */export function abPercentBar_labelAndValue(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","abPercentBar.labelAndValue",arg0,arg1);}/**
 * <pre>
 * abProductStatus.buildId.version=Build ID
 * </pre>
 */export function abProductStatus_buildId_version(){return AbWebServices.i18n.getMessage("abreact","abProductStatus.buildId.version");}/**
 * <pre>
 * abProductStatus.button.refresh=Refresh
 * </pre>
 */export function abProductStatus_button_refresh(){return AbWebServices.i18n.getMessage("abreact","abProductStatus.button.refresh");}/**
 * <pre>
 * abProductStatus.column.details=Details
 * </pre>
 */export function abProductStatus_column_details(){return AbWebServices.i18n.getMessage("abreact","abProductStatus.column.details");}/**
 * <pre>
 * abProductStatus.column.status=Status
 * </pre>
 */export function abProductStatus_column_status(){return AbWebServices.i18n.getMessage("abreact","abProductStatus.column.status");}/**
 * <pre>
 * abProductStatus.column.version=Version
 * </pre>
 */export function abProductStatus_column_version(){return AbWebServices.i18n.getMessage("abreact","abProductStatus.column.version");}/**
 * <pre>
 * abProductStatus.lastUpdatedAt=Last updated: {0}
 * </pre>
 */export function abProductStatus_lastUpdatedAt(arg0){return AbWebServices.i18n.getMessage("abreact","abProductStatus.lastUpdatedAt",arg0);}/**
 * <pre>
 * abProductStatus.productStatus={0} Status
 * </pre>
 */export function abProductStatus_productStatus(arg0){return AbWebServices.i18n.getMessage("abreact","abProductStatus.productStatus",arg0);}/**
 * <pre>
 * abPwd.ChangePasswordBtnText=Change Password
 * </pre>
 */export function abPwd_changePasswordBtnText(){return AbWebServices.i18n.getMessage("abreact","abPwd.ChangePasswordBtnText");}/**
 * <pre>
 * abPwd.ConfirmLabel=Confirm Password:
 * </pre>
 */export function abPwd_confirmLabel(){return AbWebServices.i18n.getMessage("abreact","abPwd.ConfirmLabel");}/**
 * <pre>
 * abPwd.EmptyError=Password must not be empty
 * </pre>
 */export function abPwd_emptyError(){return AbWebServices.i18n.getMessage("abreact","abPwd.EmptyError");}/**
 * <pre>
 * abPwd.MatchingError=Password input fields don't match
 * </pre>
 */export function abPwd_matchingError(){return AbWebServices.i18n.getMessage("abreact","abPwd.MatchingError");}/**
 * <pre>
 * abPwd.MissingOldPassword=Enter your old password
 * </pre>
 */export function abPwd_missingOldPassword(){return AbWebServices.i18n.getMessage("abreact","abPwd.MissingOldPassword");}/**
 * <pre>
 * abPwd.OldPasswordLabel=Current Password:
 * </pre>
 */export function abPwd_oldPasswordLabel(){return AbWebServices.i18n.getMessage("abreact","abPwd.OldPasswordLabel");}/**
 * <pre>
 * # The following abPwd.xxx constants are used by AbPasswordEditor and AbResetPasswordDialog components.
 * # To see an example, navigate to Other | Administration through the nav-bar menu, select Bridge Connections
 * # on the sidebar and click the Add New button. In the New Bridge Connection click on the Change... link.
 * abPwd.PasswordLabel=New Password:
 * </pre>
 */export function abPwd_passwordLabel(){return AbWebServices.i18n.getMessage("abreact","abPwd.PasswordLabel");}/**
 * <pre>
 * abPwd.SetPasswordDlgTitle=Change Password
 * </pre>
 */export function abPwd_setPasswordDlgTitle(){return AbWebServices.i18n.getMessage("abreact","abPwd.SetPasswordDlgTitle");}/**
 * <pre>
 * abReactTopDown.discardChanges.discardMsg=There are unsaved changes. Discard them?
 * </pre>
 */export function abReactTopDown_discardChanges_discardMsg(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.discardChanges.discardMsg");}/**
 * <pre>
 * abReactTopDown.discardChanges.keepEditingLabel=Keep Editing
 * </pre>
 */export function abReactTopDown_discardChanges_keepEditingLabel(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.discardChanges.keepEditingLabel");}/**
 * <pre>
 * abReactTopDown.discardChanges.title=Discard Changes?
 * </pre>
 */export function abReactTopDown_discardChanges_title(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.discardChanges.title");}/**
 * <pre>
 * abReactTopDown.leaveChangedPageAlert=You have unsaved changes.
In order to leave, you must save or discard your changes first.
 * </pre>
 */export function abReactTopDown_leaveChangedPageAlert(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.leaveChangedPageAlert");}/**
 * <pre>
 * abReactTopDown.leaveChangedPageAlert.title=Unsaved Changes
 * </pre>
 */export function abReactTopDown_leaveChangedPageAlert_title(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.leaveChangedPageAlert.title");}/**
 * <pre>
 * abReactTopDown.saveDiscardDialog.cancelDescription=Stay on this page
 * </pre>
 */export function abReactTopDown_saveDiscardDialog_cancelDescription(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.saveDiscardDialog.cancelDescription");}/**
 * <pre>
 * abReactTopDown.saveDiscardDialog.discardDescription=Discard changes and continue
 * </pre>
 */export function abReactTopDown_saveDiscardDialog_discardDescription(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.saveDiscardDialog.discardDescription");}/**
 * <pre>
 * abReactTopDown.saveDiscardDialog.leavePageMsg=You are trying to go to a different page, but the current page has unsaved changes.
 * </pre>
 */export function abReactTopDown_saveDiscardDialog_leavePageMsg(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.saveDiscardDialog.leavePageMsg");}/**
 * <pre>
 * abReactTopDown.saveDiscardDialog.saveDescription=Save changes and continue
 * </pre>
 */export function abReactTopDown_saveDiscardDialog_saveDescription(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.saveDiscardDialog.saveDescription");}/**
 * <pre>
 * abReactTopDown.saveDiscardDialog.title=There are unsaved changes
 * </pre>
 */export function abReactTopDown_saveDiscardDialog_title(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.saveDiscardDialog.title");}/**
 * <pre>
 * abReactTopDown.saveDiscardDialog.whatToDoMsg=What do you want to do?
 * </pre>
 */export function abReactTopDown_saveDiscardDialog_whatToDoMsg(){return AbWebServices.i18n.getMessage("abreact","abReactTopDown.saveDiscardDialog.whatToDoMsg");}/**
 * <pre>
 * abShowMoreText.less=Show Less
 * </pre>
 */export function abShowMoreText_less(){return AbWebServices.i18n.getMessage("abreact","abShowMoreText.less");}/**
 * <pre>
 * abShowMoreText.more=Show More
 * </pre>
 */export function abShowMoreText_more(){return AbWebServices.i18n.getMessage("abreact","abShowMoreText.more");}/**
 * <pre>
 * abSideMenu.collapse.tooltip=Collapse
 * </pre>
 */export function abSideMenu_collapse_tooltip(){return AbWebServices.i18n.getMessage("abreact","abSideMenu.collapse.tooltip");}/**
 * <pre>
 * abSideMenu.expand.tooltip=Expand
 * </pre>
 */export function abSideMenu_expand_tooltip(){return AbWebServices.i18n.getMessage("abreact","abSideMenu.expand.tooltip");}/**
 * <pre>
 * abSpeechInputButton.error=Error while recording audio.
 * </pre>
 */export function abSpeechInputButton_error(){return AbWebServices.i18n.getMessage("abreact","abSpeechInputButton.error");}/**
 * <pre>
 * #{0} is a number 1-5, ex: 4-Star Reviews
 * abStarRatings.filter={0}-Star Reviews
 * </pre>
 */export function abStarRatings_filter(arg0){return AbWebServices.i18n.getMessage("abreact","abStarRatings.filter",arg0);}/**
 * <pre>
 * abStarRatings.paneTitle=Ratings and Reviews
 * </pre>
 */export function abStarRatings_paneTitle(){return AbWebServices.i18n.getMessage("abreact","abStarRatings.paneTitle");}/**
 * <pre>
 * abStarRatings.placeholderText=Type your review here
 * </pre>
 */export function abStarRatings_placeholderText(){return AbWebServices.i18n.getMessage("abreact","abStarRatings.placeholderText");}/**
 * <pre>
 * abStarRatings.rate=Rate
 * </pre>
 */export function abStarRatings_rate(){return AbWebServices.i18n.getMessage("abreact","abStarRatings.rate");}/**
 * <pre>
 * abStarRatings.sortPreferenceOldest=Oldest
 * </pre>
 */export function abStarRatings_sortPreferenceOldest(){return AbWebServices.i18n.getMessage("abreact","abStarRatings.sortPreferenceOldest");}/**
 * <pre>
 * abStarRatings.sortPreferenceRecent=Recent
 * </pre>
 */export function abStarRatings_sortPreferenceRecent(){return AbWebServices.i18n.getMessage("abreact","abStarRatings.sortPreferenceRecent");}/**
 * <pre>
 * abStarRatings.submitText=Post
 * </pre>
 */export function abStarRatings_submitText(){return AbWebServices.i18n.getMessage("abreact","abStarRatings.submitText");}/**
 * <pre>
 * #{0} is the average rating for an entity, and {1} is the number of total ratings, ex: 4.5 stars (5 ratings)
 * abStarRatings.title={0} Stars ({1} Ratings)
 * </pre>
 */export function abStarRatings_title(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","abStarRatings.title",arg0,arg1);}/**
 * <pre>
 * abTextDivWithOverflowPopup.collapse=Collapse
 * </pre>
 */export function abTextDivWithOverflowPopup_collapse(){return AbWebServices.i18n.getMessage("abreact","abTextDivWithOverflowPopup.collapse");}/**
 * <pre>
 * abTextDivWithOverflowPopup.expand=Expand
 * </pre>
 */export function abTextDivWithOverflowPopup_expand(){return AbWebServices.i18n.getMessage("abreact","abTextDivWithOverflowPopup.expand");}/**
 * <pre>
 * about.dialog.advanced.label=Advanced
 * </pre>
 */export function about_dialog_advanced_label(){return AbWebServices.i18n.getMessage("abreact","about.dialog.advanced.label");}/**
 * <pre>
 * about.dialog.buildDate=Build Date
 * </pre>
 */export function about_dialog_buildDate(){return AbWebServices.i18n.getMessage("abreact","about.dialog.buildDate");}/**
 * <pre>
 * about.dialog.buildId=Build ID
 * </pre>
 */export function about_dialog_buildId(){return AbWebServices.i18n.getMessage("abreact","about.dialog.buildId");}/**
 * <pre>
 * about.dialog.cancel.label=Close
 * </pre>
 */export function about_dialog_cancel_label(){return AbWebServices.i18n.getMessage("abreact","about.dialog.cancel.label");}/**
 * <pre>
 * about.dialog.locale=Locale
 * </pre>
 */export function about_dialog_locale(){return AbWebServices.i18n.getMessage("abreact","about.dialog.locale");}/**
 * <pre>
 * about.dialog.logo.tooltip=Ab Initio
 * </pre>
 */export function about_dialog_logo_tooltip(){return AbWebServices.i18n.getMessage("abreact","about.dialog.logo.tooltip");}/**
 * <pre>
 * about.dialog.preferredLocale=Preferred Locale
 * </pre>
 */export function about_dialog_preferredLocale(){return AbWebServices.i18n.getMessage("abreact","about.dialog.preferredLocale");}/**
 * <pre>
 * about.dialog.productName=Product Name
 * </pre>
 */export function about_dialog_productName(){return AbWebServices.i18n.getMessage("abreact","about.dialog.productName");}/**
 * <pre>
 * about.dialog.productVersion=Product Version
 * </pre>
 */export function about_dialog_productVersion(){return AbWebServices.i18n.getMessage("abreact","about.dialog.productVersion");}/**
 * <pre>
 * # The following are options for what will be displayed in the title of the advanced About dialog itself.
 * # See ABSDK-2053
 * # {0} is the product name - different products should be using a different localized string but if
 * # one is not provided, this one is used.
 * about.dialog.title=About {0}
 * </pre>
 */export function about_dialog_title(arg0){return AbWebServices.i18n.getMessage("abreact","about.dialog.title",arg0);}/**
 * <pre>
 * accessDeniedDialog.logOut=Log Out
 * </pre>
 */export function accessDeniedDialog_logOut(){return AbWebServices.i18n.getMessage("abreact","accessDeniedDialog.logOut");}/**
 * <pre>
 * accessDeniedDialog.message=Access Denied. Your account has not been granted access to this resource. Please contact your system administrator or click 'Log Out' to try again.
 * </pre>
 */export function accessDeniedDialog_message(){return AbWebServices.i18n.getMessage("abreact","accessDeniedDialog.message");}/**
 * <pre>
 * aceCodeEditor.searchbox.caseSensitiveSearch=CaseSensitive Search
 * </pre>
 */export function aceCodeEditor_searchbox_caseSensitiveSearch(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.caseSensitiveSearch");}/**
 * <pre>
 * aceCodeEditor.searchbox.findAll=All
 * </pre>
 */export function aceCodeEditor_searchbox_findAll(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.findAll");}/**
 * <pre>
 * aceCodeEditor.searchbox.findAllShortcut=Alt-Enter
 * </pre>
 */export function aceCodeEditor_searchbox_findAllShortcut(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.findAllShortcut");}/**
 * <pre>
 * aceCodeEditor.searchbox.findPlaceholder=Search for
 * </pre>
 */export function aceCodeEditor_searchbox_findPlaceholder(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.findPlaceholder");}/**
 * <pre>
 * aceCodeEditor.searchbox.regexpSearch=RegExp Search
 * </pre>
 */export function aceCodeEditor_searchbox_regexpSearch(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.regexpSearch");}/**
 * <pre>
 * aceCodeEditor.searchbox.replace=Replace
 * </pre>
 */export function aceCodeEditor_searchbox_replace(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.replace");}/**
 * <pre>
 * aceCodeEditor.searchbox.replaceAll=All
 * </pre>
 */export function aceCodeEditor_searchbox_replaceAll(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.replaceAll");}/**
 * <pre>
 * aceCodeEditor.searchbox.replacePlaceholder=Replace with
 * </pre>
 */export function aceCodeEditor_searchbox_replacePlaceholder(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.replacePlaceholder");}/**
 * <pre>
 * aceCodeEditor.searchbox.wholeWorldSearch=Whole Word Search
 * </pre>
 */export function aceCodeEditor_searchbox_wholeWorldSearch(){return AbWebServices.i18n.getMessage("abreact","aceCodeEditor.searchbox.wholeWorldSearch");}/**
 * <pre>
 * actionbar.hamburger_menu.tooltip=Other Actions
 * </pre>
 */export function actionbar_hamburgerMenu_tooltip(){return AbWebServices.i18n.getMessage("abreact","actionbar.hamburger_menu.tooltip");}/**
 * <pre>
 * aggregate.aggregateType.fixedWindow=Fixed Window
 * </pre>
 */export function aggregate_aggregateType_fixedWindow(){return AbWebServices.i18n.getMessage("abreact","aggregate.aggregateType.fixedWindow");}/**
 * <pre>
 * aggregate.aggregateType.mixedWindow=Mixed Window
 * </pre>
 */export function aggregate_aggregateType_mixedWindow(){return AbWebServices.i18n.getMessage("abreact","aggregate.aggregateType.mixedWindow");}/**
 * <pre>
 * aggregate.aggregateType.noWindow=No Window
 * </pre>
 */export function aggregate_aggregateType_noWindow(){return AbWebServices.i18n.getMessage("abreact","aggregate.aggregateType.noWindow");}/**
 * <pre>
 * aggregate.aggregateType.slidingWindow=Sliding Window
 * </pre>
 */export function aggregate_aggregateType_slidingWindow(){return AbWebServices.i18n.getMessage("abreact","aggregate.aggregateType.slidingWindow");}/**
 * <pre>
 * aggregate.dataType.boolean=Boolean
 * </pre>
 */export function aggregate_dataType_boolean(){return AbWebServices.i18n.getMessage("abreact","aggregate.dataType.boolean");}/**
 * <pre>
 * aggregate.dataType.date=Date
 * </pre>
 */export function aggregate_dataType_date(){return AbWebServices.i18n.getMessage("abreact","aggregate.dataType.date");}/**
 * <pre>
 * aggregate.dataType.dateTime=Date Time
 * </pre>
 */export function aggregate_dataType_dateTime(){return AbWebServices.i18n.getMessage("abreact","aggregate.dataType.dateTime");}/**
 * <pre>
 * aggregate.dataType.numeric=Numeric
 * </pre>
 */export function aggregate_dataType_numeric(){return AbWebServices.i18n.getMessage("abreact","aggregate.dataType.numeric");}/**
 * <pre>
 * aggregate.dataType.string=String
 * </pre>
 */export function aggregate_dataType_string(){return AbWebServices.i18n.getMessage("abreact","aggregate.dataType.string");}/**
 * <pre>
 * aggregate.durationUnit.days=Days
 * </pre>
 */export function aggregate_durationUnit_days(){return AbWebServices.i18n.getMessage("abreact","aggregate.durationUnit.days");}/**
 * <pre>
 * aggregate.durationUnit.hours=Hours
 * </pre>
 */export function aggregate_durationUnit_hours(){return AbWebServices.i18n.getMessage("abreact","aggregate.durationUnit.hours");}/**
 * <pre>
 * aggregate.durationUnit.minutes=Minutes
 * </pre>
 */export function aggregate_durationUnit_minutes(){return AbWebServices.i18n.getMessage("abreact","aggregate.durationUnit.minutes");}/**
 * <pre>
 * aggregate.durationUnit.months=Months
 * </pre>
 */export function aggregate_durationUnit_months(){return AbWebServices.i18n.getMessage("abreact","aggregate.durationUnit.months");}/**
 * <pre>
 * aggregate.durationUnit.weeks=Weeks
 * </pre>
 */export function aggregate_durationUnit_weeks(){return AbWebServices.i18n.getMessage("abreact","aggregate.durationUnit.weeks");}/**
 * <pre>
 * aggregate.numericSubtype.custom=Custom
 * </pre>
 */export function aggregate_numericSubtype_custom(){return AbWebServices.i18n.getMessage("abreact","aggregate.numericSubtype.custom");}/**
 * <pre>
 * aggregate.numericSubtype.decimalHundredths=Fixed precision (2 decimal places)
 * </pre>
 */export function aggregate_numericSubtype_decimalHundredths(){return AbWebServices.i18n.getMessage("abreact","aggregate.numericSubtype.decimalHundredths");}/**
 * <pre>
 * aggregate.numericSubtype.double=Variable precision
 * </pre>
 */export function aggregate_numericSubtype_double(){return AbWebServices.i18n.getMessage("abreact","aggregate.numericSubtype.double");}/**
 * <pre>
 * aggregate.numericSubtype.int2=Integer (up to 32 thousand)
 * </pre>
 */export function aggregate_numericSubtype_int2(){return AbWebServices.i18n.getMessage("abreact","aggregate.numericSubtype.int2");}/**
 * <pre>
 * aggregate.numericSubtype.int4=Integer (up to 2 billion)
 * </pre>
 */export function aggregate_numericSubtype_int4(){return AbWebServices.i18n.getMessage("abreact","aggregate.numericSubtype.int4");}/**
 * <pre>
 * aggregate.numericSubtype.int8=Integer (up to 9 quintillion)
 * </pre>
 */export function aggregate_numericSubtype_int8(){return AbWebServices.i18n.getMessage("abreact","aggregate.numericSubtype.int8");}/**
 * <pre>
 * aggregate.placeholder.aggregateType=Choose Type
 * </pre>
 */export function aggregate_placeholder_aggregateType(){return AbWebServices.i18n.getMessage("abreact","aggregate.placeholder.aggregateType");}/**
 * <pre>
 * aggregate.placeholder.businessName=New Aggregate
 * </pre>
 */export function aggregate_placeholder_businessName(){return AbWebServices.i18n.getMessage("abreact","aggregate.placeholder.businessName");}/**
 * <pre>
 * aggregate.placeholder.dataType=Select Data Type
 * </pre>
 */export function aggregate_placeholder_dataType(){return AbWebServices.i18n.getMessage("abreact","aggregate.placeholder.dataType");}/**
 * <pre>
 * aggregate.placeholder.numericSubtype=Select Numeric Subtype
 * </pre>
 */export function aggregate_placeholder_numericSubtype(){return AbWebServices.i18n.getMessage("abreact","aggregate.placeholder.numericSubtype");}/**
 * <pre>
 * aggregate.placeholder.technicalName=new_aggregate
 * </pre>
 */export function aggregate_placeholder_technicalName(){return AbWebServices.i18n.getMessage("abreact","aggregate.placeholder.technicalName");}/**
 * <pre>
 * aggregate.placeholder.template=Choose Aggregate Function
 * </pre>
 */export function aggregate_placeholder_template(){return AbWebServices.i18n.getMessage("abreact","aggregate.placeholder.template");}/**
 * <pre>
 * aggregate.property.aggregateType=Type
 * </pre>
 */export function aggregate_property_aggregateType(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.aggregateType");}/**
 * <pre>
 * aggregate.property.businessName=Business Name
 * </pre>
 */export function aggregate_property_businessName(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.businessName");}/**
 * <pre>
 * aggregate.property.dataType=Data Type
 * </pre>
 */export function aggregate_property_dataType(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.dataType");}/**
 * <pre>
 * aggregate.property.duration=Duration
 * </pre>
 */export function aggregate_property_duration(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.duration");}/**
 * <pre>
 * aggregate.property.numBlocks=Number of Blocks
 * </pre>
 */export function aggregate_property_numBlocks(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.numBlocks");}/**
 * <pre>
 * aggregate.property.numericSubtype=Numeric Subtype
 * </pre>
 */export function aggregate_property_numericSubtype(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.numericSubtype");}/**
 * <pre>
 * aggregate.property.secondDataType=Second Data Type
 * </pre>
 */export function aggregate_property_secondDataType(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.secondDataType");}/**
 * <pre>
 * aggregate.property.technicalName=Technical Name
 * </pre>
 */export function aggregate_property_technicalName(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.technicalName");}/**
 * <pre>
 * aggregate.property.template=Function
 * </pre>
 */export function aggregate_property_template(){return AbWebServices.i18n.getMessage("abreact","aggregate.property.template");}/**
 * <pre>
 * aggregate.section.configuration=Configuration
 * </pre>
 */export function aggregate_section_configuration(){return AbWebServices.i18n.getMessage("abreact","aggregate.section.configuration");}/**
 * <pre>
 * aggregate.section.information=Information
 * </pre>
 */export function aggregate_section_information(){return AbWebServices.i18n.getMessage("abreact","aggregate.section.information");}/**
 * <pre>
 * # 'aiHelpChat.' resources: AI Help Chat widget
 * # Owner: see AiHelpChatWidget.tsx
 * # {0} is the chat number
 * aiHelpChat.chatTab=Chat {0}
 * </pre>
 */export function aiHelpChat_chatTab(arg0){return AbWebServices.i18n.getMessage("abreact","aiHelpChat.chatTab",arg0);}/**
 * <pre>
 * aiHelpChat.newChat=New Chat
 * </pre>
 */export function aiHelpChat_newChat(){return AbWebServices.i18n.getMessage("abreact","aiHelpChat.newChat");}/**
 * <pre>
 * aiHelpChat.title=AI Help Assistant
 * </pre>
 */export function aiHelpChat_title(){return AbWebServices.i18n.getMessage("abreact","aiHelpChat.title");}/**
 * <pre>
 * alert.dialog.defaultTitle.error=Error
 * </pre>
 */export function alert_dialog_defaultTitle_error(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.defaultTitle.error");}/**
 * <pre>
 * alert.dialog.defaultTitle.info=Information
 * </pre>
 */export function alert_dialog_defaultTitle_info(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.defaultTitle.info");}/**
 * <pre>
 * alert.dialog.defaultTitle.success=Success
 * </pre>
 */export function alert_dialog_defaultTitle_success(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.defaultTitle.success");}/**
 * <pre>
 * alert.dialog.defaultTitle.warning=Warning
 * </pre>
 */export function alert_dialog_defaultTitle_warning(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.defaultTitle.warning");}/**
 * <pre>
 * alert.dialog.iconAltText.error=Error: 
 * </pre>
 */export function alert_dialog_iconAltText_error(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.iconAltText.error");}/**
 * <pre>
 * alert.dialog.iconAltText.info=Information: 
 * </pre>
 */export function alert_dialog_iconAltText_info(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.iconAltText.info");}/**
 * <pre>
 * alert.dialog.iconAltText.success=Success: 
 * </pre>
 */export function alert_dialog_iconAltText_success(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.iconAltText.success");}/**
 * <pre>
 * alert.dialog.iconAltText.warning=Warning: 
 * </pre>
 */export function alert_dialog_iconAltText_warning(){return AbWebServices.i18n.getMessage("abreact","alert.dialog.iconAltText.warning");}/**
 * <pre>
 * asyncGenericGridExpandoCell.fetchingChildren=Fetching children
 * </pre>
 */export function asyncGenericGridExpandoCell_fetchingChildren(){return AbWebServices.i18n.getMessage("abreact","asyncGenericGridExpandoCell.fetchingChildren");}/**
 * <pre>
 * asyncGenericGridExpandoCell.tryAgain=Click to try again.
 * </pre>
 */export function asyncGenericGridExpandoCell_tryAgain(){return AbWebServices.i18n.getMessage("abreact","asyncGenericGridExpandoCell.tryAgain");}/**
 * <pre>
 * ## Authentication Strategy Messages:   authenticationStrategy.stateful|stateless.errorType(.sso|.notSso)?.(title|message)
 * # For 'authenticationStrategy.actionButton.login.title' button label, use 'AbReactResources.loginDialog_logIn()'
 * # to be consistent with login dialog label
 * authenticationStrategy.actionButton.loginOK.title=OK
 * </pre>
 */export function authenticationStrategy_actionButton_loginOK_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.actionButton.loginOK.title");}/**
 * <pre>
 * authenticationStrategy.actionButton.logout.title=Log Out
 * </pre>
 */export function authenticationStrategy_actionButton_logout_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.actionButton.logout.title");}/**
 * <pre>
 * authenticationStrategy.actionButton.reactivate.title=Reactivate
 * </pre>
 */export function authenticationStrategy_actionButton_reactivate_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.actionButton.reactivate.title");}/**
 * <pre>
 * authenticationStrategy.actionButton.reconnect.title=Reconnect
 * </pre>
 */export function authenticationStrategy_actionButton_reconnect_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.actionButton.reconnect.title");}/**
 * <pre>
 * authenticationStrategy.actionButton.refresh.title=Refresh
 * </pre>
 */export function authenticationStrategy_actionButton_refresh_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.actionButton.refresh.title");}/**
 * <pre>
 * ### Stateful Authentication Strategy Messages
 * authenticationStrategy.invalidSession.title=Session Ended
 * </pre>
 */export function authenticationStrategy_invalidSession_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.invalidSession.title");}/**
 * <pre>
 * authenticationStrategy.stateful.concurrentDisabledSession.notSso.message=This session has been disabled because user "{0}" has logged in from another location. Click Reactivate to continue your session or Log Out to end your session. If you reactivate your session, then the other sessions that are logged in as the same user will be disabled.
 * </pre>
 */export function authenticationStrategy_stateful_concurrentDisabledSession_notSso_message(arg0){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.concurrentDisabledSession.notSso.message",arg0);}/**
 * <pre>
 * authenticationStrategy.stateful.concurrentDisabledSession.sso.message=This session has been disabled because user "{0}" has logged in from another location. Click Reactivate to continue your session or close this browser tab to allow the user session in the other location to continue. If you reactivate your session, then the other sessions that are logged in as the same user will be disabled.
 * </pre>
 */export function authenticationStrategy_stateful_concurrentDisabledSession_sso_message(arg0){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.concurrentDisabledSession.sso.message",arg0);}/**
 * <pre>
 * authenticationStrategy.stateful.concurrentInvalidSession.notSso.message=This session has ended because user "{0}" has logged in from another location. Click OK to close the application.
 * </pre>
 */export function authenticationStrategy_stateful_concurrentInvalidSession_notSso_message(arg0){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.concurrentInvalidSession.notSso.message",arg0);}/**
 * <pre>
 * authenticationStrategy.stateful.concurrentInvalidSession.sso.message=This session has ended because user "{0}" has logged in from another location. Close this browser tab to allow the user session in the other location to continue, or click Log In to begin a new session here. If you begin a new session here, then the other sessions that are logged in as the same user will be closed.
 * </pre>
 */export function authenticationStrategy_stateful_concurrentInvalidSession_sso_message(arg0){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.concurrentInvalidSession.sso.message",arg0);}/**
 * <pre>
 * authenticationStrategy.stateful.disabledSession.title=Session Disabled
 * </pre>
 */export function authenticationStrategy_stateful_disabledSession_title(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.disabledSession.title");}/**
 * <pre>
 * authenticationStrategy.stateful.invalidSession.message=This session has ended. Click Log In to begin a new session.
 * </pre>
 */export function authenticationStrategy_stateful_invalidSession_message(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.invalidSession.message");}/**
 * <pre>
 * authenticationStrategy.stateful.stolenSession.message=This browser tab session has ended because you logged in via another tab (or window) on this browser. Close this browser tab to allow the other browser tab to continue, or click Refresh to reload this browser tab using the same session as the other browser tab.
 * </pre>
 */export function authenticationStrategy_stateful_stolenSession_message(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateful.stolenSession.message");}/**
 * <pre>
 * authenticationStrategy.stateless.concurrentInvalidSession.notSso.message=This session has ended because user "{0}" has logged in from another location. Click Reactivate to continue your session, otherwise click Log Out. If you reactivate your session, then the other sessions that are logged in as the same user will be disabled.
 * </pre>
 */export function authenticationStrategy_stateless_concurrentInvalidSession_notSso_message(arg0){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateless.concurrentInvalidSession.notSso.message",arg0);}/**
 * <pre>
 * authenticationStrategy.stateless.invalidSession.sso.message=This session has ended. To reestablish your session without losing work, open another browser tab and log in, then return to this browser tab and click Reconnect. Alternatively, click Log In to begin a new session.
 * </pre>
 */export function authenticationStrategy_stateless_invalidSession_sso_message(){return AbWebServices.i18n.getMessage("abreact","authenticationStrategy.stateless.invalidSession.sso.message");}/**
 * <pre>
 * autoSaveNotice.keepEditing.label=Keep Editing
 * </pre>
 */export function autoSaveNotice_keepEditing_label(){return AbWebServices.i18n.getMessage("abreact","autoSaveNotice.keepEditing.label");}/**
 * <pre>
 * autoSaveNotice.title=Viewing Autosaved Changes
 * </pre>
 */export function autoSaveNotice_title(){return AbWebServices.i18n.getMessage("abreact","autoSaveNotice.title");}/**
 * <pre>
 * autoSaveNotice.whatToDo.message=The last session ended unexpectedly. What would you like to do with the autosaved changes?
 * </pre>
 */export function autoSaveNotice_whatToDo_message(){return AbWebServices.i18n.getMessage("abreact","autoSaveNotice.whatToDo.message");}/**
 * <pre>
 * awSnap.message=Could not load requested page.
 * </pre>
 */export function awSnap_message(){return AbWebServices.i18n.getMessage("abreact","awSnap.message");}/**
 * <pre>
 * boolean.renderer.false.tooltip=False
 * </pre>
 */export function boolean_renderer_false_tooltip(){return AbWebServices.i18n.getMessage("abreact","boolean.renderer.false.tooltip");}/**
 * <pre>
 * boolean.renderer.indeterminate.tooltip=Value is unspecified
 * </pre>
 */export function boolean_renderer_indeterminate_tooltip(){return AbWebServices.i18n.getMessage("abreact","boolean.renderer.indeterminate.tooltip");}/**
 * <pre>
 * boolean.renderer.true.tooltip=True
 * </pre>
 */export function boolean_renderer_true_tooltip(){return AbWebServices.i18n.getMessage("abreact","boolean.renderer.true.tooltip");}/**
 * <pre>
 * booleanChoices.affirmative=Yes
 * </pre>
 */export function booleanChoices_affirmative(){return AbWebServices.i18n.getMessage("abreact","booleanChoices.affirmative");}/**
 * <pre>
 * booleanChoices.negative=No
 * </pre>
 */export function booleanChoices_negative(){return AbWebServices.i18n.getMessage("abreact","booleanChoices.negative");}/**
 * <pre>
 * booleanChoices.unspecified=Unset
 * </pre>
 */export function booleanChoices_unspecified(){return AbWebServices.i18n.getMessage("abreact","booleanChoices.unspecified");}/**
 * <pre>
 * booleanChoices.unspecifiedInParens=(Unset)
 * </pre>
 */export function booleanChoices_unspecifiedInParens(){return AbWebServices.i18n.getMessage("abreact","booleanChoices.unspecifiedInParens");}/**
 * <pre>
 * booleanChoices.unspecifiedTooltip=Value is unset
 * </pre>
 */export function booleanChoices_unspecifiedTooltip(){return AbWebServices.i18n.getMessage("abreact","booleanChoices.unspecifiedTooltip");}/**
 * <pre>
 * button.home.tooltip=Home
 * </pre>
 */export function button_home_tooltip(){return AbWebServices.i18n.getMessage("abreact","button.home.tooltip");}/**
 * <pre>
 * button.refresh.label=Refresh
 * </pre>
 */export function button_refresh_label(){return AbWebServices.i18n.getMessage("abreact","button.refresh.label");}/**
 * <pre>
 * button.refresh.tooltip=Refresh
 * </pre>
 */export function button_refresh_tooltip(){return AbWebServices.i18n.getMessage("abreact","button.refresh.tooltip");}/**
 * <pre>
 * button.toManagerPage.tooltip=Back up to Manager Page
 * </pre>
 */export function button_toManagerPage_tooltip(){return AbWebServices.i18n.getMessage("abreact","button.toManagerPage.tooltip");}/**
 * <pre>
 * childRecordsWarning.checkboxLabel=Don't show this message again
 * </pre>
 */export function childRecordsWarning_checkboxLabel(){return AbWebServices.i18n.getMessage("abreact","childRecordsWarning.checkboxLabel");}/**
 * <pre>
 * childRecordsWarning.message=The Expand all nodes button with asynchronous data will only expand nodes already retrieved from the server.
 * </pre>
 */export function childRecordsWarning_message(){return AbWebServices.i18n.getMessage("abreact","childRecordsWarning.message");}/**
 * <pre>
 * childRecordsWarning.title=Expand All Nodes
 * </pre>
 */export function childRecordsWarning_title(){return AbWebServices.i18n.getMessage("abreact","childRecordsWarning.title");}/**
 * <pre>
 * columnFiltersDlg.currentFilters=Current filters:
 * </pre>
 */export function columnFiltersDlg_currentFilters(){return AbWebServices.i18n.getMessage("abreact","columnFiltersDlg.currentFilters");}/**
 * <pre>
 * columnVisibilityDlg.closeButton=Close
 * </pre>
 */export function columnVisibilityDlg_closeButton(){return AbWebServices.i18n.getMessage("abreact","columnVisibilityDlg.closeButton");}/**
 * <pre>
 * columnVisibilityDlg.frozenColumnTooltip=Column cannot be hidden because it is frozen
 * </pre>
 */export function columnVisibilityDlg_frozenColumnTooltip(){return AbWebServices.i18n.getMessage("abreact","columnVisibilityDlg.frozenColumnTooltip");}/**
 * <pre>
 * columnVisibilityDlg.title=Show/Hide Columns
 * </pre>
 */export function columnVisibilityDlg_title(){return AbWebServices.i18n.getMessage("abreact","columnVisibilityDlg.title");}/**
 * <pre>
 * commentTree.delete.comment.title=Delete Comment
 * </pre>
 */export function commentTree_delete_comment_title(){return AbWebServices.i18n.getMessage("abreact","commentTree.delete.comment.title");}/**
 * <pre>
 * commentTree.delete.popup=Are you sure you want to delete this comment?
 * </pre>
 */export function commentTree_delete_popup(){return AbWebServices.i18n.getMessage("abreact","commentTree.delete.popup");}/**
 * <pre>
 * commentTree.empty.comment.popup=Comment text is empty. You cannot create empty comments.
 * </pre>
 */export function commentTree_empty_comment_popup(){return AbWebServices.i18n.getMessage("abreact","commentTree.empty.comment.popup");}/**
 * <pre>
 * commentTree.empty.comment.title=Empty Comment
 * </pre>
 */export function commentTree_empty_comment_title(){return AbWebServices.i18n.getMessage("abreact","commentTree.empty.comment.title");}/**
 * <pre>
 * configuredRouteLink.invalidConfiguration=Invalid link configuration for {0}
 * </pre>
 */export function configuredRouteLink_invalidConfiguration(arg0){return AbWebServices.i18n.getMessage("abreact","configuredRouteLink.invalidConfiguration",arg0);}/**
 * <pre>
 * configuredRoutePreview.missingParams=Route is missing required parameters
 * </pre>
 */export function configuredRoutePreview_missingParams(){return AbWebServices.i18n.getMessage("abreact","configuredRoutePreview.missingParams");}/**
 * <pre>
 * configuredRoutePreview.notFound=Route not found
 * </pre>
 */export function configuredRoutePreview_notFound(){return AbWebServices.i18n.getMessage("abreact","configuredRoutePreview.notFound");}/**
 * <pre>
 * # 'customComponentHost.' resources: Custom component host error messages
 * # Owner: see CustomComponentHost.tsx
 * customComponentHost.compactViewError=Error, cannot upload or download from a compact view host
 * </pre>
 */export function customComponentHost_compactViewError(){return AbWebServices.i18n.getMessage("abreact","customComponentHost.compactViewError");}/**
 * <pre>
 * customComponentHost.error=Error
 * </pre>
 */export function customComponentHost_error(){return AbWebServices.i18n.getMessage("abreact","customComponentHost.error");}/**
 * <pre>
 * customComponentHost.failedToLoad=Failed to load custom component, drag and drop the custom component directory here
 * </pre>
 */export function customComponentHost_failedToLoad(){return AbWebServices.i18n.getMessage("abreact","customComponentHost.failedToLoad");}/**
 * <pre>
 * dataGrid.columnHeader.ascendingSortIconTooltip=Ascending sort.
Click to sort descending.
 * </pre>
 */export function dataGrid_columnHeader_ascendingSortIconTooltip(){return AbWebServices.i18n.getMessage("abreact","dataGrid.columnHeader.ascendingSortIconTooltip");}/**
 * <pre>
 * dataGrid.columnHeader.descendingSortIconTooltip=Descending sort.
Click to sort ascending.
 * </pre>
 */export function dataGrid_columnHeader_descendingSortIconTooltip(){return AbWebServices.i18n.getMessage("abreact","dataGrid.columnHeader.descendingSortIconTooltip");}/**
 * <pre>
 * dataGrid.columnHeader.descendingSortResetIconTooltip=Descending sort.
Click to reset the sort.
 * </pre>
 */export function dataGrid_columnHeader_descendingSortResetIconTooltip(){return AbWebServices.i18n.getMessage("abreact","dataGrid.columnHeader.descendingSortResetIconTooltip");}/**
 * <pre>
 * dataGrid.columnHeader.sortableIconTooltip=Unsorted.
Click to sort ascending.
 * </pre>
 */export function dataGrid_columnHeader_sortableIconTooltip(){return AbWebServices.i18n.getMessage("abreact","dataGrid.columnHeader.sortableIconTooltip");}/**
 * <pre>
 * dataGridColumn.filterLabel=Filters for '{0}':
 * </pre>
 */export function dataGridColumn_filterLabel(arg0){return AbWebServices.i18n.getMessage("abreact","dataGridColumn.filterLabel",arg0);}/**
 * <pre>
 * dateInputArgRenderer.and=and
 * </pre>
 */export function dateInputArgRenderer_and(){return AbWebServices.i18n.getMessage("abreact","dateInputArgRenderer.and");}/**
 * <pre>
 * datePicker.date.placeholder=Enter a date
 * </pre>
 */export function datePicker_date_placeholder(){return AbWebServices.i18n.getMessage("abreact","datePicker.date.placeholder");}/**
 * <pre>
 * datePicker.datetime.placeholder=Enter a date and time
 * </pre>
 */export function datePicker_datetime_placeholder(){return AbWebServices.i18n.getMessage("abreact","datePicker.datetime.placeholder");}/**
 * <pre>
 * datePicker.example=Example: {0}
 * </pre>
 */export function datePicker_example(arg0){return AbWebServices.i18n.getMessage("abreact","datePicker.example",arg0);}/**
 * <pre>
 * datePicker.invalidDate.format=Invalid date format.
Please match format of {0}
 * </pre>
 */export function datePicker_invalidDate_format(arg0){return AbWebServices.i18n.getMessage("abreact","datePicker.invalidDate.format",arg0);}/**
 * <pre>
 * datePicker.invalidDate.range=Date out of range.
Must be between {0} and {1}
 * </pre>
 */export function datePicker_invalidDate_range(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","datePicker.invalidDate.range",arg0,arg1);}/**
 * <pre>
 * datePicker.monthButton.range=Month out of range
 * </pre>
 */export function datePicker_monthButton_range(){return AbWebServices.i18n.getMessage("abreact","datePicker.monthButton.range");}/**
 * <pre>
 * datePicker.monthInput.noItems=No matching months
 * </pre>
 */export function datePicker_monthInput_noItems(){return AbWebServices.i18n.getMessage("abreact","datePicker.monthInput.noItems");}/**
 * <pre>
 * datePicker.yearInput.noItems=No matching years
 * </pre>
 */export function datePicker_yearInput_noItems(){return AbWebServices.i18n.getMessage("abreact","datePicker.yearInput.noItems");}/**
 * <pre>
 * decimalInput.invalidDecimal.format=Invalid decimal format.
 * </pre>
 */export function decimalInput_invalidDecimal_format(){return AbWebServices.i18n.getMessage("abreact","decimalInput.invalidDecimal.format");}/**
 * <pre>
 * decimalInput.invalidDecimal.range=Decimal out of range.
 * </pre>
 */export function decimalInput_invalidDecimal_range(){return AbWebServices.i18n.getMessage("abreact","decimalInput.invalidDecimal.range");}/**
 * <pre>
 * decimalInput.precision=Number limited to {0} decimal places.
 * </pre>
 */export function decimalInput_precision(arg0){return AbWebServices.i18n.getMessage("abreact","decimalInput.precision",arg0);}/**
 * <pre>
 * diagram.legend.defaultTitle=Legend
 * </pre>
 */export function diagram_legend_defaultTitle(){return AbWebServices.i18n.getMessage("abreact","diagram.legend.defaultTitle");}/**
 * <pre>
 * diagram.node.collapse=Collapse
 * </pre>
 */export function diagram_node_collapse(){return AbWebServices.i18n.getMessage("abreact","diagram.node.collapse");}/**
 * <pre>
 * diagram.node.expand=Expand
 * </pre>
 */export function diagram_node_expand(){return AbWebServices.i18n.getMessage("abreact","diagram.node.expand");}/**
 * <pre>
 * # Context: "The dragged item, whose category has label {0} and whose value type has label {1}, is not assignable to this operand"
 * # Examples: "[Reference String] is not assignable", "[Literal Number] is not assignable"
 * dragDrop.machine.dragOverValidationErrorTooltipContents.categoryAndValueTypeMismatch=[{0} {1}{2}] is not assignable to [{3} {4}{5}]
 * </pre>
 */export function dragDrop_machine_dragOverValidationErrorTooltipContents_categoryAndValueTypeMismatch(arg0,arg1,arg2,arg3,arg4,arg5){return AbWebServices.i18n.getMessage("abreact","dragDrop.machine.dragOverValidationErrorTooltipContents.categoryAndValueTypeMismatch",arg0,arg1,arg2,arg3,arg4,arg5);}/**
 * <pre>
 * # Context: "The dragged item, whose category has label {0}, is not assignable to this operand"
 * # Examples: "Reference is not assignable", "Literal is not assignable", "Named Constant is not assignable"
 * dragDrop.machine.dragOverValidationErrorTooltipContents.categoryMismatch={0} is not assignable
 * </pre>
 */export function dragDrop_machine_dragOverValidationErrorTooltipContents_categoryMismatch(arg0){return AbWebServices.i18n.getMessage("abreact","dragDrop.machine.dragOverValidationErrorTooltipContents.categoryMismatch",arg0);}/**
 * <pre>
 * # Context: "The  dragged item, whose cardinality is single, is not assignable to this operand"
 * dragDrop.machine.dragOverValidationErrorTooltipContents.expectedMultiValued=Cardinality single is not assignable
 * </pre>
 */export function dragDrop_machine_dragOverValidationErrorTooltipContents_expectedMultiValued(){return AbWebServices.i18n.getMessage("abreact","dragDrop.machine.dragOverValidationErrorTooltipContents.expectedMultiValued");}/**
 * <pre>
 * # Context: "The dragged item, whose cardinality is multiple, is not assignable to this operand"
 * dragDrop.machine.dragOverValidationErrorTooltipContents.expectedSingleValued=Cardinality multiple is not assignable
 * </pre>
 */export function dragDrop_machine_dragOverValidationErrorTooltipContents_expectedSingleValued(){return AbWebServices.i18n.getMessage("abreact","dragDrop.machine.dragOverValidationErrorTooltipContents.expectedSingleValued");}/**
 * <pre>
 * # Context: "The framework is unable to resolve a domain category for the dragged item"
 * dragDrop.machine.dragOverValidationErrorTooltipContents.noResolvedCategory=Unable to resolve a domain category
 * </pre>
 */export function dragDrop_machine_dragOverValidationErrorTooltipContents_noResolvedCategory(){return AbWebServices.i18n.getMessage("abreact","dragDrop.machine.dragOverValidationErrorTooltipContents.noResolvedCategory");}/**
 * <pre>
 * # Context: "The framework is unable to resolve a domain value type for the dragged item"
 * dragDrop.machine.dragOverValidationErrorTooltipContents.noResolvedValueType=Unable to resolve a domain value type
 * </pre>
 */export function dragDrop_machine_dragOverValidationErrorTooltipContents_noResolvedValueType(){return AbWebServices.i18n.getMessage("abreact","dragDrop.machine.dragOverValidationErrorTooltipContents.noResolvedValueType");}/**
 * <pre>
 * editablePanel.cancelFailureMessage=Failed to cancel
 * </pre>
 */export function editablePanel_cancelFailureMessage(){return AbWebServices.i18n.getMessage("abreact","editablePanel.cancelFailureMessage");}/**
 * <pre>
 * editablePanel.saveFailureMessage=Failed to save
 * </pre>
 */export function editablePanel_saveFailureMessage(){return AbWebServices.i18n.getMessage("abreact","editablePanel.saveFailureMessage");}/**
 * <pre>
 * error.causedBy=Caused By:
 * </pre>
 */export function error_causedBy(){return AbWebServices.i18n.getMessage("abreact","error.causedBy");}/**
 * <pre>
 * error.clientCallStack=Client stack:
 * </pre>
 */export function error_clientCallStack(){return AbWebServices.i18n.getMessage("abreact","error.clientCallStack");}/**
 * <pre>
 * error.clipboard.divider=---------------------------------------------------------------------
 * </pre>
 */export function error_clipboard_divider(){return AbWebServices.i18n.getMessage("abreact","error.clipboard.divider");}/**
 * <pre>
 * error.clipboard.number=Error #
 * </pre>
 */export function error_clipboard_number(){return AbWebServices.i18n.getMessage("abreact","error.clipboard.number");}/**
 * <pre>
 * error.date_time=Date/Time:
 * </pre>
 */export function error_dateTime(){return AbWebServices.i18n.getMessage("abreact","error.date_time");}/**
 * <pre>
 * error.detailButton.label=Details
 * </pre>
 */export function error_detailButton_label(){return AbWebServices.i18n.getMessage("abreact","error.detailButton.label");}/**
 * <pre>
 * error.detailsDialogTitle=Error Details:
 * </pre>
 */export function error_detailsDialogTitle(){return AbWebServices.i18n.getMessage("abreact","error.detailsDialogTitle");}/**
 * <pre>
 * error.dialogTitle=Unexpected Error
 * </pre>
 */export function error_dialogTitle(){return AbWebServices.i18n.getMessage("abreact","error.dialogTitle");}/**
 * <pre>
 * error.label=Error:
 * </pre>
 */export function error_label(){return AbWebServices.i18n.getMessage("abreact","error.label");}/**
 * <pre>
 * error.noSupportInformation=Cannot show support information.
 * </pre>
 */export function error_noSupportInformation(){return AbWebServices.i18n.getMessage("abreact","error.noSupportInformation");}/**
 * <pre>
 * error.rpc_url=RPC:
 * </pre>
 */export function error_rpcUrl(){return AbWebServices.i18n.getMessage("abreact","error.rpc_url");}/**
 * <pre>
 * error.showDetails=Show Error Details
 * </pre>
 */export function error_showDetails(){return AbWebServices.i18n.getMessage("abreact","error.showDetails");}/**
 * <pre>
 * error.supportInstructions=For assistance, click Package for Support and share the package with Ab Initio Support.
 * </pre>
 */export function error_supportInstructions(){return AbWebServices.i18n.getMessage("abreact","error.supportInstructions");}/**
 * <pre>
 * error.unexpectedInternalError=Unexpected error
 * </pre>
 */export function error_unexpectedInternalError(){return AbWebServices.i18n.getMessage("abreact","error.unexpectedInternalError");}/**
 * <pre>
 * errorBoundary.details.buttonLabel=Details...
 * </pre>
 */export function errorBoundary_details_buttonLabel(){return AbWebServices.i18n.getMessage("abreact","errorBoundary.details.buttonLabel");}/**
 * <pre>
 * # ErrorBoundary that displayed react rendering errors (also used by RouteErrorBoundary)
 * errorBoundary.title=Rendering Error
 * </pre>
 */export function errorBoundary_title(){return AbWebServices.i18n.getMessage("abreact","errorBoundary.title");}/**
 * <pre>
 * errorBoundary.tryRedraw.buttonLabel=Try to redraw
 * </pre>
 */export function errorBoundary_tryRedraw_buttonLabel(){return AbWebServices.i18n.getMessage("abreact","errorBoundary.tryRedraw.buttonLabel");}/**
 * <pre>
 * errorBoundary.tryRedraw.buttonTooltip=Area could not be rendered successfully.  Click to attempt redraw.
 * </pre>
 */export function errorBoundary_tryRedraw_buttonTooltip(){return AbWebServices.i18n.getMessage("abreact","errorBoundary.tryRedraw.buttonTooltip");}/**
 * <pre>
 * expression.advanced.options=Advanced Options
 * </pre>
 */export function expression_advanced_options(){return AbWebServices.i18n.getMessage("abreact","expression.advanced.options");}/**
 * <pre>
 * expression.debug.rowDetails=Row Details
 * </pre>
 */export function expression_debug_rowDetails(){return AbWebServices.i18n.getMessage("abreact","expression.debug.rowDetails");}/**
 * <pre>
 * expression.editor.action.else.prefix=else
 * </pre>
 */export function expression_editor_action_else_prefix(){return AbWebServices.i18n.getMessage("abreact","expression.editor.action.else.prefix");}/**
 * <pre>
 * expression.formula.click.to.create=Click to create
 * </pre>
 */export function expression_formula_click_to_create(){return AbWebServices.i18n.getMessage("abreact","expression.formula.click.to.create");}/**
 * <pre>
 * expression.formula.label=Formula
 * </pre>
 */export function expression_formula_label(){return AbWebServices.i18n.getMessage("abreact","expression.formula.label");}/**
 * <pre>
 * expression.formula.symbol=f(x)
 * </pre>
 */export function expression_formula_symbol(){return AbWebServices.i18n.getMessage("abreact","expression.formula.symbol");}/**
 * <pre>
 * expression.formula.value.editor.done=Done
 * </pre>
 */export function expression_formula_value_editor_done(){return AbWebServices.i18n.getMessage("abreact","expression.formula.value.editor.done");}/**
 * <pre>
 * expression.function.inputs.dialog.label=Calculation Function
 * </pre>
 */export function expression_function_inputs_dialog_label(){return AbWebServices.i18n.getMessage("abreact","expression.function.inputs.dialog.label");}/**
 * <pre>
 * expression.function.label=Function
 * </pre>
 */export function expression_function_label(){return AbWebServices.i18n.getMessage("abreact","expression.function.label");}/**
 * <pre>
 * expression.function.noInputAvailable=Input not available
 * </pre>
 */export function expression_function_noInputAvailable(){return AbWebServices.i18n.getMessage("abreact","expression.function.noInputAvailable");}/**
 * <pre>
 * expression.incomplete.condition.tooltip=The condition is incomplete.
 * </pre>
 */export function expression_incomplete_condition_tooltip(){return AbWebServices.i18n.getMessage("abreact","expression.incomplete.condition.tooltip");}/**
 * <pre>
 * expression.incomplete.function.tooltip=The function is incomplete.
 * </pre>
 */export function expression_incomplete_function_tooltip(){return AbWebServices.i18n.getMessage("abreact","expression.incomplete.function.tooltip");}/**
 * <pre>
 * expression.not.specified=Not Specified
 * </pre>
 */export function expression_not_specified(){return AbWebServices.i18n.getMessage("abreact","expression.not.specified");}/**
 * <pre>
 * expression.operand.value.boolean.prompt=Select a boolean...
 * </pre>
 */export function expression_operand_value_boolean_prompt(){return AbWebServices.i18n.getMessage("abreact","expression.operand.value.boolean.prompt");}/**
 * <pre>
 * expression.operand.value.decimal.prompt=Enter a number
 * </pre>
 */export function expression_operand_value_decimal_prompt(){return AbWebServices.i18n.getMessage("abreact","expression.operand.value.decimal.prompt");}/**
 * <pre>
 * expression.operand.value.enum.prompt=Select...
 * </pre>
 */export function expression_operand_value_enum_prompt(){return AbWebServices.i18n.getMessage("abreact","expression.operand.value.enum.prompt");}/**
 * <pre>
 * expression.operand.value.integer.prompt=Enter a whole number
 * </pre>
 */export function expression_operand_value_integer_prompt(){return AbWebServices.i18n.getMessage("abreact","expression.operand.value.integer.prompt");}/**
 * <pre>
 * expression.operand.value.string.prompt=Enter a text value
 * </pre>
 */export function expression_operand_value_string_prompt(){return AbWebServices.i18n.getMessage("abreact","expression.operand.value.string.prompt");}/**
 * <pre>
 * expression.operator.deprecated={0} (deprecated)
 * </pre>
 */export function expression_operator_deprecated(arg0){return AbWebServices.i18n.getMessage("abreact","expression.operator.deprecated",arg0);}/**
 * <pre>
 * expression.operator.none=None
 * </pre>
 */export function expression_operator_none(){return AbWebServices.i18n.getMessage("abreact","expression.operator.none");}/**
 * <pre>
 * expression.operator.value.prompt=Choose One
 * </pre>
 */export function expression_operator_value_prompt(){return AbWebServices.i18n.getMessage("abreact","expression.operator.value.prompt");}/**
 * <pre>
 * expression.readonly.clipboard.success=Formatted expression copied to clipboard
 * </pre>
 */export function expression_readonly_clipboard_success(){return AbWebServices.i18n.getMessage("abreact","expression.readonly.clipboard.success");}/**
 * <pre>
 * # 'expressionEditor.' resources: Expression editor UI labels
 * # Owner: see expression/ui/editor/
 * expressionEditor.optionalArguments=Optional Arguments
 * </pre>
 */export function expressionEditor_optionalArguments(){return AbWebServices.i18n.getMessage("abreact","expressionEditor.optionalArguments");}/**
 * <pre>
 * expressionEditor.selectedOperatorInfo=Selected Operator Info:
 * </pre>
 */export function expressionEditor_selectedOperatorInfo(){return AbWebServices.i18n.getMessage("abreact","expressionEditor.selectedOperatorInfo");}/**
 * <pre>
 * failedToFetchErrorDlg.message=Could not connect to {0}. Please contact your Ab Initio accounts team or support@abinitio.com.
 * </pre>
 */export function failedToFetchErrorDlg_message(arg0){return AbWebServices.i18n.getMessage("abreact","failedToFetchErrorDlg.message",arg0);}/**
 * <pre>
 * failedToFetchErrorDlg.title={0} Connection Failure
 * </pre>
 */export function failedToFetchErrorDlg_title(arg0){return AbWebServices.i18n.getMessage("abreact","failedToFetchErrorDlg.title",arg0);}/**
 * <pre>
 * # Fields
 * field.attributeRequiredError="{0}" must have a value
 * </pre>
 */export function field_attributeRequiredError(arg0){return AbWebServices.i18n.getMessage("abreact","field.attributeRequiredError",arg0);}/**
 * <pre>
 * field.baselineValueName=Published Value
 * </pre>
 */export function field_baselineValueName(){return AbWebServices.i18n.getMessage("abreact","field.baselineValueName");}/**
 * <pre>
 * field.changeSetValueName=Changeset Value
 * </pre>
 */export function field_changeSetValueName(){return AbWebServices.i18n.getMessage("abreact","field.changeSetValueName");}/**
 * <pre>
 * field.decimalFormatError="{0}" must be a decimal value
 * </pre>
 */export function field_decimalFormatError(arg0){return AbWebServices.i18n.getMessage("abreact","field.decimalFormatError",arg0);}/**
 * <pre>
 * field.nullPreviousValue=Previous value was not set
 * </pre>
 */export function field_nullPreviousValue(){return AbWebServices.i18n.getMessage("abreact","field.nullPreviousValue");}/**
 * <pre>
 * field.saveError=Cannot save due to validation errors
 * </pre>
 */export function field_saveError(){return AbWebServices.i18n.getMessage("abreact","field.saveError");}/**
 * <pre>
 * field.serverValueName=Previous Value
 * </pre>
 */export function field_serverValueName(){return AbWebServices.i18n.getMessage("abreact","field.serverValueName");}/**
 * <pre>
 * field.unexpectedSaveError=Save failed due to unexpected server error
 * </pre>
 */export function field_unexpectedSaveError(){return AbWebServices.i18n.getMessage("abreact","field.unexpectedSaveError");}/**
 * <pre>
 * field.unexpectedValidationError=Unexpected error during validation
 * </pre>
 */export function field_unexpectedValidationError(){return AbWebServices.i18n.getMessage("abreact","field.unexpectedValidationError");}/**
 * <pre>
 * # Used in generic filtering components. Nothing found.
 * filter.noResults=No matching results
 * </pre>
 */export function filter_noResults(){return AbWebServices.i18n.getMessage("abreact","filter.noResults");}/**
 * <pre>
 * filterValuePillBox.activeFiltersLabel=Filters:
 * </pre>
 */export function filterValuePillBox_activeFiltersLabel(){return AbWebServices.i18n.getMessage("abreact","filterValuePillBox.activeFiltersLabel");}/**
 * <pre>
 * filterValuePillBox.clearAll=Clear All
 * </pre>
 */export function filterValuePillBox_clearAll(){return AbWebServices.i18n.getMessage("abreact","filterValuePillBox.clearAll");}/**
 * <pre>
 * filterValuePillBox.clearAllTooltip=Clear all filters
 * </pre>
 */export function filterValuePillBox_clearAllTooltip(){return AbWebServices.i18n.getMessage("abreact","filterValuePillBox.clearAllTooltip");}/**
 * <pre>
 * filterValuePillBox.containsTextLabel=Contains text
 * </pre>
 */export function filterValuePillBox_containsTextLabel(){return AbWebServices.i18n.getMessage("abreact","filterValuePillBox.containsTextLabel");}/**
 * <pre>
 * filter_text_input.empty_text=Filter...
 * </pre>
 */export function filterTextInput_emptyText(){return AbWebServices.i18n.getMessage("abreact","filter_text_input.empty_text");}/**
 * <pre>
 * findTool.findNext=Find Next (F3)
 * </pre>
 */export function findTool_findNext(){return AbWebServices.i18n.getMessage("abreact","findTool.findNext");}/**
 * <pre>
 * findTool.findPrevious=Find Previous (Shift+F3)
 * </pre>
 */export function findTool_findPrevious(){return AbWebServices.i18n.getMessage("abreact","findTool.findPrevious");}/**
 * <pre>
 * findTool.findTextTooltip=Find text
 * </pre>
 */export function findTool_findTextTooltip(){return AbWebServices.i18n.getMessage("abreact","findTool.findTextTooltip");}/**
 * <pre>
 * findTool.selectionOnlyLabel=Selection only
 * </pre>
 */export function findTool_selectionOnlyLabel(){return AbWebServices.i18n.getMessage("abreact","findTool.selectionOnlyLabel");}/**
 * <pre>
 * findTool.selectionOnlyTooltip=Search in selection region only
 * </pre>
 */export function findTool_selectionOnlyTooltip(){return AbWebServices.i18n.getMessage("abreact","findTool.selectionOnlyTooltip");}/**
 * <pre>
 * # 'form.' resources: AbForm component
 * # Owner: see form/AbForm.tsx
 * form.required=Required
 * </pre>
 */export function form_required(){return AbWebServices.i18n.getMessage("abreact","form.required");}/**
 * <pre>
 * # Gateway Error (nginx) is currently portal-specific, but can be shown during login (first productInfo request) when
 * # only abreact services have been initialized
 * gatewayErrorDlg.message=Could not start {0}. Please contact your Ab Initio accounts team or support@abinitio.com.
 * </pre>
 */export function gatewayErrorDlg_message(arg0){return AbWebServices.i18n.getMessage("abreact","gatewayErrorDlg.message",arg0);}/**
 * <pre>
 * gatewayErrorDlg.title={0} Startup Failure
 * </pre>
 */export function gatewayErrorDlg_title(arg0){return AbWebServices.i18n.getMessage("abreact","gatewayErrorDlg.title",arg0);}/**
 * <pre>
 * genericColumnSortDlg.addSort=Add a sort
 * </pre>
 */export function genericColumnSortDlg_addSort(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.addSort");}/**
 * <pre>
 * genericColumnSortDlg.ascending=Ascending
 * </pre>
 */export function genericColumnSortDlg_ascending(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.ascending");}/**
 * <pre>
 * genericColumnSortDlg.changeColumnTooltip=Change column
 * </pre>
 */export function genericColumnSortDlg_changeColumnTooltip(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.changeColumnTooltip");}/**
 * <pre>
 * genericColumnSortDlg.clearAllLabel=Clear All
 * </pre>
 */export function genericColumnSortDlg_clearAllLabel(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.clearAllLabel");}/**
 * <pre>
 * genericColumnSortDlg.clearAllTooltip=Remove all sorts
 * </pre>
 */export function genericColumnSortDlg_clearAllTooltip(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.clearAllTooltip");}/**
 * <pre>
 * genericColumnSortDlg.descending=Descending
 * </pre>
 */export function genericColumnSortDlg_descending(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.descending");}/**
 * <pre>
 * genericColumnSortDlg.dragToReorder=Drag this item up or down to change the order of the sort
 * </pre>
 */export function genericColumnSortDlg_dragToReorder(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.dragToReorder");}/**
 * <pre>
 * genericColumnSortDlg.noSortLabel=Click the add sort button to add a sort
 * </pre>
 */export function genericColumnSortDlg_noSortLabel(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.noSortLabel");}/**
 * <pre>
 * genericColumnSortDlg.removeSort=Remove this sort
 * </pre>
 */export function genericColumnSortDlg_removeSort(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.removeSort");}/**
 * <pre>
 * genericColumnSortDlg.resetSort=Reset sort
 * </pre>
 */export function genericColumnSortDlg_resetSort(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.resetSort");}/**
 * <pre>
 * genericColumnSortDlg.sortByLabel1=Sort by
 * </pre>
 */export function genericColumnSortDlg_sortByLabel1(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.sortByLabel1");}/**
 * <pre>
 * genericColumnSortDlg.sortByLabelN=Then by
 * </pre>
 */export function genericColumnSortDlg_sortByLabelN(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.sortByLabelN");}/**
 * <pre>
 * genericColumnSortDlg.title=Manage Sorting
 * </pre>
 */export function genericColumnSortDlg_title(){return AbWebServices.i18n.getMessage("abreact","genericColumnSortDlg.title");}/**
 * <pre>
 * genericGrid.addColumns=Add Columns
 * </pre>
 */export function genericGrid_addColumns(){return AbWebServices.i18n.getMessage("abreact","genericGrid.addColumns");}/**
 * <pre>
 * genericGrid.addSortAscending=Add Sort Ascending
 * </pre>
 */export function genericGrid_addSortAscending(){return AbWebServices.i18n.getMessage("abreact","genericGrid.addSortAscending");}/**
 * <pre>
 * genericGrid.addSortDescending=Add Sort Descending
 * </pre>
 */export function genericGrid_addSortDescending(){return AbWebServices.i18n.getMessage("abreact","genericGrid.addSortDescending");}/**
 * <pre>
 * genericGrid.appendChildRowTooltip=Append child row
 * </pre>
 */export function genericGrid_appendChildRowTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.appendChildRowTooltip");}/**
 * <pre>
 * genericGrid.appendRowTooltip=Append row
 * </pre>
 */export function genericGrid_appendRowTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.appendRowTooltip");}/**
 * <pre>
 * genericGrid.ascendingSort=Ascending sort.
Click to reverse sort direction.
 * </pre>
 */export function genericGrid_ascendingSort(){return AbWebServices.i18n.getMessage("abreact","genericGrid.ascendingSort");}/**
 * <pre>
 * genericGrid.ascendingSortNoModify=Ascending sort.
Further sorting for this column is disabled.
 * </pre>
 */export function genericGrid_ascendingSortNoModify(){return AbWebServices.i18n.getMessage("abreact","genericGrid.ascendingSortNoModify");}/**
 * <pre>
 * genericGrid.asyncFindTooltip=Find text in grid.
Note that with asynchronous hierarchical data, Find will not work in number or date columns where the nodes are not yet realized.
 * </pre>
 */export function genericGrid_asyncFindTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.asyncFindTooltip");}/**
 * <pre>
 * genericGrid.clear=Clear
 * </pre>
 */export function genericGrid_clear(){return AbWebServices.i18n.getMessage("abreact","genericGrid.clear");}/**
 * <pre>
 * genericGrid.collapseAllNodesTooltip=Collapse all nodes
 * </pre>
 */export function genericGrid_collapseAllNodesTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.collapseAllNodesTooltip");}/**
 * <pre>
 * genericGrid.copyAsPlainText=Copy as plain text
 * </pre>
 */export function genericGrid_copyAsPlainText(){return AbWebServices.i18n.getMessage("abreact","genericGrid.copyAsPlainText");}/**
 * <pre>
 * genericGrid.copyAsPlainTextTooltip=Copies the selected cell contents as plain text
 * </pre>
 */export function genericGrid_copyAsPlainTextTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.copyAsPlainTextTooltip");}/**
 * <pre>
 * genericGrid.copyTooltip=Copy (Ctrl+C)
 * </pre>
 */export function genericGrid_copyTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.copyTooltip");}/**
 * <pre>
 * genericGrid.deleteRowsTooltip=Delete selected items (Delete)
 * </pre>
 */export function genericGrid_deleteRowsTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.deleteRowsTooltip");}/**
 * <pre>
 * genericGrid.descendingSort=Descending sort.
Click to reverse sort direction.
 * </pre>
 */export function genericGrid_descendingSort(){return AbWebServices.i18n.getMessage("abreact","genericGrid.descendingSort");}/**
 * <pre>
 * genericGrid.descendingSortNoModify=Descending sort.
Further sorting for this column is disabled.
 * </pre>
 */export function genericGrid_descendingSortNoModify(){return AbWebServices.i18n.getMessage("abreact","genericGrid.descendingSortNoModify");}/**
 * <pre>
 * genericGrid.downloadToSpreadsheetLabel=Download to Spreadsheet
 * </pre>
 */export function genericGrid_downloadToSpreadsheetLabel(){return AbWebServices.i18n.getMessage("abreact","genericGrid.downloadToSpreadsheetLabel");}/**
 * <pre>
 * genericGrid.editInputsLabel=Edit Inputs
 * </pre>
 */export function genericGrid_editInputsLabel(){return AbWebServices.i18n.getMessage("abreact","genericGrid.editInputsLabel");}/**
 * <pre>
 * genericGrid.editInputsTooltip=Edit input parameter values used in this grid
 * </pre>
 */export function genericGrid_editInputsTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.editInputsTooltip");}/**
 * <pre>
 * genericGrid.executingFind=Executing Find...
 * </pre>
 */export function genericGrid_executingFind(){return AbWebServices.i18n.getMessage("abreact","genericGrid.executingFind");}/**
 * <pre>
 * genericGrid.expandAllNodesTooltip=Expand all nodes
 * </pre>
 */export function genericGrid_expandAllNodesTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.expandAllNodesTooltip");}/**
 * <pre>
 * genericGrid.filterLabel=Filter
 * </pre>
 */export function genericGrid_filterLabel(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filterLabel");}/**
 * <pre>
 * genericGrid.filterTooltip=Click to add a filter
 * </pre>
 */export function genericGrid_filterTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filterTooltip");}/**
 * <pre>
 * genericGrid.filters=Filters for {0}
 * </pre>
 */export function genericGrid_filters(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.filters",arg0);}/**
 * <pre>
 * genericGrid.filtersLabel=Filters ({0})
 * </pre>
 */export function genericGrid_filtersLabel(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.filtersLabel",arg0);}/**
 * <pre>
 * genericGrid.filtersPanelHeaderLabel=Filters
 * </pre>
 */export function genericGrid_filtersPanelHeaderLabel(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filtersPanelHeaderLabel");}/**
 * <pre>
 * genericGrid.filtersTooltip=Click to toggle visibility of Filter Bar
 * </pre>
 */export function genericGrid_filtersTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filtersTooltip");}/**
 * <pre>
 * genericGrid.filtersTooltipDisabled=Click to toggle visibility of Filter Bar
Filtering UI is currently disabled.
You can view existing filters, but you cannot edit or add/delete them.
 * </pre>
 */export function genericGrid_filtersTooltipDisabled(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filtersTooltipDisabled");}/**
 * <pre>
 * genericGrid.filtersTooltipDisabledEditMode=Filtering is disabled while editing
 * </pre>
 */export function genericGrid_filtersTooltipDisabledEditMode(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filtersTooltipDisabledEditMode");}/**
 * <pre>
 * genericGrid.filtersTooltipDisabledUnknown=Filtering is not allowed in this context
 * </pre>
 */export function genericGrid_filtersTooltipDisabledUnknown(){return AbWebServices.i18n.getMessage("abreact","genericGrid.filtersTooltipDisabledUnknown");}/**
 * <pre>
 * genericGrid.find=Find
 * </pre>
 */export function genericGrid_find(){return AbWebServices.i18n.getMessage("abreact","genericGrid.find");}/**
 * <pre>
 * genericGrid.findTooltip=Find text in grid...
 * </pre>
 */export function genericGrid_findTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.findTooltip");}/**
 * <pre>
 * genericGrid.hideColumn=Hide column
 * </pre>
 */export function genericGrid_hideColumn(){return AbWebServices.i18n.getMessage("abreact","genericGrid.hideColumn");}/**
 * <pre>
 * genericGrid.indentRowsTooltip=Indent rows (change parentage) (Ctrl + arrow right)
 * </pre>
 */export function genericGrid_indentRowsTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.indentRowsTooltip");}/**
 * <pre>
 * genericGrid.infoIconLabel={0} rows
 * </pre>
 */export function genericGrid_infoIconLabel(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.infoIconLabel",arg0);}/**
 * <pre>
 * genericGrid.infoIconPlusLabel={0}+ rows
 * </pre>
 */export function genericGrid_infoIconPlusLabel(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.infoIconPlusLabel",arg0);}/**
 * <pre>
 * genericGrid.infoIconPlusTooltipNoSort=More rows available.
Sorting is disabled.
Consider adding filters to refine your results.
 * </pre>
 */export function genericGrid_infoIconPlusTooltipNoSort(){return AbWebServices.i18n.getMessage("abreact","genericGrid.infoIconPlusTooltipNoSort");}/**
 * <pre>
 * genericGrid.infoIconPlusTooltipNoSort2=More data available.
Sorting is disabled.
Consider adding filters to refine your results.
 * </pre>
 */export function genericGrid_infoIconPlusTooltipNoSort2(){return AbWebServices.i18n.getMessage("abreact","genericGrid.infoIconPlusTooltipNoSort2");}/**
 * <pre>
 * genericGrid.insertRowsBelowTooltip=Insert rows below (Ctrl+Insert)
 * </pre>
 */export function genericGrid_insertRowsBelowTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.insertRowsBelowTooltip");}/**
 * <pre>
 * genericGrid.insertRowsTooltip=Insert rows above (Insert)
 * </pre>
 */export function genericGrid_insertRowsTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.insertRowsTooltip");}/**
 * <pre>
 * genericGrid.invalidColumnFiltersWarning=Invalid filter specification.
Correct the error and try again.
 * </pre>
 */export function genericGrid_invalidColumnFiltersWarning(){return AbWebServices.i18n.getMessage("abreact","genericGrid.invalidColumnFiltersWarning");}/**
 * <pre>
 * genericGrid.invalidSelection=Cannot copy because the selection range is not valid:
{0}
 * </pre>
 */export function genericGrid_invalidSelection(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.invalidSelection",arg0);}/**
 * <pre>
 * genericGrid.manageColumns=Show/Hide Columns
 * </pre>
 */export function genericGrid_manageColumns(){return AbWebServices.i18n.getMessage("abreact","genericGrid.manageColumns");}/**
 * <pre>
 * genericGrid.manageSortLabel=Sort
 * </pre>
 */export function genericGrid_manageSortLabel(){return AbWebServices.i18n.getMessage("abreact","genericGrid.manageSortLabel");}/**
 * <pre>
 * genericGrid.moreOptions=More Options
 * </pre>
 */export function genericGrid_moreOptions(){return AbWebServices.i18n.getMessage("abreact","genericGrid.moreOptions");}/**
 * <pre>
 * genericGrid.noFindMatch=Text '{0}' not found
 * </pre>
 */export function genericGrid_noFindMatch(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.noFindMatch",arg0);}/**
 * <pre>
 * genericGrid.nothingToFind=Nothing to find
 * </pre>
 */export function genericGrid_nothingToFind(){return AbWebServices.i18n.getMessage("abreact","genericGrid.nothingToFind");}/**
 * <pre>
 * genericGrid.outdentRowsTooltip=Outdent rows (change parentage) (Ctrl + arrow left)
 * </pre>
 */export function genericGrid_outdentRowsTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.outdentRowsTooltip");}/**
 * <pre>
 * genericGrid.pasteTooltip=Paste (Ctrl+V)
 * </pre>
 */export function genericGrid_pasteTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.pasteTooltip");}/**
 * <pre>
 * genericGrid.removeSort=Remove Sort
 * </pre>
 */export function genericGrid_removeSort(){return AbWebServices.i18n.getMessage("abreact","genericGrid.removeSort");}/**
 * <pre>
 * genericGrid.reparentRowsTooltip=Move selected rows (change parentage)
 * </pre>
 */export function genericGrid_reparentRowsTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.reparentRowsTooltip");}/**
 * <pre>
 * genericGrid.resetSortTooltip=Reset sort
 * </pre>
 */export function genericGrid_resetSortTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.resetSortTooltip");}/**
 * <pre>
 * genericGrid.retrievingData=Retrieving data...
 * </pre>
 */export function genericGrid_retrievingData(){return AbWebServices.i18n.getMessage("abreact","genericGrid.retrievingData");}/**
 * <pre>
 * genericGrid.revertChangesTooltip=Revert changes to selected items (Ctrl+Z)
 * </pre>
 */export function genericGrid_revertChangesTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.revertChangesTooltip");}/**
 * <pre>
 * genericGrid.showColumnOnLeft=Show column '{0}' on left
 * </pre>
 */export function genericGrid_showColumnOnLeft(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.showColumnOnLeft",arg0);}/**
 * <pre>
 * genericGrid.showColumnOnRight=Show column '{0}' on right
 * </pre>
 */export function genericGrid_showColumnOnRight(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.showColumnOnRight",arg0);}/**
 * <pre>
 * genericGrid.sortAscending=Sort Ascending
 * </pre>
 */export function genericGrid_sortAscending(){return AbWebServices.i18n.getMessage("abreact","genericGrid.sortAscending");}/**
 * <pre>
 * genericGrid.sortDescending=Sort Descending
 * </pre>
 */export function genericGrid_sortDescending(){return AbWebServices.i18n.getMessage("abreact","genericGrid.sortDescending");}/**
 * <pre>
 * genericGrid.sortTooltip=Manage Sorting
 * </pre>
 */export function genericGrid_sortTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.sortTooltip");}/**
 * <pre>
 * genericGrid.stackedColumnHasSortTooltip=Stacked column has sorted columns.
Click to modify sorting.
 * </pre>
 */export function genericGrid_stackedColumnHasSortTooltip(){return AbWebServices.i18n.getMessage("abreact","genericGrid.stackedColumnHasSortTooltip");}/**
 * <pre>
 * genericGrid.unexpectedFindError=Unexpected error in Find
{0}
 * </pre>
 */export function genericGrid_unexpectedFindError(arg0){return AbWebServices.i18n.getMessage("abreact","genericGrid.unexpectedFindError",arg0);}/**
 * <pre>
 * genericGridColumnHeaderCellRenderer.addColumnFilter=Add column filter
 * </pre>
 */export function genericGridColumnHeaderCellRenderer_addColumnFilter(){return AbWebServices.i18n.getMessage("abreact","genericGridColumnHeaderCellRenderer.addColumnFilter");}/**
 * <pre>
 * genericGridColumnHeaderCellRenderer.filter=Filter...
 * </pre>
 */export function genericGridColumnHeaderCellRenderer_filter(){return AbWebServices.i18n.getMessage("abreact","genericGridColumnHeaderCellRenderer.filter");}/**
 * <pre>
 * genericGridColumnHeaderCellRenderer.freezeColumn=Freeze up to this column
 * </pre>
 */export function genericGridColumnHeaderCellRenderer_freezeColumn(){return AbWebServices.i18n.getMessage("abreact","genericGridColumnHeaderCellRenderer.freezeColumn");}/**
 * <pre>
 * genericGridColumnHeaderCellRenderer.removeFilter=Clear all filters
 * </pre>
 */export function genericGridColumnHeaderCellRenderer_removeFilter(){return AbWebServices.i18n.getMessage("abreact","genericGridColumnHeaderCellRenderer.removeFilter");}/**
 * <pre>
 * genericGridColumnHeaderCellRenderer.sortOptions=Sorting...
 * </pre>
 */export function genericGridColumnHeaderCellRenderer_sortOptions(){return AbWebServices.i18n.getMessage("abreact","genericGridColumnHeaderCellRenderer.sortOptions");}/**
 * <pre>
 * genericGridColumnHeaderCellRenderer.unfreezeColumns=Unfreeze columns
 * </pre>
 */export function genericGridColumnHeaderCellRenderer_unfreezeColumns(){return AbWebServices.i18n.getMessage("abreact","genericGridColumnHeaderCellRenderer.unfreezeColumns");}/**
 * <pre>
 * genericGridFilterBar.deleteAll=Delete All
 * </pre>
 */export function genericGridFilterBar_deleteAll(){return AbWebServices.i18n.getMessage("abreact","genericGridFilterBar.deleteAll");}/**
 * <pre>
 * genericGridMachine.cannotFreezeGroupedColumn=Cannot freeze this column because only non-grouped columns can be frozen.
 * </pre>
 */export function genericGridMachine_cannotFreezeGroupedColumn(){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotFreezeGroupedColumn");}/**
 * <pre>
 * genericGridMachine.cannotFreezeHiddenColumn=Cannot freeze this column because only visible columns can be frozen.
At least one column to the left is currently hidden.
 * </pre>
 */export function genericGridMachine_cannotFreezeHiddenColumn(){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotFreezeHiddenColumn");}/**
 * <pre>
 * genericGridMachine.cannotFreezeNoScrollableColumns=Cannot freeze this column because there must be at least one non-frozen column.
 * </pre>
 */export function genericGridMachine_cannotFreezeNoScrollableColumns(){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotFreezeNoScrollableColumns");}/**
 * <pre>
 * genericGridMachine.cannotFreezeNotTopLevel=Cannot freeze this column because only top-level non-grouped columns can be frozen.
 * </pre>
 */export function genericGridMachine_cannotFreezeNotTopLevel(){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotFreezeNotTopLevel");}/**
 * <pre>
 * genericGridMachine.cannotPasteReadonlyColumn=Cannot paste data into column '{0}' since it is not editable
 * </pre>
 */export function genericGridMachine_cannotPasteReadonlyColumn(arg0){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotPasteReadonlyColumn",arg0);}/**
 * <pre>
 * genericGridMachine.cannotPasteRowValue=Cannot paste data since at least one of the target rows cannot be modified
 * </pre>
 */export function genericGridMachine_cannotPasteRowValue(){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotPasteRowValue");}/**
 * <pre>
 * genericGridMachine.cannotPasteStackedColumn=Cannot paste data into stacked column '{0}' since it is not editable
 * </pre>
 */export function genericGridMachine_cannotPasteStackedColumn(arg0){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.cannotPasteStackedColumn",arg0);}/**
 * <pre>
 * genericGridMachine.pasteError=A paste error occurred. Some or all of the cells may not have been pasted.
 * </pre>
 */export function genericGridMachine_pasteError(){return AbWebServices.i18n.getMessage("abreact","genericGridMachine.pasteError");}/**
 * <pre>
 * gridFilter.defaultDisplayName=Filter {0}
 * </pre>
 */export function gridFilter_defaultDisplayName(arg0){return AbWebServices.i18n.getMessage("abreact","gridFilter.defaultDisplayName",arg0);}/**
 * <pre>
 * gridFilter.newFilterLabel=New Filter
 * </pre>
 */export function gridFilter_newFilterLabel(){return AbWebServices.i18n.getMessage("abreact","gridFilter.newFilterLabel");}/**
 * <pre>
 * gridFilter.noDescriptionLabel=No description
 * </pre>
 */export function gridFilter_noDescriptionLabel(){return AbWebServices.i18n.getMessage("abreact","gridFilter.noDescriptionLabel");}/**
 * <pre>
 * gridFilterEditor.readonlyCloseTooltip=Filtering UI is currently disabled.
No changes can be made to this filter.
 * </pre>
 */export function gridFilterEditor_readonlyCloseTooltip(){return AbWebServices.i18n.getMessage("abreact","gridFilterEditor.readonlyCloseTooltip");}/**
 * <pre>
 * # The following are options for what will be displayed in the title of the advanced About dialog itself.
 * # Different products should be using a different localized string but if one is not provided, this one
 * # is used.
 * # {0} is the product name
 * help_menu.item.about.label=About {0}
 * </pre>
 */export function helpMenu_item_about_label(arg0){return AbWebServices.i18n.getMessage("abreact","help_menu.item.about.label",arg0);}/**
 * <pre>
 * help_menu.item.aiAssistant.label=AI Help Assistant
 * </pre>
 */export function helpMenu_item_aiassistant_label(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.aiAssistant.label");}/**
 * <pre>
 * help_menu.item.cancelTracing=Cancel Tracing
 * </pre>
 */export function helpMenu_item_canceltracing(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.cancelTracing");}/**
 * <pre>
 * help_menu.item.configureServerTracing=Configure Tracing
 * </pre>
 */export function helpMenu_item_configureservertracing(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.configureServerTracing");}/**
 * <pre>
 * # PFS related labels in the help menu
 * help_menu.item.pfs.configurePfs.label=Configure Package for Support
 * </pre>
 */export function helpMenu_item_pfs_configurepfs_label(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.pfs.configurePfs.label");}/**
 * <pre>
 * help_menu.item.pfs.label=Package for Support
 * </pre>
 */export function helpMenu_item_pfs_label(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.pfs.label");}/**
 * <pre>
 * help_menu.item.platformStatus.label=Platform Status
 * </pre>
 */export function helpMenu_item_platformstatus_label(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.platformStatus.label");}/**
 * <pre>
 * help_menu.item.serverTracing.maxTraceSize.default=Use System Default
 * </pre>
 */export function helpMenu_item_servertracing_maxtracesize_default(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.serverTracing.maxTraceSize.default");}/**
 * <pre>
 * help_menu.item.serverTracing.maxTraceSize.label=Maximum trace file size:
 * </pre>
 */export function helpMenu_item_servertracing_maxtracesize_label(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.serverTracing.maxTraceSize.label");}/**
 * <pre>
 * help_menu.item.serverTracing.maxTraceSize.userSpecified=Use Specified Size (in MB):
 * </pre>
 */export function helpMenu_item_servertracing_maxtracesize_userspecified(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.serverTracing.maxTraceSize.userSpecified");}/**
 * <pre>
 * help_menu.item.serverTracing.title=Configure Tracing
 * </pre>
 */export function helpMenu_item_servertracing_title(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.serverTracing.title");}/**
 * <pre>
 * help_menu.item.startTracing=Start Tracing
 * </pre>
 */export function helpMenu_item_starttracing(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.startTracing");}/**
 * <pre>
 * help_menu.item.stopTracing=Stop Tracing
 * </pre>
 */export function helpMenu_item_stoptracing(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.stopTracing");}/**
 * <pre>
 * help_menu.item.traceOptions.helpText=Enter a ':'-separated selective list of subsystems, for example 'ALL=5:bizrules=6'.
 * </pre>
 */export function helpMenu_item_traceoptions_helptext(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.traceOptions.helpText");}/**
 * <pre>
 * help_menu.item.traceOptions.label=Tracing Options
 * </pre>
 */export function helpMenu_item_traceoptions_label(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.traceOptions.label");}/**
 * <pre>
 * help_menu.item.traceOptions.label.warning=Note: This option should only be used under the direction of Ab Initio Support
 * </pre>
 */export function helpMenu_item_traceoptions_label_warning(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.traceOptions.label.warning");}/**
 * <pre>
 * help_menu.item.traceOptions.title=Tracing Options
 * </pre>
 */export function helpMenu_item_traceoptions_title(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.traceOptions.title");}/**
 * <pre>
 * help_menu.item.traceOptions.toolTip=Enter a ':'-separated selective list of subsystems, for example 'ALL=5:bizrules=6'.
 * </pre>
 */export function helpMenu_item_traceoptions_tooltip(){return AbWebServices.i18n.getMessage("abreact","help_menu.item.traceOptions.toolTip");}/**
 * <pre>
 * iconPicker.noStyle=None
 * </pre>
 */export function iconPicker_noStyle(){return AbWebServices.i18n.getMessage("abreact","iconPicker.noStyle");}/**
 * <pre>
 * iconPicker.selectIcon=Select Icon
 * </pre>
 */export function iconPicker_selectIcon(){return AbWebServices.i18n.getMessage("abreact","iconPicker.selectIcon");}/**
 * <pre>
 * iconPicker.style=Style
 * </pre>
 */export function iconPicker_style(){return AbWebServices.i18n.getMessage("abreact","iconPicker.style");}/**
 * <pre>
 * imageFinder.noData=No data to display
 * </pre>
 */export function imageFinder_noData(){return AbWebServices.i18n.getMessage("abreact","imageFinder.noData");}/**
 * <pre>
 * imageFinder.selectImage=Select Image
 * </pre>
 */export function imageFinder_selectImage(){return AbWebServices.i18n.getMessage("abreact","imageFinder.selectImage");}/**
 * <pre>
 * # 'imageResizer.' resources: Markdown image resizer
 * # Owner: see input/markdown/ui/ImageResizer.tsx
 * imageResizer.addCaption=Add Caption
 * </pre>
 */export function imageResizer_addCaption(){return AbWebServices.i18n.getMessage("abreact","imageResizer.addCaption");}/**
 * <pre>
 * imageSearch.clearSearch=Clear search field
 * </pre>
 */export function imageSearch_clearSearch(){return AbWebServices.i18n.getMessage("abreact","imageSearch.clearSearch");}/**
 * <pre>
 * #0 - display name of an image
 * imageSearch.popupTitle={0} details
 * </pre>
 */export function imageSearch_popupTitle(arg0){return AbWebServices.i18n.getMessage("abreact","imageSearch.popupTitle",arg0);}/**
 * <pre>
 * imageSearch.searchPlaceholder=Search
 * </pre>
 */export function imageSearch_searchPlaceholder(){return AbWebServices.i18n.getMessage("abreact","imageSearch.searchPlaceholder");}/**
 * <pre>
 * imageSearch.searchResults=Displaying {0} images of {1}
 * </pre>
 */export function imageSearch_searchResults(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","imageSearch.searchResults",arg0,arg1);}/**
 * <pre>
 * infoBubble.showTooltip=Show info bubble
 * </pre>
 */export function infoBubble_showTooltip(){return AbWebServices.i18n.getMessage("abreact","infoBubble.showTooltip");}/**
 * <pre>
 * inputFilterBase.valueTypeBoolean=Boolean
 * </pre>
 */export function inputFilterBase_valueTypeBoolean(){return AbWebServices.i18n.getMessage("abreact","inputFilterBase.valueTypeBoolean");}/**
 * <pre>
 * inputFilterBase.valueTypeDate=Date
 * </pre>
 */export function inputFilterBase_valueTypeDate(){return AbWebServices.i18n.getMessage("abreact","inputFilterBase.valueTypeDate");}/**
 * <pre>
 * inputFilterBase.valueTypeDateTime=Datetime
 * </pre>
 */export function inputFilterBase_valueTypeDateTime(){return AbWebServices.i18n.getMessage("abreact","inputFilterBase.valueTypeDateTime");}/**
 * <pre>
 * inputFilterBase.valueTypeNumber=Number
 * </pre>
 */export function inputFilterBase_valueTypeNumber(){return AbWebServices.i18n.getMessage("abreact","inputFilterBase.valueTypeNumber");}/**
 * <pre>
 * inputFilterBase.valueTypeString=String
 * </pre>
 */export function inputFilterBase_valueTypeString(){return AbWebServices.i18n.getMessage("abreact","inputFilterBase.valueTypeString");}/**
 * <pre>
 * inputFilterParameterBase.requiredField=This field is required
 * </pre>
 */export function inputFilterParameterBase_requiredField(){return AbWebServices.i18n.getMessage("abreact","inputFilterParameterBase.requiredField");}/**
 * <pre>
 * inputParameterForm.dlgTitle=Edit Inputs
 * </pre>
 */export function inputParameterForm_dlgTitle(){return AbWebServices.i18n.getMessage("abreact","inputParameterForm.dlgTitle");}/**
 * <pre>
 * inputParameterForm.requiredInputsValidationError=All required inputs must be specified
 * </pre>
 */export function inputParameterForm_requiredInputsValidationError(){return AbWebServices.i18n.getMessage("abreact","inputParameterForm.requiredInputsValidationError");}/**
 * <pre>
 * inputParameterForm.title=Enter Inputs
 * </pre>
 */export function inputParameterForm_title(){return AbWebServices.i18n.getMessage("abreact","inputParameterForm.title");}/**
 * <pre>
 * inputParameterOperandValueEditor.dropdownPlaceholder=Select
 * </pre>
 */export function inputParameterOperandValueEditor_dropdownPlaceholder(){return AbWebServices.i18n.getMessage("abreact","inputParameterOperandValueEditor.dropdownPlaceholder");}/**
 * <pre>
 * inputParameterOperandValueEditor.invalidLabel=Invalid
 * </pre>
 */export function inputParameterOperandValueEditor_invalidLabel(){return AbWebServices.i18n.getMessage("abreact","inputParameterOperandValueEditor.invalidLabel");}/**
 * <pre>
 * inputParameterOperandValueEditor.invalidTooltip=No parameter defined that matches the required value type '{0}'
 * </pre>
 */export function inputParameterOperandValueEditor_invalidTooltip(arg0){return AbWebServices.i18n.getMessage("abreact","inputParameterOperandValueEditor.invalidTooltip",arg0);}/**
 * <pre>
 * integerInput.invalidInteger.format=Invalid integer format.
 * </pre>
 */export function integerInput_invalidInteger_format(){return AbWebServices.i18n.getMessage("abreact","integerInput.invalidInteger.format");}/**
 * <pre>
 * integerInput.invalidInteger.range=Integer out of range.
 * </pre>
 */export function integerInput_invalidInteger_range(){return AbWebServices.i18n.getMessage("abreact","integerInput.invalidInteger.range");}/**
 * <pre>
 * interactiveStars.rating.still.saving=Your last rating is still being saved...
 * </pre>
 */export function interactiveStars_rating_still_saving(){return AbWebServices.i18n.getMessage("abreact","interactiveStars.rating.still.saving");}/**
 * <pre>
 * invalidValue.greaterThan=Must be >= {0}.
 * </pre>
 */export function invalidValue_greaterThan(arg0){return AbWebServices.i18n.getMessage("abreact","invalidValue.greaterThan",arg0);}/**
 * <pre>
 * invalidValue.lessThan=Must be <= {0}.
 * </pre>
 */export function invalidValue_lessThan(arg0){return AbWebServices.i18n.getMessage("abreact","invalidValue.lessThan",arg0);}/**
 * <pre>
 * # These two are used when a user inputs a number that is too big for JS to handle (not a normal bound)
 * invalidValue.number.tooBig=Number is too big.
 * </pre>
 */export function invalidValue_number_tooBig(){return AbWebServices.i18n.getMessage("abreact","invalidValue.number.tooBig");}/**
 * <pre>
 * invalidValue.number.tooSmall=Number is too small.
 * </pre>
 */export function invalidValue_number_tooSmall(){return AbWebServices.i18n.getMessage("abreact","invalidValue.number.tooSmall");}/**
 * <pre>
 * locale.default.label=Default (Choose Automatically)
 * </pre>
 */export function locale_default_label(){return AbWebServices.i18n.getMessage("abreact","locale.default.label");}/**
 * <pre>
 * logViewer.filter=Filter...
 * </pre>
 */export function logViewer_filter(){return AbWebServices.i18n.getMessage("abreact","logViewer.filter");}/**
 * <pre>
 * logViewer.filterSummary=Viewing {0} of {1} client log messages.
 * </pre>
 */export function logViewer_filterSummary(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","logViewer.filterSummary",arg0,arg1);}/**
 * <pre>
 * logViewer.level=Level
 * </pre>
 */export function logViewer_level(){return AbWebServices.i18n.getMessage("abreact","logViewer.level");}/**
 * <pre>
 * logViewer.message=Message
 * </pre>
 */export function logViewer_message(){return AbWebServices.i18n.getMessage("abreact","logViewer.message");}/**
 * <pre>
 * logViewer.time=Time
 * </pre>
 */export function logViewer_time(){return AbWebServices.i18n.getMessage("abreact","logViewer.time");}/**
 * <pre>
 * logViewerDialog.closeButtonText=Close
 * </pre>
 */export function logViewerDialog_closeButtonText(){return AbWebServices.i18n.getMessage("abreact","logViewerDialog.closeButtonText");}/**
 * <pre>
 * logViewerDialog.title=Client Log Messages
 * </pre>
 */export function logViewerDialog_title(){return AbWebServices.i18n.getMessage("abreact","logViewerDialog.title");}/**
 * <pre>
 * loginDialog.abInitioLogoAlt=Ab Initio
 * </pre>
 */export function loginDialog_abInitioLogoAlt(){return AbWebServices.i18n.getMessage("abreact","loginDialog.abInitioLogoAlt");}/**
 * <pre>
 * loginDialog.authProgressMessage=Authenticating…
 * </pre>
 */export function loginDialog_authProgressMessage(){return AbWebServices.i18n.getMessage("abreact","loginDialog.authProgressMessage");}/**
 * <pre>
 * loginDialog.customBrandingAlt=Login logo
 * </pre>
 */export function loginDialog_customBrandingAlt(){return AbWebServices.i18n.getMessage("abreact","loginDialog.customBrandingAlt");}/**
 * <pre>
 * loginDialog.logIn=Log In
 * </pre>
 */export function loginDialog_logIn(){return AbWebServices.i18n.getMessage("abreact","loginDialog.logIn");}/**
 * <pre>
 * loginDialog.passwordLabel=Password
 * </pre>
 */export function loginDialog_passwordLabel(){return AbWebServices.i18n.getMessage("abreact","loginDialog.passwordLabel");}/**
 * <pre>
 * loginDialog.unsecuredCredentialsWarning=This http connection is not secure. Credentials entered here could be compromised.
 * </pre>
 */export function loginDialog_unsecuredCredentialsWarning(){return AbWebServices.i18n.getMessage("abreact","loginDialog.unsecuredCredentialsWarning");}/**
 * <pre>
 * loginDialog.usernameLabel=Username
 * </pre>
 */export function loginDialog_usernameLabel(){return AbWebServices.i18n.getMessage("abreact","loginDialog.usernameLabel");}/**
 * <pre>
 * loginHistory.copy.header=START_TIME	END_TIME	DURATION	IP_ADDRESS
 * </pre>
 */export function loginHistory_copy_header(){return AbWebServices.i18n.getMessage("abreact","loginHistory.copy.header");}/**
 * <pre>
 * loginHistory.dialog.button.selectCurrent=Select Current Session
 * </pre>
 */export function loginHistory_dialog_button_selectCurrent(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.button.selectCurrent");}/**
 * <pre>
 * loginHistory.dialog.column.label.DURATION=Duration
 * </pre>
 */export function loginHistory_dialog_column_label_duration(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.column.label.DURATION");}/**
 * <pre>
 * loginHistory.dialog.column.label.LOCATION=Location
 * </pre>
 */export function loginHistory_dialog_column_label_location(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.column.label.LOCATION");}/**
 * <pre>
 * loginHistory.dialog.column.label.LOGIN=Login
 * </pre>
 */export function loginHistory_dialog_column_label_login(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.column.label.LOGIN");}/**
 * <pre>
 * loginHistory.dialog.column.label.LOGOUT=Logout
 * </pre>
 */export function loginHistory_dialog_column_label_logout(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.column.label.LOGOUT");}/**
 * <pre>
 * loginHistory.dialog.historyNotFound=Could not load login history.
 * </pre>
 */export function loginHistory_dialog_historyNotFound(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.historyNotFound");}/**
 * <pre>
 * # The following phrase completes the sentence "(<icon>)..."
 * loginHistory.dialog.legend.concurrent=indicates that a session is concurrent with the selected session.
 * </pre>
 */export function loginHistory_dialog_legend_concurrent(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.legend.concurrent");}/**
 * <pre>
 * loginHistory.dialog.legend.current.bold=bold.
 * </pre>
 */export function loginHistory_dialog_legend_current_bold(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.legend.current.bold");}/**
 * <pre>
 * # The following statement is split into three strings to accommodate programmatic styling.
 * # Any of the separate parts may be left blank depending on style needs.
 * # The ".bold" string is rendered using bold-face glyphs.
 * loginHistory.dialog.legend.current.prefix=The current session is indicated in 
 * </pre>
 */export function loginHistory_dialog_legend_current_prefix(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.legend.current.prefix");}/**
 * <pre>
 * loginHistory.dialog.legend.current.suffix=
 * </pre>
 */export function loginHistory_dialog_legend_current_suffix(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.legend.current.suffix");}/**
 * <pre>
 * loginHistory.dialog.row.label.loggedIn=Logged In
 * </pre>
 */export function loginHistory_dialog_row_label_loggedIn(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.row.label.loggedIn");}/**
 * <pre>
 * loginHistory.dialog.title=Login History
 * </pre>
 */export function loginHistory_dialog_title(){return AbWebServices.i18n.getMessage("abreact","loginHistory.dialog.title");}/**
 * <pre>
 * loginHistory.menu.label=Login history
 * </pre>
 */export function loginHistory_menu_label(){return AbWebServices.i18n.getMessage("abreact","loginHistory.menu.label");}/**
 * <pre>
 * loginPage.portal.title=Login - Ab Initio Data Platform
 * </pre>
 */export function loginPage_portal_title(){return AbWebServices.i18n.getMessage("abreact","loginPage.portal.title");}/**
 * <pre>
 * longtextviewer.view.markup=View Markup
 * </pre>
 */export function longtextviewer_view_markup(){return AbWebServices.i18n.getMessage("abreact","longtextviewer.view.markup");}/**
 * <pre>
 * markdownContent.lineNumbers=Line numbers
 * </pre>
 */export function markdownContent_lineNumbers(){return AbWebServices.i18n.getMessage("abreact","markdownContent.lineNumbers");}/**
 * <pre>
 * markdownContent.softWrap=Soft wrap
 * </pre>
 */export function markdownContent_softWrap(){return AbWebServices.i18n.getMessage("abreact","markdownContent.softWrap");}/**
 * <pre>
 * markdownEditor.backgroundColorButton=Highlight
 * </pre>
 */export function markdownEditor_backgroundColorButton(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.backgroundColorButton");}/**
 * <pre>
 * markdownEditor.backgroundColorMenu=Highlight color
 * </pre>
 */export function markdownEditor_backgroundColorMenu(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.backgroundColorMenu");}/**
 * <pre>
 * markdownEditor.bold=Bold
 * </pre>
 */export function markdownEditor_bold(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.bold");}/**
 * <pre>
 * markdownEditor.browseToUploadImage=Browse to upload image
 * </pre>
 */export function markdownEditor_browseToUploadImage(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.browseToUploadImage");}/**
 * <pre>
 * markdownEditor.colorMenu=Colors
 * </pre>
 */export function markdownEditor_colorMenu(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.colorMenu");}/**
 * <pre>
 * markdownEditor.createImage=Create image
 * </pre>
 */export function markdownEditor_createImage(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.createImage");}/**
 * <pre>
 * markdownEditor.createLink=Create link
 * </pre>
 */export function markdownEditor_createLink(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.createLink");}/**
 * <pre>
 * markdownEditor.defaultSize=Default size
 * </pre>
 */export function markdownEditor_defaultSize(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.defaultSize");}/**
 * <pre>
 * markdownEditor.deleteImage=Delete image
 * </pre>
 */export function markdownEditor_deleteImage(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.deleteImage");}/**
 * <pre>
 * markdownEditor.deleteLink=Delete link
 * </pre>
 */export function markdownEditor_deleteLink(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.deleteLink");}/**
 * <pre>
 * markdownEditor.deletePerson=Delete person
 * </pre>
 */export function markdownEditor_deletePerson(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.deletePerson");}/**
 * <pre>
 * markdownEditor.editImage=Edit image
 * </pre>
 */export function markdownEditor_editImage(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.editImage");}/**
 * <pre>
 * markdownEditor.editImageDialogTitle=Edit Image
 * </pre>
 */export function markdownEditor_editImageDialogTitle(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.editImageDialogTitle");}/**
 * <pre>
 * markdownEditor.editLink=Edit link
 * </pre>
 */export function markdownEditor_editLink(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.editLink");}/**
 * <pre>
 * markdownEditor.editLinkDialogTitle=Edit Link
 * </pre>
 */export function markdownEditor_editLinkDialogTitle(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.editLinkDialogTitle");}/**
 * <pre>
 * markdownEditor.editMarkdown=Edit markdown
 * </pre>
 */export function markdownEditor_editMarkdown(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.editMarkdown");}/**
 * <pre>
 * markdownEditor.editMarkdownDialogTitle=Edit Markdown
 * </pre>
 */export function markdownEditor_editMarkdownDialogTitle(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.editMarkdownDialogTitle");}/**
 * <pre>
 * markdownEditor.fontMenu=Font
 * </pre>
 */export function markdownEditor_fontMenu(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.fontMenu");}/**
 * <pre>
 * markdownEditor.foregroundColorButton=Color
 * </pre>
 */export function markdownEditor_foregroundColorButton(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.foregroundColorButton");}/**
 * <pre>
 * markdownEditor.foregroundColorMenu=Text color
 * </pre>
 */export function markdownEditor_foregroundColorMenu(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.foregroundColorMenu");}/**
 * <pre>
 * markdownEditor.insert=Insert
 * </pre>
 */export function markdownEditor_insert(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.insert");}/**
 * <pre>
 * markdownEditor.italic=Italic
 * </pre>
 */export function markdownEditor_italic(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.italic");}/**
 * <pre>
 * markdownEditor.jumpToTarget=Jump to target
 * </pre>
 */export function markdownEditor_jumpToTarget(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.jumpToTarget");}/**
 * <pre>
 * markdownEditor.linkText=Text
 * </pre>
 */export function markdownEditor_linkText(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.linkText");}/**
 * <pre>
 * markdownEditor.listMenu=Lists
 * </pre>
 */export function markdownEditor_listMenu(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.listMenu");}/**
 * <pre>
 * markdownEditor.monospace=Monospace
 * </pre>
 */export function markdownEditor_monospace(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.monospace");}/**
 * <pre>
 * # used when no matching people in list
 * markdownEditor.noPersonMatches=Can't find that person
 * </pre>
 */export function markdownEditor_noPersonMatches(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.noPersonMatches");}/**
 * <pre>
 * markdownEditor.orderedList=Numbered list
 * </pre>
 */export function markdownEditor_orderedList(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.orderedList");}/**
 * <pre>
 * # tile of pop-out button in floating toolbar
 * markdownEditor.popout=Pop out
 * </pre>
 */export function markdownEditor_popout(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.popout");}/**
 * <pre>
 * # tile of pop-out dialog when you click pop-out button
 * markdownEditor.popoutTitle=Edit Markdown
 * </pre>
 */export function markdownEditor_popoutTitle(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.popoutTitle");}/**
 * <pre>
 * markdownEditor.strikethrough=Strikethrough
 * </pre>
 */export function markdownEditor_strikethrough(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.strikethrough");}/**
 * <pre>
 * # in textarea editor, when you insert an image, you get ![alt text](example.jpg)
 * markdownEditor.textAreaImageTextPlaceholder=alt text
 * </pre>
 */export function markdownEditor_textAreaImageTextPlaceholder(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.textAreaImageTextPlaceholder");}/**
 * <pre>
 * markdownEditor.textAreaImageUrlPlaceholder=example.jpg
 * </pre>
 */export function markdownEditor_textAreaImageUrlPlaceholder(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.textAreaImageUrlPlaceholder");}/**
 * <pre>
 * # in textarea editor, when you insert a link, you get [link text](https://example.com)
 * markdownEditor.textAreaLinkTextPlaceholder=link text
 * </pre>
 */export function markdownEditor_textAreaLinkTextPlaceholder(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.textAreaLinkTextPlaceholder");}/**
 * <pre>
 * markdownEditor.textAreaLinkUrlPlaceholder=https://example.com
 * </pre>
 */export function markdownEditor_textAreaLinkUrlPlaceholder(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.textAreaLinkUrlPlaceholder");}/**
 * <pre>
 * markdownEditor.underline=Underline
 * </pre>
 */export function markdownEditor_underline(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.underline");}/**
 * <pre>
 * markdownEditor.unorderedList=Bulleted list
 * </pre>
 */export function markdownEditor_unorderedList(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.unorderedList");}/**
 * <pre>
 * markdownEditor.url=URL
 * </pre>
 */export function markdownEditor_url(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.url");}/**
 * <pre>
 * markdownEditor.urlIsInvalid=URL is invalid
 * </pre>
 */export function markdownEditor_urlIsInvalid(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.urlIsInvalid");}/**
 * <pre>
 * markdownEditor.urlPlaceholder=Enter URL for image
 * </pre>
 */export function markdownEditor_urlPlaceholder(){return AbWebServices.i18n.getMessage("abreact","markdownEditor.urlPlaceholder");}/**
 * <pre>
 * # {0} is the graph number
 * markdownExtension.ezGraph.defaultTitle=Graph {0}
 * </pre>
 */export function markdownExtension_ezGraph_defaultTitle(arg0){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.defaultTitle",arg0);}/**
 * <pre>
 * markdownExtension.ezGraph.error.ezGraphServiceNotAvailable=Easy>Data service is not available. Please ensure the Easy>Data project is loaded.
 * </pre>
 */export function markdownExtension_ezGraph_error_ezGraphServiceNotAvailable(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.error.ezGraphServiceNotAvailable");}/**
 * <pre>
 * markdownExtension.ezGraph.error.failed=Failed to load Easy>Data Graph
 * </pre>
 */export function markdownExtension_ezGraph_error_failed(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.error.failed");}/**
 * <pre>
 * markdownExtension.ezGraph.error.formattingError=Graph display error: The generated citation contains invalid formatting.
 * </pre>
 */export function markdownExtension_ezGraph_error_formattingError(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.error.formattingError");}/**
 * <pre>
 * markdownExtension.ezGraph.error.unknown=Unknown error occurred
 * </pre>
 */export function markdownExtension_ezGraph_error_unknown(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.error.unknown");}/**
 * <pre>
 * markdownExtension.ezGraph.individualLoading=Loading graph
 * </pre>
 */export function markdownExtension_ezGraph_individualLoading(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.individualLoading");}/**
 * <pre>
 * markdownExtension.ezGraph.loading=Generated graphs are loading
 * </pre>
 */export function markdownExtension_ezGraph_loading(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.loading");}/**
 * <pre>
 * markdownExtension.ezGraph.overallTitle=Generated Graphs
 * </pre>
 */export function markdownExtension_ezGraph_overallTitle(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.ezGraph.overallTitle");}/**
 * <pre>
 * markdownExtension.mpGraph.defaultTitle=MP Graph
 * </pre>
 */export function markdownExtension_mpGraph_defaultTitle(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.mpGraph.defaultTitle");}/**
 * <pre>
 * markdownExtension.mpGraph.multipleGraphsLabel=MP Graphs
 * </pre>
 */export function markdownExtension_mpGraph_multipleGraphsLabel(){return AbWebServices.i18n.getMessage("abreact","markdownExtension.mpGraph.multipleGraphsLabel");}/**
 * <pre>
 * maxLineGridCellRenderer.currentValue=Current value:
 * </pre>
 */export function maxLineGridCellRenderer_currentValue(){return AbWebServices.i18n.getMessage("abreact","maxLineGridCellRenderer.currentValue");}/**
 * <pre>
 * maxLineGridCellRenderer.showLess=Show Less
 * </pre>
 */export function maxLineGridCellRenderer_showLess(){return AbWebServices.i18n.getMessage("abreact","maxLineGridCellRenderer.showLess");}/**
 * <pre>
 * maxLineGridCellRenderer.showMore=Show More
 * </pre>
 */export function maxLineGridCellRenderer_showMore(){return AbWebServices.i18n.getMessage("abreact","maxLineGridCellRenderer.showMore");}/**
 * <pre>
 * # Used in menus. This indicates that the menu is empty.
 * menu.noItems=No menu items
 * </pre>
 */export function menu_noItems(){return AbWebServices.i18n.getMessage("abreact","menu.noItems");}/**
 * <pre>
 * # Text to display in a modal popup while changes are being discarded.
 * message.discarding=Discarding...
 * </pre>
 */export function message_discarding(){return AbWebServices.i18n.getMessage("abreact","message.discarding");}/**
 * <pre>
 * # DEVELOPERS: Please Read the below 6 points below for best practices:
 * #
 * # 1) Add Prefix Header for related resources:
 * #     Each related set of resources should have a common prefix (e.g., 'actionMenu.'), and a commented header section
 * #     that includes: developer/owner for questions, and when possible, a demo url where these resources are displayed.
 * #
 * # 2) The entire set of resources in the file should be sorted:
 * #     this ensures that related resources are adjacent to each other (this helps clarifying the context for the translation team).
 * #
 * # 3) Each prefix header should be separated by an empty line
 * #     so that it does not appear as a comment for the first resource in the sub-area.
 * #
 * # 4) Resource Key Syntax:
 * #     The preferred resource key syntax, which also works well for function names, is using '.' as the primary
 * #     semantic delimiter, and using lower camel case within each major area.   All resource keys MUST be at least
 * #     two-part so that related resources will be co-located when the resource keys are sorted.
 * #     Also - DO NOT CHANGE EXISTING RESOURCE KEYS as that is currently not support by the translation team tools.
 * # Example:   actionMenu.showInfoBubble
 * #
 * # 5) Use Comments to provide additional translation context:
 * #     The translation team's tool displays the comment(s) directly above each resource to the translator.
 * #     As such, it is good practice to use the comments to add any additional context that will be needed by the
 * #     translation team when translating a particular resource (e.g., systematic description of the placeholders,
 * #     where it is used, larger context).
 * #
 * # Example demonstrating 1-5 above: a Prefix Header for 'myFooComponent.' followed by commented resources:
 * #   # 'myFooComponent.' resources: myFooComponent displays the properties of a Foo entity
 * #   # Owner: smalone
 * #   # Trunk Demo Url: http://expressit-dev1.abinitio.com:8080/ace-demo-nightly-main/app/index.html#/workspace/CEP/tag/Latest/rulesets/rpath=%2FProjects%2FCEP%2Fevent-processing-biz%2Frset%2Fbens_test%2Fruleset.rset
 * #
 * #   # Date range
 * #   myFooComponent.daterangeInclusiveBeginLabel=From
 * #   # {0} is the data grid's column label
 * #   myFooComponent.showColumnOnLeft=Show column '{0}' on left
 * #
 * # For more details about how to write effective resources and where comments are most needed, see:
 * #          https://confluence.abinitio.com/display/FED/Effective+String+Resources
 * #
 * # 6) Developers should use *Resources.ts static methods:
 * #     The resources in this bundle will also be used to generate a corresponding <mod>Resources.ts class that has a
 * # static methods for each resource. Developers should use the static methods instead of directly using
 * # the i18n service, as they are strongly typed, provide intellisense lookahead, and support typedoc (cntl-Q).
 * message.loading=Loading...
 * </pre>
 */export function message_loading(){return AbWebServices.i18n.getMessage("abreact","message.loading");}/**
 * <pre>
 * message.pleaseWait=Please Wait...
 * </pre>
 */export function message_pleaseWait(){return AbWebServices.i18n.getMessage("abreact","message.pleaseWait");}/**
 * <pre>
 * # Text to display in a modal popup while changes are being saved.
 * message.saving=Saving...
 * </pre>
 */export function message_saving(){return AbWebServices.i18n.getMessage("abreact","message.saving");}/**
 * <pre>
 * # 'mhObjectDetails.' resources: Metadata Hub object details viewer
 * # Owner: see incubator/ui/component/emms/MhObjectDetailsViewer.tsx
 * mhObjectDetails.dataQualityNotImplemented=Data Quality Not Implemented
 * </pre>
 */export function mhObjectDetails_dataQualityNotImplemented(){return AbWebServices.i18n.getMessage("abreact","mhObjectDetails.dataQualityNotImplemented");}/**
 * <pre>
 * mhObjectDetails.operationalStatisticsNotImplemented=Operational Statistics Not Implemented
 * </pre>
 */export function mhObjectDetails_operationalStatisticsNotImplemented(){return AbWebServices.i18n.getMessage("abreact","mhObjectDetails.operationalStatisticsNotImplemented");}/**
 * <pre>
 * # button for clearing the search grid
 * mhbrowserSearch.clearResults=Clear results
 * </pre>
 */export function mhbrowserSearch_clearResults(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.clearResults");}/**
 * <pre>
 * mhbrowserSearch.columnheadingDetails=Details
 * </pre>
 */export function mhbrowserSearch_columnheadingDetails(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.columnheadingDetails");}/**
 * <pre>
 * # column headings for the search grid
 * mhbrowserSearch.columnheadingName=Name
 * </pre>
 */export function mhbrowserSearch_columnheadingName(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.columnheadingName");}/**
 * <pre>
 * mhbrowserSearch.columnheadingType=Type
 * </pre>
 */export function mhbrowserSearch_columnheadingType(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.columnheadingType");}/**
 * <pre>
 * mhbrowserSearch.foundManyItems=Found {0} items
 * </pre>
 */export function mhbrowserSearch_foundManyItems(arg0){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.foundManyItems",arg0);}/**
 * <pre>
 * mhbrowserSearch.foundOneItem=Found 1 item
 * </pre>
 */export function mhbrowserSearch_foundOneItem(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.foundOneItem");}/**
 * <pre>
 * # status text showing how many items were found
 * mhbrowserSearch.foundZeroItems=Found 0 items
 * </pre>
 */export function mhbrowserSearch_foundZeroItems(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.foundZeroItems");}/**
 * <pre>
 * # default prompt for the search field
 * mhbrowserSearch.searchPrompt=Search...
 * </pre>
 */export function mhbrowserSearch_searchPrompt(){return AbWebServices.i18n.getMessage("abreact","mhbrowserSearch.searchPrompt");}/**
 * <pre>
 * mhhierarchyTree.errorFetchingHierarchy=Error Fetching Hierarchy
 * </pre>
 */export function mhhierarchyTree_errorFetchingHierarchy(){return AbWebServices.i18n.getMessage("abreact","mhhierarchyTree.errorFetchingHierarchy");}/**
 * <pre>
 * mhhierarchyTree.folderNotFound=Folder not found
 * </pre>
 */export function mhhierarchyTree_folderNotFound(){return AbWebServices.i18n.getMessage("abreact","mhhierarchyTree.folderNotFound");}/**
 * <pre>
 * mhobjectPicker.dialogTitle=Metadata Hub Hierarchy Browser
 * </pre>
 */export function mhobjectPicker_dialogTitle(){return AbWebServices.i18n.getMessage("abreact","mhobjectPicker.dialogTitle");}/**
 * <pre>
 * mhobjectViewer.header=Details for selected item:
 * </pre>
 */export function mhobjectViewer_header(){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.header");}/**
 * <pre>
 * mhobjectViewer.noDetails=No details found for item
 * </pre>
 */export function mhobjectViewer_noDetails(){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.noDetails");}/**
 * <pre>
 * mhobjectViewer.noName=no name
 * </pre>
 */export function mhobjectViewer_noName(){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.noName");}/**
 * <pre>
 * mhobjectViewer.nothingSelected=Select an item to view its details.
 * </pre>
 */export function mhobjectViewer_nothingSelected(){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.nothingSelected");}/**
 * <pre>
 * mhobjectViewer.tabBrowse=Browse
 * </pre>
 */export function mhobjectViewer_tabBrowse(){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.tabBrowse");}/**
 * <pre>
 * mhobjectViewer.tabBrowseSpace=Browse {0}
 * </pre>
 */export function mhobjectViewer_tabBrowseSpace(arg0){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.tabBrowseSpace",arg0);}/**
 * <pre>
 * mhobjectViewer.tabSearch=Search
 * </pre>
 */export function mhobjectViewer_tabSearch(){return AbWebServices.i18n.getMessage("abreact","mhobjectViewer.tabSearch");}/**
 * <pre>
 * multipanel.header.collapse=Collapse Section
 * </pre>
 */export function multipanel_header_collapse(){return AbWebServices.i18n.getMessage("abreact","multipanel.header.collapse");}/**
 * <pre>
 * multipanel.header.expand=Expand Section
 * </pre>
 */export function multipanel_header_expand(){return AbWebServices.i18n.getMessage("abreact","multipanel.header.expand");}/**
 * <pre>
 * navigationService.duplicateRoute.detail=Could not add the following routes as they already exist: {0}
 * </pre>
 */export function navigationService_duplicateRoute_detail(arg0){return AbWebServices.i18n.getMessage("abreact","navigationService.duplicateRoute.detail",arg0);}/**
 * <pre>
 * nonboolean.editor.add.condition=+ Add
 * </pre>
 */export function nonboolean_editor_add_condition(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.add.condition");}/**
 * <pre>
 * nonboolean.editor.clear.button=Clear
 * </pre>
 */export function nonboolean_editor_clear_button(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.clear.button");}/**
 * <pre>
 * nonboolean.editor.delete.condition=- Delete
 * </pre>
 */export function nonboolean_editor_delete_condition(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.delete.condition");}/**
 * <pre>
 * nonboolean.editor.else.label=else
 * </pre>
 */export function nonboolean_editor_else_label(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.else.label");}/**
 * <pre>
 * nonboolean.editor.elseIf.label=else if
 * </pre>
 */export function nonboolean_editor_elseIf_label(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.elseIf.label");}/**
 * <pre>
 * nonboolean.editor.if.label=if
 * </pre>
 */export function nonboolean_editor_if_label(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.if.label");}/**
 * <pre>
 * nonboolean.editor.input.required.tooltip=A value is required.
 * </pre>
 */export function nonboolean_editor_input_required_tooltip(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.input.required.tooltip");}/**
 * <pre>
 * nonboolean.editor.then.label=then
 * </pre>
 */export function nonboolean_editor_then_label(){return AbWebServices.i18n.getMessage("abreact","nonboolean.editor.then.label");}/**
 * <pre>
 * notification.hideDetails=Hide Details
 * </pre>
 */export function notification_hideDetails(){return AbWebServices.i18n.getMessage("abreact","notification.hideDetails");}/**
 * <pre>
 * notification.previewNotAvailable=No preview available
 * </pre>
 */export function notification_previewNotAvailable(){return AbWebServices.i18n.getMessage("abreact","notification.previewNotAvailable");}/**
 * <pre>
 * notification.showMore=Show More
 * </pre>
 */export function notification_showMore(){return AbWebServices.i18n.getMessage("abreact","notification.showMore");}/**
 * <pre>
 * notification.viewDetails=View Details
 * </pre>
 */export function notification_viewDetails(){return AbWebServices.i18n.getMessage("abreact","notification.viewDetails");}/**
 * <pre>
 * notificationIndicator.summary.quantity.0=No Notifications
 * </pre>
 */export function notificationIndicator_summary_quantity_0(){return AbWebServices.i18n.getMessage("abreact","notificationIndicator.summary.quantity.0");}/**
 * <pre>
 * # {0} is the severity
 * notificationIndicator.summary.quantity.1=1 {0} Notification
 * </pre>
 */export function notificationIndicator_summary_quantity_1(arg0){return AbWebServices.i18n.getMessage("abreact","notificationIndicator.summary.quantity.1",arg0);}/**
 * <pre>
 * # {0} is the count, {1} is the severity
 * notificationIndicator.summary.quantity.multi={0} {1} Notifications
 * </pre>
 */export function notificationIndicator_summary_quantity_multi(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","notificationIndicator.summary.quantity.multi",arg0,arg1);}/**
 * <pre>
 * notificationIndicatorDialog.detailButton.label=Details
 * </pre>
 */export function notificationIndicatorDialog_detailButton_label(){return AbWebServices.i18n.getMessage("abreact","notificationIndicatorDialog.detailButton.label");}/**
 * <pre>
 * notificationIndicatorDialog.title=Notifications
 * </pre>
 */export function notificationIndicatorDialog_title(){return AbWebServices.i18n.getMessage("abreact","notificationIndicatorDialog.title");}/**
 * <pre>
 * objectDetails.makeSelectionPlaceholder=Make selection to view details
 * </pre>
 */export function objectDetails_makeSelectionPlaceholder(){return AbWebServices.i18n.getMessage("abreact","objectDetails.makeSelectionPlaceholder");}/**
 * <pre>
 * objectPicker.add=Add
 * </pre>
 */export function objectPicker_add(){return AbWebServices.i18n.getMessage("abreact","objectPicker.add");}/**
 * <pre>
 * objectPicker.addAll=Add All
 * </pre>
 */export function objectPicker_addAll(){return AbWebServices.i18n.getMessage("abreact","objectPicker.addAll");}/**
 * <pre>
 * objectPicker.clear=Clear
 * </pre>
 */export function objectPicker_clear(){return AbWebServices.i18n.getMessage("abreact","objectPicker.clear");}/**
 * <pre>
 * objectPicker.clearAll=Clear All
 * </pre>
 */export function objectPicker_clearAll(){return AbWebServices.i18n.getMessage("abreact","objectPicker.clearAll");}/**
 * <pre>
 * objectPicker.defaultBottomFilterPlaceholder=Filter children...
 * </pre>
 */export function objectPicker_defaultBottomFilterPlaceholder(){return AbWebServices.i18n.getMessage("abreact","objectPicker.defaultBottomFilterPlaceholder");}/**
 * <pre>
 * objectPicker.defaultInputLabel=Input Items:
 * </pre>
 */export function objectPicker_defaultInputLabel(){return AbWebServices.i18n.getMessage("abreact","objectPicker.defaultInputLabel");}/**
 * <pre>
 * objectPicker.defaultSelectedItemLabel=Selected Item:
 * </pre>
 */export function objectPicker_defaultSelectedItemLabel(){return AbWebServices.i18n.getMessage("abreact","objectPicker.defaultSelectedItemLabel");}/**
 * <pre>
 * objectPicker.defaultSelectedItemsFilterPlaceholder=Filter...
 * </pre>
 */export function objectPicker_defaultSelectedItemsFilterPlaceholder(){return AbWebServices.i18n.getMessage("abreact","objectPicker.defaultSelectedItemsFilterPlaceholder");}/**
 * <pre>
 * objectPicker.defaultSelectedItemsLabel=Selected Items:
 * </pre>
 */export function objectPicker_defaultSelectedItemsLabel(){return AbWebServices.i18n.getMessage("abreact","objectPicker.defaultSelectedItemsLabel");}/**
 * <pre>
 * objectPicker.defaultTopFilterPlaceholder=Filter...
 * </pre>
 */export function objectPicker_defaultTopFilterPlaceholder(){return AbWebServices.i18n.getMessage("abreact","objectPicker.defaultTopFilterPlaceholder");}/**
 * <pre>
 * objectPicker.maxCountLabel=(Max: {0})
 * </pre>
 */export function objectPicker_maxCountLabel(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.maxCountLabel",arg0);}/**
 * <pre>
 * objectPicker.maximumCount=Maximum: {0}
 * </pre>
 */export function objectPicker_maximumCount(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.maximumCount",arg0);}/**
 * <pre>
 * objectPicker.minCountLabel=(Min: {0})
 * </pre>
 */export function objectPicker_minCountLabel(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.minCountLabel",arg0);}/**
 * <pre>
 * objectPicker.minMaxCountLabel=(Max: {0}, Min: {1})
 * </pre>
 */export function objectPicker_minMaxCountLabel(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","objectPicker.minMaxCountLabel",arg0,arg1);}/**
 * <pre>
 * objectPicker.minimumCount=Minimum: {0}
 * </pre>
 */export function objectPicker_minimumCount(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.minimumCount",arg0);}/**
 * <pre>
 * objectPicker.moveDown=Move Down
 * </pre>
 */export function objectPicker_moveDown(){return AbWebServices.i18n.getMessage("abreact","objectPicker.moveDown");}/**
 * <pre>
 * objectPicker.moveUp=Move Up
 * </pre>
 */export function objectPicker_moveUp(){return AbWebServices.i18n.getMessage("abreact","objectPicker.moveUp");}/**
 * <pre>
 * objectPicker.remove=Remove
 * </pre>
 */export function objectPicker_remove(){return AbWebServices.i18n.getMessage("abreact","objectPicker.remove");}/**
 * <pre>
 * objectPicker.remove.underMinCount=Cannot remove, minimum of {0} items required
 * </pre>
 */export function objectPicker_remove_underMinCount(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.remove.underMinCount",arg0);}/**
 * <pre>
 * objectPicker.removeAll=Remove All
 * </pre>
 */export function objectPicker_removeAll(){return AbWebServices.i18n.getMessage("abreact","objectPicker.removeAll");}/**
 * <pre>
 * objectPicker.replace=Replace
 * </pre>
 */export function objectPicker_replace(){return AbWebServices.i18n.getMessage("abreact","objectPicker.replace");}/**
 * <pre>
 * objectPicker.set=Select
 * </pre>
 */export function objectPicker_set(){return AbWebServices.i18n.getMessage("abreact","objectPicker.set");}/**
 * <pre>
 * objectPicker.showInTree=Show in Tree
 * </pre>
 */export function objectPicker_showInTree(){return AbWebServices.i18n.getMessage("abreact","objectPicker.showInTree");}/**
 * <pre>
 * objectPicker.showInTree.nyi="Show in Tree" is not yet implemented.
 * </pre>
 */export function objectPicker_showInTree_nyi(){return AbWebServices.i18n.getMessage("abreact","objectPicker.showInTree.nyi");}/**
 * <pre>
 * objectPicker.warning.overMaxCount=More than {0} items selected
 * </pre>
 */export function objectPicker_warning_overMaxCount(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.warning.overMaxCount",arg0);}/**
 * <pre>
 * objectPicker.warning.underMinCount=Less than {0} items selected
 * </pre>
 */export function objectPicker_warning_underMinCount(arg0){return AbWebServices.i18n.getMessage("abreact","objectPicker.warning.underMinCount",arg0);}/**
 * <pre>
 * pagedDataModel.rowLabel={0} rows
 * </pre>
 */export function pagedDataModel_rowLabel(arg0){return AbWebServices.i18n.getMessage("abreact","pagedDataModel.rowLabel",arg0);}/**
 * <pre>
 * pagedDataModel.rowRangeLabel={0} to {1}
 * </pre>
 */export function pagedDataModel_rowRangeLabel(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","pagedDataModel.rowRangeLabel",arg0,arg1);}/**
 * <pre>
 * pagedDataModel.rowRangeWithTotalLabel={0} to {1} of {2} rows
 * </pre>
 */export function pagedDataModel_rowRangeWithTotalLabel(arg0,arg1,arg2){return AbWebServices.i18n.getMessage("abreact","pagedDataModel.rowRangeWithTotalLabel",arg0,arg1,arg2);}/**
 * <pre>
 * pagerComponent.fetchingData=Fetching data...
 * </pre>
 */export function pagerComponent_fetchingData(){return AbWebServices.i18n.getMessage("abreact","pagerComponent.fetchingData");}/**
 * <pre>
 * pagerComponent.firstPageTooltip=First page
 * </pre>
 */export function pagerComponent_firstPageTooltip(){return AbWebServices.i18n.getMessage("abreact","pagerComponent.firstPageTooltip");}/**
 * <pre>
 * pagerComponent.lastPageTooltip=Last page
 * </pre>
 */export function pagerComponent_lastPageTooltip(){return AbWebServices.i18n.getMessage("abreact","pagerComponent.lastPageTooltip");}/**
 * <pre>
 * pagerComponent.nextLabel=Next >
 * </pre>
 */export function pagerComponent_nextLabel(){return AbWebServices.i18n.getMessage("abreact","pagerComponent.nextLabel");}/**
 * <pre>
 * pagerComponent.pageSizeLabel=Rows per page:
 * </pre>
 */export function pagerComponent_pageSizeLabel(){return AbWebServices.i18n.getMessage("abreact","pagerComponent.pageSizeLabel");}/**
 * <pre>
 * pagerComponent.previousLabel=< Previous
 * </pre>
 */export function pagerComponent_previousLabel(){return AbWebServices.i18n.getMessage("abreact","pagerComponent.previousLabel");}/**
 * <pre>
 * parameterEditorDlg.addNewButtonTooltip=Add new parameter
 * </pre>
 */export function parameterEditorDlg_addNewButtonTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.addNewButtonTooltip");}/**
 * <pre>
 * parameterEditorDlg.addNewParameterPrompt=Click the <strong>Add new parameter</strong> button above to add a new parameter
 * </pre>
 */export function parameterEditorDlg_addNewParameterPrompt(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.addNewParameterPrompt");}/**
 * <pre>
 * parameterEditorDlg.dropdownDisabledTooltip=Cannot change Data Type on a parameter that is used in the input filter
 * </pre>
 */export function parameterEditorDlg_dropdownDisabledTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.dropdownDisabledTooltip");}/**
 * <pre>
 * parameterEditorDlg.inputFilterLabel=Input Filter
 * </pre>
 */export function parameterEditorDlg_inputFilterLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.inputFilterLabel");}/**
 * <pre>
 * parameterEditorDlg.moveDownButtonTooltip=Move down
 * </pre>
 */export function parameterEditorDlg_moveDownButtonTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.moveDownButtonTooltip");}/**
 * <pre>
 * parameterEditorDlg.moveUpButtonTooltip=Move up
 * </pre>
 */export function parameterEditorDlg_moveUpButtonTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.moveUpButtonTooltip");}/**
 * <pre>
 * parameterEditorDlg.parameterAlwaysPromptLabel=Always prompt for input
 * </pre>
 */export function parameterEditorDlg_parameterAlwaysPromptLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterAlwaysPromptLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterAlwaysPromptTooltip=Always prompt for input, even if a Default Value has been provided.
Normally, if all parameters have Default Values provided, the grid can be shown immediately, without user prompting.
If this is checked, the input parameters form will always be shown, allowing the user to modify the parameter value from its Default Value.
 * </pre>
 */export function parameterEditorDlg_parameterAlwaysPromptTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterAlwaysPromptTooltip");}/**
 * <pre>
 * parameterEditorDlg.parameterDataTypeLabel=Data Type
 * </pre>
 */export function parameterEditorDlg_parameterDataTypeLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterDataTypeLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterDefaultValueLabel=Default Value
 * </pre>
 */export function parameterEditorDlg_parameterDefaultValueLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterDefaultValueLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterIsNotUsedTooltip=Parameter is not used in input filter.
It may be removed.
 * </pre>
 */export function parameterEditorDlg_parameterIsNotUsedTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterIsNotUsedTooltip");}/**
 * <pre>
 * parameterEditorDlg.parameterIsUsedTooltip=Parameter is used in input filter
 * </pre>
 */export function parameterEditorDlg_parameterIsUsedTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterIsUsedTooltip");}/**
 * <pre>
 * parameterEditorDlg.parameterNameLabel=Parameter Name
 * </pre>
 */export function parameterEditorDlg_parameterNameLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterNameLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterOptionalLabel=Make parameter optional
 * </pre>
 */export function parameterEditorDlg_parameterOptionalLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterOptionalLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterPromptTextLabel=Prompt Text
 * </pre>
 */export function parameterEditorDlg_parameterPromptTextLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterPromptTextLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterRuntimeDisplayModeLabel=Runtime Display Mode
 * </pre>
 */export function parameterEditorDlg_parameterRuntimeDisplayModeLabel(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterRuntimeDisplayModeLabel");}/**
 * <pre>
 * parameterEditorDlg.parameterRuntimeDisplayModeTooltip=Determines if and how the input parameter will be rendered at runtime after initial filter execution
 * </pre>
 */export function parameterEditorDlg_parameterRuntimeDisplayModeTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.parameterRuntimeDisplayModeTooltip");}/**
 * <pre>
 * parameterEditorDlg.removeButtonTooltip=Remove parameter
 * </pre>
 */export function parameterEditorDlg_removeButtonTooltip(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.removeButtonTooltip");}/**
 * <pre>
 * parameterEditorDlg.runtimeDisplayModeEditable=Editable
 * </pre>
 */export function parameterEditorDlg_runtimeDisplayModeEditable(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.runtimeDisplayModeEditable");}/**
 * <pre>
 * parameterEditorDlg.runtimeDisplayModeHidden=Hidden
 * </pre>
 */export function parameterEditorDlg_runtimeDisplayModeHidden(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.runtimeDisplayModeHidden");}/**
 * <pre>
 * parameterEditorDlg.runtimeDisplayModeReadonly=Readonly
 * </pre>
 */export function parameterEditorDlg_runtimeDisplayModeReadonly(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.runtimeDisplayModeReadonly");}/**
 * <pre>
 * parameterEditorDlg.title=Input Filter and Parameters
 * </pre>
 */export function parameterEditorDlg_title(){return AbWebServices.i18n.getMessage("abreact","parameterEditorDlg.title");}/**
 * <pre>
 * passwordInput.capsLockIndicator.tooltip=Caps lock is on 
 * </pre>
 */export function passwordInput_capsLockIndicator_tooltip(){return AbWebServices.i18n.getMessage("abreact","passwordInput.capsLockIndicator.tooltip");}/**
 * <pre>
 * passwordInput.changePasswordLabel=Change
 * </pre>
 */export function passwordInput_changePasswordLabel(){return AbWebServices.i18n.getMessage("abreact","passwordInput.changePasswordLabel");}/**
 * <pre>
 * passwordInput.hidePassword=Hide password
 * </pre>
 */export function passwordInput_hidePassword(){return AbWebServices.i18n.getMessage("abreact","passwordInput.hidePassword");}/**
 * <pre>
 * passwordInput.showPassword=Show password
 * </pre>
 */export function passwordInput_showPassword(){return AbWebServices.i18n.getMessage("abreact","passwordInput.showPassword");}/**
 * <pre>
 * picker.addChildren=Add Children
 * </pre>
 */export function picker_addChildren(){return AbWebServices.i18n.getMessage("abreact","picker.addChildren");}/**
 * <pre>
 * picker.addFiltered=Add Filtered
 * </pre>
 */export function picker_addFiltered(){return AbWebServices.i18n.getMessage("abreact","picker.addFiltered");}/**
 * <pre>
 * picker.currentNumberOfItems={0} Picked
 * </pre>
 */export function picker_currentNumberOfItems(arg0){return AbWebServices.i18n.getMessage("abreact","picker.currentNumberOfItems",arg0);}/**
 * <pre>
 * picker.maxCountLabel=Pick At Most {0}
 * </pre>
 */export function picker_maxCountLabel(arg0){return AbWebServices.i18n.getMessage("abreact","picker.maxCountLabel",arg0);}/**
 * <pre>
 * picker.minCountLabel=Pick {0} Or More
 * </pre>
 */export function picker_minCountLabel(arg0){return AbWebServices.i18n.getMessage("abreact","picker.minCountLabel",arg0);}/**
 * <pre>
 * picker.minMaxCountLabel=Pick Between {0} and {1}
 * </pre>
 */export function picker_minMaxCountLabel(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","picker.minMaxCountLabel",arg0,arg1);}/**
 * <pre>
 * picker.noData=No data
 * </pre>
 */export function picker_noData(){return AbWebServices.i18n.getMessage("abreact","picker.noData");}/**
 * <pre>
 * picker.pickExactly=Pick Exactly {0}
 * </pre>
 */export function picker_pickExactly(arg0){return AbWebServices.i18n.getMessage("abreact","picker.pickExactly",arg0);}/**
 * <pre>
 * picker.removeFiltered=Remove Filtered
 * </pre>
 */export function picker_removeFiltered(){return AbWebServices.i18n.getMessage("abreact","picker.removeFiltered");}/**
 * <pre>
 * popup_header.close.tooltip=Close
 * </pre>
 */export function popupHeader_close_tooltip(){return AbWebServices.i18n.getMessage("abreact","popup_header.close.tooltip");}/**
 * <pre>
 * popup_header.maximize.tooltip=Maximize
 * </pre>
 */export function popupHeader_maximize_tooltip(){return AbWebServices.i18n.getMessage("abreact","popup_header.maximize.tooltip");}/**
 * <pre>
 * popup_header.minimize.tooltip=Restore Down
 * </pre>
 */export function popupHeader_minimize_tooltip(){return AbWebServices.i18n.getMessage("abreact","popup_header.minimize.tooltip");}/**
 * <pre>
 * # Accessible name for primary navigation landmark (left sidebar)
 * portalPrimaryNavigation.name=Primary
 * </pre>
 */export function portalPrimaryNavigation_name(){return AbWebServices.i18n.getMessage("abreact","portalPrimaryNavigation.name");}/**
 * <pre>
 * # Accessible name to distinguish between when the top nav bar
 * # shows breadcrumb navigation instead of a list of subspace links
 * portalSecondaryNavigation.breadcrumbsLabel=Breadcrumbs
 * </pre>
 */export function portalSecondaryNavigation_breadcrumbsLabel(){return AbWebServices.i18n.getMessage("abreact","portalSecondaryNavigation.breadcrumbsLabel");}/**
 * <pre>
 * # Name for home link at the top of portal side navigation
 * portalSideNav.home.link.name={0} Home
 * </pre>
 */export function portalSideNav_home_link_name(arg0){return AbWebServices.i18n.getMessage("abreact","portalSideNav.home.link.name",arg0);}/**
 * <pre>
 * postLoginAppLoader.bridgeUnavailable.message=The Ab Initio Data Platform is not able to connect to the bridge process. Please contact your administrator.
 * </pre>
 */export function postLoginAppLoader_bridgeUnavailable_message(){return AbWebServices.i18n.getMessage("abreact","postLoginAppLoader.bridgeUnavailable.message");}/**
 * <pre>
 * postLoginAppLoader.bridgeUnavailable.title=Bridge Connection Failure
 * </pre>
 */export function postLoginAppLoader_bridgeUnavailable_title(){return AbWebServices.i18n.getMessage("abreact","postLoginAppLoader.bridgeUnavailable.title");}/**
 * <pre>
 * postLoginAppLoader.unavailableServer.body=Try refreshing your browser or contact your administrator
 * </pre>
 */export function postLoginAppLoader_unavailableServer_body(){return AbWebServices.i18n.getMessage("abreact","postLoginAppLoader.unavailableServer.body");}/**
 * <pre>
 * postLoginAppLoader.unavailableServer.title=Server Unavailable
 * </pre>
 */export function postLoginAppLoader_unavailableServer_title(){return AbWebServices.i18n.getMessage("abreact","postLoginAppLoader.unavailableServer.title");}/**
 * <pre>
 * printButton.label=Print
 * </pre>
 */export function printButton_label(){return AbWebServices.i18n.getMessage("abreact","printButton.label");}/**
 * <pre>
 * printPreview.buildingPDF=Building your PDF...
 * </pre>
 */export function printPreview_buildingPDF(){return AbWebServices.i18n.getMessage("abreact","printPreview.buildingPDF");}/**
 * <pre>
 * printPreview.defaultFilename=document
 * </pre>
 */export function printPreview_defaultFilename(){return AbWebServices.i18n.getMessage("abreact","printPreview.defaultFilename");}/**
 * <pre>
 * printPreview.diagram.preparingPreview=Preparing preview
 * </pre>
 */export function printPreview_diagram_preparingPreview(){return AbWebServices.i18n.getMessage("abreact","printPreview.diagram.preparingPreview");}/**
 * <pre>
 * printPreview.legendPanel.title=Legend
 * </pre>
 */export function printPreview_legendPanel_title(){return AbWebServices.i18n.getMessage("abreact","printPreview.legendPanel.title");}/**
 * <pre>
 * printPreview.orientationLabel=Orientation:
 * </pre>
 */export function printPreview_orientationLabel(){return AbWebServices.i18n.getMessage("abreact","printPreview.orientationLabel");}/**
 * <pre>
 * printPreview.orientationLandscape=Landscape
 * </pre>
 */export function printPreview_orientationLandscape(){return AbWebServices.i18n.getMessage("abreact","printPreview.orientationLandscape");}/**
 * <pre>
 * printPreview.orientationPortrait=Portrait
 * </pre>
 */export function printPreview_orientationPortrait(){return AbWebServices.i18n.getMessage("abreact","printPreview.orientationPortrait");}/**
 * <pre>
 * printPreview.orientationTooltip=Select a page orientation
 * </pre>
 */export function printPreview_orientationTooltip(){return AbWebServices.i18n.getMessage("abreact","printPreview.orientationTooltip");}/**
 * <pre>
 * #0 - page number
 * printPreview.page=Page {0}
 * </pre>
 */export function printPreview_page(arg0){return AbWebServices.i18n.getMessage("abreact","printPreview.page",arg0);}/**
 * <pre>
 * #0 - page number of {1} page total
 * printPreview.page.of.pages=Page {0} of {1}
 * </pre>
 */export function printPreview_page_of_pages(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","printPreview.page.of.pages",arg0,arg1);}/**
 * <pre>
 * printPreview.paperSizeA0=A0
 * </pre>
 */export function printPreview_paperSizeA0(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA0");}/**
 * <pre>
 * printPreview.paperSizeA1=A1
 * </pre>
 */export function printPreview_paperSizeA1(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA1");}/**
 * <pre>
 * printPreview.paperSizeA2=A2
 * </pre>
 */export function printPreview_paperSizeA2(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA2");}/**
 * <pre>
 * printPreview.paperSizeA3=A3
 * </pre>
 */export function printPreview_paperSizeA3(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA3");}/**
 * <pre>
 * printPreview.paperSizeA4=A4
 * </pre>
 */export function printPreview_paperSizeA4(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA4");}/**
 * <pre>
 * printPreview.paperSizeA5=A5
 * </pre>
 */export function printPreview_paperSizeA5(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA5");}/**
 * <pre>
 * printPreview.paperSizeA6=A6
 * </pre>
 */export function printPreview_paperSizeA6(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeA6");}/**
 * <pre>
 * printPreview.paperSizeExecutive=Executive
 * </pre>
 */export function printPreview_paperSizeExecutive(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeExecutive");}/**
 * <pre>
 * printPreview.paperSizeFolio=Folio
 * </pre>
 */export function printPreview_paperSizeFolio(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeFolio");}/**
 * <pre>
 * printPreview.paperSizeLabel=Paper Size:
 * </pre>
 */export function printPreview_paperSizeLabel(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeLabel");}/**
 * <pre>
 * printPreview.paperSizeLegal=Legal
 * </pre>
 */export function printPreview_paperSizeLegal(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeLegal");}/**
 * <pre>
 * printPreview.paperSizeLetter=Letter
 * </pre>
 */export function printPreview_paperSizeLetter(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeLetter");}/**
 * <pre>
 * printPreview.paperSizeTabloid=Tabloid
 * </pre>
 */export function printPreview_paperSizeTabloid(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeTabloid");}/**
 * <pre>
 * printPreview.paperSizeTooltip=Select a paper size
 * </pre>
 */export function printPreview_paperSizeTooltip(){return AbWebServices.i18n.getMessage("abreact","printPreview.paperSizeTooltip");}/**
 * <pre>
 * printPreview.printPreviewDialog=Print Preview Dialog
 * </pre>
 */export function printPreview_printPreviewDialog(){return AbWebServices.i18n.getMessage("abreact","printPreview.printPreviewDialog");}/**
 * <pre>
 * printPreview.saveAsPDF=Save as PDF
 * </pre>
 */export function printPreview_saveAsPDF(){return AbWebServices.i18n.getMessage("abreact","printPreview.saveAsPDF");}/**
 * <pre>
 * printPreview.saveAsSVG=Save as SVG
 * </pre>
 */export function printPreview_saveAsSVG(){return AbWebServices.i18n.getMessage("abreact","printPreview.saveAsSVG");}/**
 * <pre>
 * #0 - as of date
 * printPreview.version.date=Version as of {0}
 * </pre>
 */export function printPreview_version_date(arg0){return AbWebServices.i18n.getMessage("abreact","printPreview.version.date",arg0);}/**
 * <pre>
 * profileStatsViewer.accessGrp=Access Time
 * </pre>
 */export function profileStatsViewer_accessGrp(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.accessGrp");}/**
 * <pre>
 * profileStatsViewer.activeGrp=Active
 * </pre>
 */export function profileStatsViewer_activeGrp(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.activeGrp");}/**
 * <pre>
 * profileStatsViewer.avgActive=Avg
 * </pre>
 */export function profileStatsViewer_avgActive(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.avgActive");}/**
 * <pre>
 * profileStatsViewer.avgValue=Avg
 * </pre>
 */export function profileStatsViewer_avgValue(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.avgValue");}/**
 * <pre>
 * profileStatsViewer.filter=Filter...
 * </pre>
 */export function profileStatsViewer_filter(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.filter");}/**
 * <pre>
 * profileStatsViewer.filterSummary=Viewing {0} of {1} client profilingInProgress statistics.
 * </pre>
 */export function profileStatsViewer_filterSummary(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.filterSummary",arg0,arg1);}/**
 * <pre>
 * profileStatsViewer.firstAccess=First
 * </pre>
 */export function profileStatsViewer_firstAccess(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.firstAccess");}/**
 * <pre>
 * profileStatsViewer.label=Label
 * </pre>
 */export function profileStatsViewer_label(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.label");}/**
 * <pre>
 * profileStatsViewer.lastAccess=Last
 * </pre>
 */export function profileStatsViewer_lastAccess(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.lastAccess");}/**
 * <pre>
 * profileStatsViewer.lastValue=Last
 * </pre>
 */export function profileStatsViewer_lastValue(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.lastValue");}/**
 * <pre>
 * profileStatsViewer.maxActive=Max
 * </pre>
 */export function profileStatsViewer_maxActive(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.maxActive");}/**
 * <pre>
 * profileStatsViewer.maxValue=Max
 * </pre>
 */export function profileStatsViewer_maxValue(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.maxValue");}/**
 * <pre>
 * profileStatsViewer.minValue=Min
 * </pre>
 */export function profileStatsViewer_minValue(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.minValue");}/**
 * <pre>
 * profileStatsViewer.numActive=Current
 * </pre>
 */export function profileStatsViewer_numActive(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.numActive");}/**
 * <pre>
 * profileStatsViewer.stdDevValue=StdDev
 * </pre>
 */export function profileStatsViewer_stdDevValue(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.stdDevValue");}/**
 * <pre>
 * profileStatsViewer.totalValue=Total
 * </pre>
 */export function profileStatsViewer_totalValue(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.totalValue");}/**
 * <pre>
 * profileStatsViewer.valueGrp=Value
 * </pre>
 */export function profileStatsViewer_valueGrp(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.valueGrp");}/**
 * <pre>
 * profileStatsViewer.valueHits=Hits
 * </pre>
 */export function profileStatsViewer_valueHits(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewer.valueHits");}/**
 * <pre>
 * profileStatsViewerDialog.closeButtonText=Close
 * </pre>
 */export function profileStatsViewerDialog_closeButtonText(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewerDialog.closeButtonText");}/**
 * <pre>
 * profileStatsViewerDialog.title=Client Profiling Statistics
 * </pre>
 */export function profileStatsViewerDialog_title(){return AbWebServices.i18n.getMessage("abreact","profileStatsViewerDialog.title");}/**
 * <pre>
 * # This message is only shown to screen readers when the progress dialog is showing on-screen.
 * progressManager.ariaLabel=In Progress
 * </pre>
 */export function progressManager_ariaLabel(){return AbWebServices.i18n.getMessage("abreact","progressManager.ariaLabel");}/**
 * <pre>
 * progressManager.cancelling=Cancelling...
 * </pre>
 */export function progressManager_cancelling(){return AbWebServices.i18n.getMessage("abreact","progressManager.cancelling");}/**
 * <pre>
 * progressManager.elapsedTime=Elapsed Time: {0}
 * </pre>
 */export function progressManager_elapsedTime(arg0){return AbWebServices.i18n.getMessage("abreact","progressManager.elapsedTime",arg0);}/**
 * <pre>
 * property.previousValueTooltip.label=Previous value
 * </pre>
 */export function property_previousValueTooltip_label(){return AbWebServices.i18n.getMessage("abreact","property.previousValueTooltip.label");}/**
 * <pre>
 * property.textPropertyInput.whitespaceWarning=Warning: This value contains leading or trailing whitespace.
 * </pre>
 */export function property_textPropertyInput_whitespaceWarning(){return AbWebServices.i18n.getMessage("abreact","property.textPropertyInput.whitespaceWarning");}/**
 * <pre>
 * quickFilterButton.tooltip=Add quick filter on selected cell value (Ctrl+Q)
 * </pre>
 */export function quickFilterButton_tooltip(){return AbWebServices.i18n.getMessage("abreact","quickFilterButton.tooltip");}/**
 * <pre>
 * remoteError.code=Code:
 * </pre>
 */export function remoteError_code(){return AbWebServices.i18n.getMessage("abreact","remoteError.code");}/**
 * <pre>
 * remoteError.message=Remote Message:
 * </pre>
 */export function remoteError_message(){return AbWebServices.i18n.getMessage("abreact","remoteError.message");}/**
 * <pre>
 * remoteError.messageArgs=Arguments:
 * </pre>
 */export function remoteError_messageArgs(){return AbWebServices.i18n.getMessage("abreact","remoteError.messageArgs");}/**
 * <pre>
 * reparentRowsDlg.appendAsChildRows=Append as child rows
 * </pre>
 */export function reparentRowsDlg_appendAsChildRows(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.appendAsChildRows");}/**
 * <pre>
 * reparentRowsDlg.insertRows=Insert rows
 * </pre>
 */export function reparentRowsDlg_insertRows(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.insertRows");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNoDescendant=You cannot select a descendant of one of the highlighted rows as the new parent
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNoDescendant(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNoDescendant");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNoDescendant2=You cannot select a descendant of one of the highlighted rows as the insertion point
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNoDescendant2(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNoDescendant2");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNoHighlightedRow=You cannot select one of the highlighted rows as the new parent
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNoHighlightedRow(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNoHighlightedRow");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNoHighlightedRow2=You cannot select one of the highlighted rows as the insertion point
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNoHighlightedRow2(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNoHighlightedRow2");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNoSelection=Nothing selected
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNoSelection(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNoSelection");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNotParent=The parent of the highlighted rows cannot be the new parent
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNotParent(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNotParent");}/**
 * <pre>
 * reparentRowsDlg.okButtonTooltipNotSibling=A sibling of the highlighted rows cannot be the insertion point
 * </pre>
 */export function reparentRowsDlg_okButtonTooltipNotSibling(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.okButtonTooltipNotSibling");}/**
 * <pre>
 * reparentRowsDlg.radioGroupLabel=Select a row in the grid to be the parent or insertion point
 * </pre>
 */export function reparentRowsDlg_radioGroupLabel(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.radioGroupLabel");}/**
 * <pre>
 * reparentRowsDlg.title=Move Rows
 * </pre>
 */export function reparentRowsDlg_title(){return AbWebServices.i18n.getMessage("abreact","reparentRowsDlg.title");}/**
 * <pre>
 * resetPasswordDialog.confirmPasswordFieldLabel=Confirm Password
 * </pre>
 */export function resetPasswordDialog_confirmPasswordFieldLabel(){return AbWebServices.i18n.getMessage("abreact","resetPasswordDialog.confirmPasswordFieldLabel");}/**
 * <pre>
 * resetPasswordDialog.confirmPasswordFieldLabelWithOldPassword=Confirm New Password
 * </pre>
 */export function resetPasswordDialog_confirmPasswordFieldLabelWithOldPassword(){return AbWebServices.i18n.getMessage("abreact","resetPasswordDialog.confirmPasswordFieldLabelWithOldPassword");}/**
 * <pre>
 * resetPasswordDialog.oldPasswordFieldLabel=Current Password
 * </pre>
 */export function resetPasswordDialog_oldPasswordFieldLabel(){return AbWebServices.i18n.getMessage("abreact","resetPasswordDialog.oldPasswordFieldLabel");}/**
 * <pre>
 * resetPasswordDialog.passwordFieldLabel=Password
 * </pre>
 */export function resetPasswordDialog_passwordFieldLabel(){return AbWebServices.i18n.getMessage("abreact","resetPasswordDialog.passwordFieldLabel");}/**
 * <pre>
 * resetPasswordDialog.passwordFieldLabelWithOldPassword=New Password
 * </pre>
 */export function resetPasswordDialog_passwordFieldLabelWithOldPassword(){return AbWebServices.i18n.getMessage("abreact","resetPasswordDialog.passwordFieldLabelWithOldPassword");}/**
 * <pre>
 * resetPasswordDialog.passwordsDoNotMatchErrorMessage=Passwords do not match. Please try again.
 * </pre>
 */export function resetPasswordDialog_passwordsDoNotMatchErrorMessage(){return AbWebServices.i18n.getMessage("abreact","resetPasswordDialog.passwordsDoNotMatchErrorMessage");}/**
 * <pre>
 * routeRegistry.duplicateRoute.detail=Could not register the following route as it has already been registered: {0}
 * </pre>
 */export function routeRegistry_duplicateRoute_detail(arg0){return AbWebServices.i18n.getMessage("abreact","routeRegistry.duplicateRoute.detail",arg0);}/**
 * <pre>
 * secretInput.changeSecretLabel=Change
 * </pre>
 */export function secretInput_changeSecretLabel(){return AbWebServices.i18n.getMessage("abreact","secretInput.changeSecretLabel");}/**
 * <pre>
 * #{0} is count of ratings, {1} is total ratings, {2} is percentage.
 * starBarComponent.rating.bar.chart.title={0} of {1} ({2}%) have a value
 * </pre>
 */export function starBarComponent_rating_bar_chart_title(arg0,arg1,arg2){return AbWebServices.i18n.getMessage("abreact","starBarComponent.rating.bar.chart.title",arg0,arg1,arg2);}/**
 * <pre>
 * # {0} is the text displayed on the tab. It is the tab that will be closed. This is the aria-label for screen
 * # readers, so it should be short.
 * tabControl.closeTab.button.ariaLabel=Close {0}
 * </pre>
 */export function tabControl_closeTab_button_ariaLabel(arg0){return AbWebServices.i18n.getMessage("abreact","tabControl.closeTab.button.ariaLabel",arg0);}/**
 * <pre>
 * tabControl.openTab=Open
 * </pre>
 */export function tabControl_openTab(){return AbWebServices.i18n.getMessage("abreact","tabControl.openTab");}/**
 * <pre>
 * tabbedSidePopup.openInMainView=Open in Main View
 * </pre>
 */export function tabbedSidePopup_openInMainView(){return AbWebServices.i18n.getMessage("abreact","tabbedSidePopup.openInMainView");}/**
 * <pre>
 * textFilterInput.clearFilter=Clear text filter
 * </pre>
 */export function textFilterInput_clearFilter(){return AbWebServices.i18n.getMessage("abreact","textFilterInput.clearFilter");}/**
 * <pre>
 * textFilterInput.placeholder=Text filter
 * </pre>
 */export function textFilterInput_placeholder(){return AbWebServices.i18n.getMessage("abreact","textFilterInput.placeholder");}/**
 * <pre>
 * textFilterInput.tooltip=Filter rows that contain this text
 * </pre>
 */export function textFilterInput_tooltip(){return AbWebServices.i18n.getMessage("abreact","textFilterInput.tooltip");}/**
 * <pre>
 * themePicker.chooseTheme=Choose theme
 * </pre>
 */export function themePicker_chooseTheme(){return AbWebServices.i18n.getMessage("abreact","themePicker.chooseTheme");}/**
 * <pre>
 * theming.classicThemeDisplayName=Ab Initio Classic Theme
 * </pre>
 */export function theming_classicThemeDisplayName(){return AbWebServices.i18n.getMessage("abreact","theming.classicThemeDisplayName");}/**
 * <pre>
 * theming.darkThemeDisplayName=Ab Initio Dark Theme
 * </pre>
 */export function theming_darkThemeDisplayName(){return AbWebServices.i18n.getMessage("abreact","theming.darkThemeDisplayName");}/**
 * <pre>
 * theming.lightThemeDisplayName=Ab Initio Light Theme
 * </pre>
 */export function theming_lightThemeDisplayName(){return AbWebServices.i18n.getMessage("abreact","theming.lightThemeDisplayName");}/**
 * <pre>
 * timeInput.error.invalidFormat=Invalid time format.
Please match format of {0}
 * </pre>
 */export function timeInput_error_invalidFormat(arg0){return AbWebServices.i18n.getMessage("abreact","timeInput.error.invalidFormat",arg0);}/**
 * <pre>
 * timeInput.error.outOfRange=Time out of range.
Must be between {0} and {1}.
 * </pre>
 */export function timeInput_error_outOfRange(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","timeInput.error.outOfRange",arg0,arg1);}/**
 * <pre>
 * timeInput.placeholder=Enter a time
 * </pre>
 */export function timeInput_placeholder(){return AbWebServices.i18n.getMessage("abreact","timeInput.placeholder");}/**
 * <pre>
 * topLeftCheckboxRenderer.label=Check/uncheck all
 * </pre>
 */export function topLeftCheckboxRenderer_label(){return AbWebServices.i18n.getMessage("abreact","topLeftCheckboxRenderer.label");}/**
 * <pre>
 * # 'translatorTools.' resources: Translator tools dialog
 * # Owner: see incubator/ui/translatorTools/TranslatorToolsDialog.tsx
 * translatorTools.translationOptions=Translation options:
 * </pre>
 */export function translatorTools_translationOptions(){return AbWebServices.i18n.getMessage("abreact","translatorTools.translationOptions");}/**
 * <pre>
 * tree.clear_all_children=Clear all children
 * </pre>
 */export function tree_clearAllChildren(){return AbWebServices.i18n.getMessage("abreact","tree.clear_all_children");}/**
 * <pre>
 * tree.select_all_children=Select all children
 * </pre>
 */export function tree_selectAllChildren(){return AbWebServices.i18n.getMessage("abreact","tree.select_all_children");}/**
 * <pre>
 * tristate_tree.clear=Clear selection
 * </pre>
 */export function tristateTree_clear(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.clear");}/**
 * <pre>
 * tristate_tree.collapse_all=Collapse all
 * </pre>
 */export function tristateTree_collapseAll(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.collapse_all");}/**
 * <pre>
 * tristate_tree.collapse_all_below=Collapse all below
 * </pre>
 */export function tristateTree_collapseAllBelow(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.collapse_all_below");}/**
 * <pre>
 * tristate_tree.expand_all=Expand all
 * </pre>
 */export function tristateTree_expandAll(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.expand_all");}/**
 * <pre>
 * tristate_tree.expand_all_below=Expand all below
 * </pre>
 */export function tristateTree_expandAllBelow(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.expand_all_below");}/**
 * <pre>
 * tristate_tree.select_all_below=Select all below
 * </pre>
 */export function tristateTree_selectAllBelow(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.select_all_below");}/**
 * <pre>
 * tristate_tree.select_children=Select children
 * </pre>
 */export function tristateTree_selectChildren(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.select_children");}/**
 * <pre>
 * tristate_tree.unselect_all_below=Deselect all below
 * </pre>
 */export function tristateTree_unselectAllBelow(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.unselect_all_below");}/**
 * <pre>
 * tristate_tree.unselect_children=Deselect children
 * </pre>
 */export function tristateTree_unselectChildren(){return AbWebServices.i18n.getMessage("abreact","tristate_tree.unselect_children");}/**
 * <pre>
 * #{0} is the unauthorized route
 * unauthorizedRoute.routeTitle=Unauthorized Route: {0}
 * </pre>
 */export function unauthorizedRoute_routeTitle(arg0){return AbWebServices.i18n.getMessage("abreact","unauthorizedRoute.routeTitle",arg0);}/**
 * <pre>
 * #{0} is the unauthorized route
 * unauthorizedRouteView.message=You do not have permission to access this page. Please contact your administrator.
 * </pre>
 */export function unauthorizedRouteView_message(){return AbWebServices.i18n.getMessage("abreact","unauthorizedRouteView.message");}/**
 * <pre>
 * unauthorizedRouteView.title=Access Denied
 * </pre>
 */export function unauthorizedRouteView_title(){return AbWebServices.i18n.getMessage("abreact","unauthorizedRouteView.title");}/**
 * <pre>
 * #{0} is the invalid route
 * unknownRoute.routeTitle=Unknown Page: {0}
 * </pre>
 */export function unknownRoute_routeTitle(arg0){return AbWebServices.i18n.getMessage("abreact","unknownRoute.routeTitle",arg0);}/**
 * <pre>
 * unknownRouteView.bodyLabel=Go to Home
 * </pre>
 */export function unknownRouteView_bodyLabel(){return AbWebServices.i18n.getMessage("abreact","unknownRouteView.bodyLabel");}/**
 * <pre>
 * #{0} is the invalid route
 * unknownRouteView.message=The requested page cannot be found. Please check the URL or go to another page.
 * </pre>
 */export function unknownRouteView_message(){return AbWebServices.i18n.getMessage("abreact","unknownRouteView.message");}/**
 * <pre>
 * unknownRouteView.title=Invalid URL
 * </pre>
 */export function unknownRouteView_title(){return AbWebServices.i18n.getMessage("abreact","unknownRouteView.title");}/**
 * <pre>
 * unsavedChangesHandler.discardError=An error occurred while discarding changes.
 * </pre>
 */export function unsavedChangesHandler_discardError(){return AbWebServices.i18n.getMessage("abreact","unsavedChangesHandler.discardError");}/**
 * <pre>
 * unsavedChangesHandler.saveError=An error occurred while saving changes.
 * </pre>
 */export function unsavedChangesHandler_saveError(){return AbWebServices.i18n.getMessage("abreact","unsavedChangesHandler.saveError");}/**
 * <pre>
 * userMenu.changePassword=Change password
 * </pre>
 */export function userMenu_changePassword(){return AbWebServices.i18n.getMessage("abreact","userMenu.changePassword");}/**
 * <pre>
 * userMenu.logOut=Log out
 * </pre>
 */export function userMenu_logOut(){return AbWebServices.i18n.getMessage("abreact","userMenu.logOut");}/**
 * <pre>
 * userSetting.colorScheme.darkMode=Dark mode
 * </pre>
 */export function userSetting_colorScheme_darkMode(){return AbWebServices.i18n.getMessage("abreact","userSetting.colorScheme.darkMode");}/**
 * <pre>
 * userSetting.colorScheme.displayName=Color scheme
 * </pre>
 */export function userSetting_colorScheme_displayName(){return AbWebServices.i18n.getMessage("abreact","userSetting.colorScheme.displayName");}/**
 * <pre>
 * userSetting.colorScheme.lightMode=Light mode
 * </pre>
 */export function userSetting_colorScheme_lightMode(){return AbWebServices.i18n.getMessage("abreact","userSetting.colorScheme.lightMode");}/**
 * <pre>
 * userSetting.language.displayName=Language
 * </pre>
 */export function userSetting_language_displayName(){return AbWebServices.i18n.getMessage("abreact","userSetting.language.displayName");}/**
 * <pre>
 * userSetting.textSize.displayName=Text size
 * </pre>
 */export function userSetting_textSize_displayName(){return AbWebServices.i18n.getMessage("abreact","userSetting.textSize.displayName");}/**
 * <pre>
 * userSetting.textSize.larger=Larger
 * </pre>
 */export function userSetting_textSize_larger(){return AbWebServices.i18n.getMessage("abreact","userSetting.textSize.larger");}/**
 * <pre>
 * userSetting.textSize.smaller=Smaller
 * </pre>
 */export function userSetting_textSize_smaller(){return AbWebServices.i18n.getMessage("abreact","userSetting.textSize.smaller");}/**
 * <pre>
 * userSetting.unset=Unset
 * </pre>
 */export function userSetting_unset(){return AbWebServices.i18n.getMessage("abreact","userSetting.unset");}/**
 * <pre>
 * view.contents=View contents
 * </pre>
 */export function view_contents(){return AbWebServices.i18n.getMessage("abreact","view.contents");}/**
 * <pre>
 * # Label for button to submit at the end of a wizard
 * wizard.buttons.finish.label=Finish
 * </pre>
 */export function wizard_buttons_finish_label(){return AbWebServices.i18n.getMessage("abreact","wizard.buttons.finish.label");}/**
 * <pre>
 * wizard.buttons.nextStep.label=Next
 * </pre>
 */export function wizard_buttons_nextStep_label(){return AbWebServices.i18n.getMessage("abreact","wizard.buttons.nextStep.label");}/**
 * <pre>
 * # Labels to go to previous step or next step in a wizard
 * wizard.buttons.previousStep.label=Previous
 * </pre>
 */export function wizard_buttons_previousStep_label(){return AbWebServices.i18n.getMessage("abreact","wizard.buttons.previousStep.label");}/**
 * <pre>
 * wizard.error.illegalCurrentPage=not a page in this wizard model
 * </pre>
 */export function wizard_error_illegalCurrentPage(){return AbWebServices.i18n.getMessage("abreact","wizard.error.illegalCurrentPage");}/**
 * <pre>
 * # {0} is the current step (starts with 1). {1} is the total number of steps. Followed by title of step.
 * wizard.subtitle.stepCounter={0} of {1}
 * </pre>
 */export function wizard_subtitle_stepCounter(arg0,arg1){return AbWebServices.i18n.getMessage("abreact","wizard.subtitle.stepCounter",arg0,arg1);}
//# sourceMappingURL=AbReactResources.js.map
